// @generated by protobuf-ts 2.11.1 with parameter long_type_string
// @generated from protobuf file "audio_message.proto" (package "pb", syntax proto3)
// tslint:disable
//
// protoc -I=model/proto --python_out=protoc model/proto/audio_message.proto
// protoc -I=model/proto --cpp_out=protoc model/proto/audio_message.proto
//
// (see webapps/pixels/package.json)
// protoc --ts_opt long_type_string --ts_out=webapps/pixels/src/generated --proto_path model/proto audio_message.proto
//
//
// option cc_generic_services = true;
// option java_generic_services = true;
// option py_generic_services = true;
//
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// 
// AudioMessage is the single message type that contains all information passed
// between client and server. It contains much more than just Audio (and often
// contains no audio at all).
// 
// unlikely TODO: rename 'PersonaMessage' or something generic. agavin notes this would be a lot of renaming.
// 
// Every AudioMessage contains a 'header' consisting of blocking grouping and sequencing info and a 'Type'.
// The Type determines which of the various optional blocks are allowed. And most specifically, determines
// which oneof the "info" block is allowed (client, server, connect)
// 
// TODO: should every audio message contain a timestamp? In the past, when creating
// messaging protocols, I've always discovered a use for this.
// 
// If the Type is CLIENT_ASK_TO_CONNECT, which is the first message sent from client
// to server, then the message will contain a ConnectInfo, which describes capabilities
// and values of the client.
// 
// If the Type is SERVER_CONNECT_INFO, which is the first message sent from server
// to client (in response to a CLIENT_ASK_TO_CONNECT), then the message will contain
// a ConnectInfo, describing whether the client can proceed.
// 
// If the Type is CLIENT_TO_SERVER, then the message will contain a ClientInfo,
// and possibly an Audio, and possibly a list of Commands.
// 
// The ClientInfo structure describes the current state of the client (the microphone is
// on, the user is currently typing, the avatar is visible, etc). These 'state' messages
// should be sent from the client to the server inside every client->server message, and sometimes
// by themselves in response to state changes on the client (and quite frequently).
// 
// If the Type is SERVER_TO_CLIENT, then the messages will contain a ServerInfo describing
// the state of the server, along with (optionally) an Audio structure, a MsgBlock, and/or
// a MsgDeltaBlock (described in-line).
// 
// The only major request-response pattern is the first message from client to server (CLIENT_ASK_TO_CONNECT),
// to which the server replies with SERVER_CONNECT_INFO. All other messages are sent from client to server
// or from server to client asynchronously, at any time, apropos of nothing. The other (minor)
// request-response pattern is PING-ACK.
// 
// There is an assumption that the client will (when ready) send a CLIENT_TO_SERVER (and its required ClientInfo)
// The values in the connect info, particularly the max_delta_id will often prompt the server to update the client's state

/**
 * @generated from protobuf message pb.AudioMessage
 */
export interface AudioMessage {
    /**
     * The Type of the message.
     *
     * @generated from protobuf field: optional pb.AudioMessage.Type type = 3
     */
    type?: AudioMessage_Type;
    // 'group/cluster' values pertain only to audio data.
    // TODO refactor into the Audio structure?
    // ANSWER YES, but it would break things. Counter-answer - better now than later. 
    //  Cleaning the message protocol is a useful investment.

    /**
     * When the server 'speaks', it emits a series of AudioMessages containing
     * Audio structures, which are the actual audio waveform data. Each 'utterance'
     * (roughly equivalent to a 'sentence') that the server emits will be composed
     * of one or more Audio messages, and all of them will contain the same
     * 'seq_id' (say the value 42). seq_id's are ascending numbers - the next
     * series of AudioMessages will contain seq_id=43, the next 44, and so on.
     * It's simply an ascending integer, starting from 0.
     *
     * @generated from protobuf field: optional uint64 audio_cluster_seq_id = 4
     */
    audioClusterSeqId?: string;
    /**
     * Within a series of AudioMessages that are part of the same cluster, the
     * audio_cluster_sample_offset indicates where in the audio waveform the current data
     * begins. So if we're sending waveform data in batches of 1024 samples, within
     * one AudioMessage series in one utterance, the first value will be 0, the next
     * 1024, the next 2048, etc.
     *
     * @generated from protobuf field: optional uint64 audio_cluster_sample_offset = 5
     */
    audioClusterSampleOffset?: string;
    /**
     * Contains the total number of samples within an audio cluster. May not be known, thus absent.
     *
     * @generated from protobuf field: optional uint64 audio_cluster_sample_max = 15
     */
    audioClusterSampleMax?: string;
    /**
     * not currently used in transmission - used for UE plumbing.
     * TODO so can we remove? We really need a kludge this this?
     *
     * @generated from protobuf field: optional uint64 silence_samples = 6
     */
    silenceSamples?: string;
    /**
     * Used only in debugging.
     * This allows the server and client to tag particular messages for console printing.
     *   The value is user and context defined.  It is just generically useful for tagging
     *   messages for particular treatment. Frequently it is used to trigger printing some messages
     *
     * @generated from protobuf field: optional uint32 debug = 7
     */
    debug?: number;
    /**
     * Time since epoch in milliseconds.
     *
     * @generated from protobuf field: optional int64 message_sent_at = 16
     */
    messageSentAt?: string; // new 11/4/24
    /**
     * the actual fields of the AudioMessage
     *
     * @generated from protobuf oneof: info_block
     */
    infoBlock: {
        oneofKind: "clientInfo";
        /**
         * @generated from protobuf field: pb.AudioMessage.ClientInfo client_info = 8
         */
        clientInfo: AudioMessage_ClientInfo;
    } | {
        oneofKind: "serverInfo";
        /**
         * @generated from protobuf field: pb.AudioMessage.ServerInfo server_info = 9
         */
        serverInfo: AudioMessage_ServerInfo;
    } | {
        oneofKind: "connectInfo";
        /**
         * @generated from protobuf field: pb.AudioMessage.ConnectInfo connect_info = 12
         */
        connectInfo: AudioMessage_ConnectInfo;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Audio audio = 10
     */
    audio?: AudioMessage_Audio;
    /**
     * @generated from protobuf field: repeated pb.AudioMessage.Command commands = 11
     */
    commands: AudioMessage_Command[];
    /**
     * @generated from protobuf field: optional pb.AudioMessage.MsgBlock msg_block = 13
     */
    msgBlock?: AudioMessage_MsgBlock;
    /**
     * @generated from protobuf field: optional pb.AudioMessage.MsgDeltaBlock msg_delta_block = 14
     */
    msgDeltaBlock?: AudioMessage_MsgDeltaBlock;
    /**
     * @generated from protobuf field: optional pb.AudioMessage.ClusterInfo cluster_block = 17
     */
    clusterBlock?: AudioMessage_ClusterInfo;
}
/**
 * A 'pointer' into a composite (composed from many AudioMessages) waveform (utterance).
 * Used by the client to communicate to the server the progress of the client's
 * actually playback. For instance, when the client has completed emitting
 *  waveform 3 out of 10, it would send to the server a AudioClusterStatus indicating so.
 *
 * colin notes: This message/structure is contained in two places: the ClientInfo (thus, with potentially)
 *   every downstream message, and with the FINISHED and INTERRUPT commands. I'm still not sold
 *   on the idea that one isn't redundant. The argument that the values in the commands
 *   might come from a different thread than the one in ClientInfo seems to me to be
 *   a weak, and if necessary, covering up a design flaw in the code.
 *    agavin notes: FINISHED/INTERRUPT is about the transitions, ClientInfo's current status is about
 *      the latest. The messages are definitive whereas the Info is just suggestive
 *
 * @generated from protobuf message pb.AudioMessage.AudioClusterStatus
 */
export interface AudioMessage_AudioClusterStatus {
    /**
     * The same as the 'seq_id' to which this AudioClusterStatus refers.
     *
     * @generated from protobuf field: optional uint64 seq_id = 1
     */
    seqId?: string;
    /**
     * Referes to a audio_cluster_sample_offset within the specified id
     *
     * @generated from protobuf field: optional uint64 sample_offset = 2
     */
    sampleOffset?: string;
    /**
     * Only if known, the total max samples
     *
     * @generated from protobuf field: optional uint64 sample_max = 3
     */
    sampleMax?: string;
    /**
     * the number of samples received by the side sending the status
     *   so for server -> client clusters the number of samples received by the client
     *
     * @generated from protobuf field: optional uint64 samples_transferred = 12
     */
    samplesTransferred?: string; // new 10/3/24
    /**
     * What percent of the waveform has played through the speaker.
     * Float from 0.0 to 1.0.
     * only if known
     * possible TODO: rename 'fraction_complete'. I know that this naming pattern
     *   is pervasive, but it's also misleading, because it's definitely
     *   not 'percent'.
     *
     * @generated from protobuf field: optional float percent_complete = 4
     */
    percentComplete?: number;
    /**
     * // the following block is used to indicate what 'happened' with the cluster
     *   reference to client -> server clusters (in the ear clusters) means the transcript result
     *   for server -> client clusters (in the mouth clusters) means the play status
     *
     * @generated from protobuf field: optional pb.AudioMessage.AudioClusterStatus.Status status = 5
     */
    status?: AudioMessage_AudioClusterStatus_Status; // added 8/22/24
    /**
     * the processing status of the cluster
     *   for ear clusters this is in progress processing status
     *   for playing clusters this is the transferring status
     *
     * @generated from protobuf field: optional pb.AudioMessage.AudioClusterStatus.ProcessingStatus processing_status = 6
     */
    processingStatus?: AudioMessage_AudioClusterStatus_ProcessingStatus; // added 9/8/24
    // /// ear clusters only

    /**
     * the ear mode of this cluster
     *
     * @generated from protobuf field: optional pb.AudioMessage.EarMode ear_mode = 7
     */
    earMode?: AudioMessage_EarMode; // new 9/8/24
    /**
     * number of characters in the transcript
     *
     * @generated from protobuf field: optional uint32 char_count = 8
     */
    charCount?: number; // new 9/8/24
    /**
     * number of words in the transcript
     *
     * @generated from protobuf field: optional uint32 word_count = 9
     */
    wordCount?: number; // new 9/8/24
    /**
     * the transcript itself, if available -- not currently included
     *
     * @generated from protobuf field: optional string transcript = 10
     */
    transcript?: string; // new 9/8/24
    /**
     * if present and not '' then this is the text of a message the server wants the client to display about ear status
     *   this supercedes the old field in server info.
     *
     * @generated from protobuf field: optional string ear_error_msg = 11
     */
    earErrorMsg?: string; // added 9/13/24
    /**
     * times, since epoch in milliseconds
     * time we were released for spooling
     *
     * @generated from protobuf field: optional int64 active_at_ms = 13
     */
    activeAtMs?: string;
    /**
     * time we we started playing
     *
     * @generated from protobuf field: optional int64 played_at_ms = 14
     */
    playedAtMs?: string;
    /**
     * time we finished playing
     *
     * @generated from protobuf field: optional int64 finished_at_ms = 15
     */
    finishedAtMs?: string;
}
/**
 * @generated from protobuf enum pb.AudioMessage.AudioClusterStatus.Status
 */
export enum AudioMessage_AudioClusterStatus_Status {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * an audio cluster was sent and a transcript was found
     *
     * @generated from protobuf enum value: FOUND_TRANSCRIPT = 1;
     */
    FOUND_TRANSCRIPT = 1,
    /**
     * an audio cluster was sent, but no transcript was available
     *
     * @generated from protobuf enum value: NO_TRANSCRIPT = 2;
     */
    NO_TRANSCRIPT = 2,
    /**
     * some kind of technical error with the audio system
     *
     * @generated from protobuf enum value: SYSTEM_ERROR = 3;
     */
    SYSTEM_ERROR = 3,
    /**
     * the client is waiting to play the cluster
     *
     * @generated from protobuf enum value: PENDING = 4;
     */
    PENDING = 4,
    /**
     * the client is holding in hold time to play the cluster
     *
     * @generated from protobuf enum value: HOLDING = 5;
     */
    HOLDING = 5,
    /**
     * the client is spooling the cluster (but not yet playing)
     *
     * @generated from protobuf enum value: SPOOLING = 6;
     */
    SPOOLING = 6,
    /**
     * the client is playing the cluster
     *
     * @generated from protobuf enum value: PLAYING = 7;
     */
    PLAYING = 7,
    /**
     * the client has paused the cluster
     *
     * @generated from protobuf enum value: PAUSED = 8;
     */
    PAUSED = 8,
    /**
     * the client has canceled the cluster (no blocked played)
     *
     * @generated from protobuf enum value: CANCELED = 9;
     */
    CANCELED = 9,
    /**
     * the client has interrupted the cluster (some blocked played)
     *
     * @generated from protobuf enum value: INTERRUPTED = 10;
     */
    INTERRUPTED = 10,
    /**
     * the client has finished the cluster
     *
     * @generated from protobuf enum value: FINISHED = 11;
     */
    FINISHED = 11,
    /**
     * the client has marked this cluster as error
     *
     * @generated from protobuf enum value: ERROR = 12;
     */
    ERROR = 12
}
/**
 * @generated from protobuf enum pb.AudioMessage.AudioClusterStatus.ProcessingStatus
 */
export enum AudioMessage_AudioClusterStatus_ProcessingStatus {
    /**
     * @generated from protobuf enum value: PS_UNKNOWN = 0;
     */
    PS_UNKNOWN = 0,
    /**
     * an audio cluster is processing in the ear
     *
     * @generated from protobuf enum value: PROCESSING = 1;
     */
    PROCESSING = 1,
    /**
     * an audio cluster is full, please finish it
     *
     * @generated from protobuf enum value: ALMOST_FULL = 2;
     */
    ALMOST_FULL = 2,
    /**
     * an audio cluster is finished processing in the ear
     *
     * @generated from protobuf enum value: COMPLETE = 3;
     */
    COMPLETE = 3,
    /**
     * server -> client clusters
     *
     * the cluster is still transferring
     *
     * @generated from protobuf enum value: TRANSFERRING = 4;
     */
    TRANSFERRING = 4,
    /**
     * the cluster has been transferred
     *
     * @generated from protobuf enum value: TRANSFERRED = 5;
     */
    TRANSFERRED = 5
}
/**
 * @generated from protobuf message pb.AudioMessage.ClusterPropertyValue
 */
export interface AudioMessage_ClusterPropertyValue {
    /**
     * @generated from protobuf field: pb.AudioMessage.ClusterPropertyValue.Type type = 1
     */
    type: AudioMessage_ClusterPropertyValue_Type;
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "strValue";
        /**
         * @generated from protobuf field: string str_value = 2
         */
        strValue: string;
    } | {
        oneofKind: "intValue";
        /**
         * @generated from protobuf field: int64 int_value = 3
         */
        intValue: string;
    } | {
        oneofKind: "floatValue";
        /**
         * @generated from protobuf field: float float_value = 4
         */
        floatValue: number;
    } | {
        oneofKind: "boolValue";
        /**
         * @generated from protobuf field: bool bool_value = 5
         */
        boolValue: boolean;
    } | {
        oneofKind: "dictValue";
        /**
         * @generated from protobuf field: pb.AudioMessage.ClusterProperties dict_value = 6
         */
        dictValue: AudioMessage_ClusterProperties;
    } | {
        oneofKind: "listValue";
        /**
         * @generated from protobuf field: pb.AudioMessage.ClusterPropertyValueList list_value = 7
         */
        listValue: AudioMessage_ClusterPropertyValueList;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum pb.AudioMessage.ClusterPropertyValue.Type
 */
export enum AudioMessage_ClusterPropertyValue_Type {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STRING = 1;
     */
    STRING = 1,
    /**
     * @generated from protobuf enum value: INT = 2;
     */
    INT = 2,
    /**
     * @generated from protobuf enum value: FLOAT = 3;
     */
    FLOAT = 3,
    /**
     * @generated from protobuf enum value: BOOL = 4;
     */
    BOOL = 4,
    /**
     * @generated from protobuf enum value: DICT = 5;
     */
    DICT = 5,
    /**
     * @generated from protobuf enum value: LIST = 6;
     */
    LIST = 6
}
/**
 * @generated from protobuf message pb.AudioMessage.ClusterPropertyValueList
 */
export interface AudioMessage_ClusterPropertyValueList {
    /**
     * @generated from protobuf field: repeated pb.AudioMessage.ClusterPropertyValue values = 1
     */
    values: AudioMessage_ClusterPropertyValue[];
}
/**
 * @generated from protobuf message pb.AudioMessage.ClusterProperty
 */
export interface AudioMessage_ClusterProperty {
    /**
     * @generated from protobuf field: string property = 1
     */
    property: string;
    /**
     * @generated from protobuf field: pb.AudioMessage.ClusterPropertyValue value = 2
     */
    value?: AudioMessage_ClusterPropertyValue;
}
/**
 * @generated from protobuf message pb.AudioMessage.ClusterProperties
 */
export interface AudioMessage_ClusterProperties {
    /**
     * @generated from protobuf field: repeated pb.AudioMessage.ClusterProperty properties = 2
     */
    properties: AudioMessage_ClusterProperty[];
}
/**
 * @generated from protobuf message pb.AudioMessage.ClusterPropertySpace
 */
export interface AudioMessage_ClusterPropertySpace {
    /**
     * @generated from protobuf field: string space = 1
     */
    space: string;
    /**
     * @generated from protobuf field: pb.AudioMessage.ClusterProperties properties = 2
     */
    properties?: AudioMessage_ClusterProperties;
}
/**
 * @generated from protobuf message pb.AudioMessage.ClusterDesc
 */
export interface AudioMessage_ClusterDesc {
    /**
     * the seq_id of the cluster
     *   if this is an audio cluster (voice), should match the seq_id of the audio cluster
     *
     * @generated from protobuf field: optional uint64 seq_id = 1
     */
    seqId?: string;
    /**
     * @generated from protobuf field: optional uint64 transaction_id = 14
     */
    transactionId?: string; // 0 is no transaction_id
    /**
     * if the cluster is not part of an open transaction, then cancel on arrival
     *
     * @generated from protobuf field: optional bool cancel_if_possible = 15
     */
    cancelIfPossible?: boolean; // new 5/27/25
    /**
     * the recomended channel to run the cluster on, if absent will imply it from channel_type
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClusterDesc.Channel channel = 2
     */
    channel?: AudioMessage_ClusterDesc_Channel;
    /**
     * the channel/type of the cluster to instantiate
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClusterDesc.Channel channel_type = 10
     */
    channelType?: AudioMessage_ClusterDesc_Channel;
    /**
     * if a cluster is being described in a client -> server message the status can optional be included
     *
     * @generated from protobuf field: optional pb.AudioMessage.AudioClusterStatus status = 3
     */
    status?: AudioMessage_AudioClusterStatus;
    /**
     * some cluster channels have a duration (like wait)
     *   it might just be a estimated duration (for anims) to be used in the case of a missing anim
     *
     * @generated from protobuf field: optional float duration = 4
     */
    duration?: number;
    /**
     * true to make this an instant complete cluster
     *
     * @generated from protobuf field: optional bool instant = 12
     */
    instant?: boolean;
    /**
     * conditions required for this cluster to start
     *
     * @generated from protobuf field: repeated pb.AudioMessage.ClusterDesc.Condition start_conditions = 5
     */
    startConditions: AudioMessage_ClusterDesc_Condition[];
    /**
     * conditions required for this cluster to end
     *   not yet implemented
     *
     * @generated from protobuf field: repeated pb.AudioMessage.ClusterDesc.Condition end_conditions = 11
     */
    endConditions: AudioMessage_ClusterDesc_Condition[];
    /**
     * any properties to set when the cluster finishes
     *
     * @generated from protobuf field: pb.AudioMessage.ClusterProperties properties = 8
     */
    properties?: AudioMessage_ClusterProperties;
    /**
     * list of possible param spaces. The default one is *
     *
     * @generated from protobuf field: repeated pb.AudioMessage.ClusterPropertySpace param_spaces = 13
     */
    paramSpaces: AudioMessage_ClusterPropertySpace[];
    /**
     * do we need to send finishes
     *
     * @generated from protobuf field: optional bool dont_confirm = 9
     */
    dontConfirm?: boolean;
    /**
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "voice";
        /**
         * @generated from protobuf field: pb.AudioMessage.ClusterDesc.VoicePayload voice = 6
         */
        voice: AudioMessage_ClusterDesc_VoicePayload;
    } | {
        oneofKind: "anim";
        /**
         * @generated from protobuf field: pb.AudioMessage.ClusterDesc.AnimPayload anim = 7
         */
        anim: AudioMessage_ClusterDesc_AnimPayload;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message pb.AudioMessage.ClusterDesc.Condition
 */
export interface AudioMessage_ClusterDesc_Condition {
    /**
     * the type to check
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClusterDesc.Condition.Type check_type = 1
     */
    checkType?: AudioMessage_ClusterDesc_Condition_Type;
    /**
     * the time offset in seconds (negative is before the condition)
     *
     * @generated from protobuf oneof: offset
     */
    offset: {
        oneofKind: "offsetSecs";
        /**
         * @generated from protobuf field: float offset_secs = 2
         */
        offsetSecs: number;
    } | {
        oneofKind: "offsetPercent";
        /**
         * @generated from protobuf field: float offset_percent = 7
         */
        offsetPercent: number;
    } | {
        oneofKind: undefined;
    };
    /**
     * possible values for the check
     *
     * @generated from protobuf oneof: check_value
     */
    checkValue: {
        oneofKind: "channel";
        /**
         * @generated from protobuf field: pb.AudioMessage.ClusterDesc.Channel channel = 3
         */
        channel: AudioMessage_ClusterDesc_Channel;
    } | {
        oneofKind: "seqId";
        /**
         * @generated from protobuf field: uint64 seq_id = 4
         */
        seqId: string;
    } | {
        oneofKind: "property";
        /**
         * @generated from protobuf field: pb.AudioMessage.ClusterProperty property = 6
         */
        property: AudioMessage_ClusterProperty;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum pb.AudioMessage.ClusterDesc.Condition.Type
 */
export enum AudioMessage_ClusterDesc_Condition_Type {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: ALWAYS = 1;
     */
    ALWAYS = 1,
    /**
     * @generated from protobuf enum value: CHANNEL_CLEAR = 2;
     */
    CHANNEL_CLEAR = 2,
    /**
     * @generated from protobuf enum value: CLUSTER_ACTIVE = 3;
     */
    CLUSTER_ACTIVE = 3,
    /**
     * @generated from protobuf enum value: CLUSTER_PLAYING = 4;
     */
    CLUSTER_PLAYING = 4,
    /**
     * @generated from protobuf enum value: CLUSTER_FINISHED = 5;
     */
    CLUSTER_FINISHED = 5,
    /**
     * @generated from protobuf enum value: PROPERTY_SET = 6;
     */
    PROPERTY_SET = 6,
    /**
     * @generated from protobuf enum value: PROPERTY_LOCKED = 7;
     */
    PROPERTY_LOCKED = 7,
    /**
     * all previous clusters finished
     *
     * @generated from protobuf enum value: PREV_FINISHED = 8;
     */
    PREV_FINISHED = 8,
    /**
     * no animation running on specified channel
     *
     * @generated from protobuf enum value: ANIM_CLEAR = 9;
     */
    ANIM_CLEAR = 9
}
/**
 * @generated from protobuf message pb.AudioMessage.ClusterDesc.VoicePayload
 */
export interface AudioMessage_ClusterDesc_VoicePayload {
    /**
     * if present, the transcript of this audio cluster
     *   may also be in the Msg, if that is present
     *
     * @generated from protobuf field: optional string transcript = 2
     */
    transcript?: string;
    /**
     * emotion (tone) that should be displayed, about to be deprecated
     *
     * @generated from protobuf field: optional pb.AudioMessage.AvatarEmotion anim_emotion = 3
     */
    animEmotion?: AudioMessage_AvatarEmotion;
    /**
     * newer more complex emotion description that includes all the intensities, etc
     *
     * @generated from protobuf field: optional pb.AudioMessage.EmotionDesc emotion = 6
     */
    emotion?: AudioMessage_EmotionDesc;
    /**
     * emotion (tone) it was synthesized with, about to be deprecated
     *
     * @generated from protobuf field: optional pb.AudioMessage.AvatarEmotion voice_emotion = 5
     */
    voiceEmotion?: AudioMessage_AvatarEmotion;
    /**
     * if present, the chat msg this is associated with
     *
     * @generated from protobuf field: optional pb.AudioMessage.Msg msg = 4
     */
    msg?: AudioMessage_Msg;
}
/**
 * @generated from protobuf message pb.AudioMessage.ClusterDesc.AnimPayload
 */
export interface AudioMessage_ClusterDesc_AnimPayload {
    /**
     * @generated from protobuf field: optional string anim_name = 1
     */
    animName?: string;
    /**
     * @generated from protobuf field: optional float anim_speed = 2
     */
    animSpeed?: number;
}
/**
 * @generated from protobuf enum pb.AudioMessage.ClusterDesc.Channel
 */
export enum AudioMessage_ClusterDesc_Channel {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: ALL = 1;
     */
    ALL = 1,
    /**
     * @generated from protobuf enum value: VOICE = 2;
     */
    VOICE = 2,
    /**
     * @generated from protobuf enum value: TEXT = 3;
     */
    TEXT = 3,
    /**
     * @generated from protobuf enum value: SFX = 4;
     */
    SFX = 4,
    /**
     * @generated from protobuf enum value: ANIM_BODY = 5;
     */
    ANIM_BODY = 5,
    /**
     * @generated from protobuf enum value: ANIM_UPPER_BODY = 6;
     */
    ANIM_UPPER_BODY = 6,
    /**
     * @generated from protobuf enum value: ANIM_BODY_GESTURE = 10;
     */
    ANIM_BODY_GESTURE = 10,
    /**
     * @generated from protobuf enum value: ANIM_FACE = 7;
     */
    ANIM_FACE = 7,
    /**
     * smart animations
     *
     * @generated from protobuf enum value: ANIM_GEN = 12;
     */
    ANIM_GEN = 12,
    /**
     * @generated from protobuf enum value: WAIT = 8;
     */
    WAIT = 8,
    /**
     * @generated from protobuf enum value: PROPERTY = 9;
     */
    PROPERTY = 9,
    /**
     * @generated from protobuf enum value: CAMERA = 11;
     */
    CAMERA = 11,
    /**
     * @generated from protobuf enum value: EVENT = 13;
     */
    EVENT = 13
}
/**
 * the main block providing updates about clusters
 *
 * @generated from protobuf message pb.AudioMessage.ClusterInfo
 */
export interface AudioMessage_ClusterInfo {
    /**
     * the largest seq_id yet seen by the system
     *
     * @generated from protobuf field: optional uint64 max_seq_id = 1
     */
    maxSeqId?: string;
    /**
     * the list of any new clusters
     *
     * @generated from protobuf field: repeated pb.AudioMessage.ClusterDesc clusters = 2
     */
    clusters: AudioMessage_ClusterDesc[];
    /**
     * the current cluster properties
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClusterProperties properties = 3
     */
    properties?: AudioMessage_ClusterProperties;
}
/**
 * @generated from protobuf message pb.AudioMessage.DevicePermissions
 */
export interface AudioMessage_DevicePermissions {
    /**
     * @generated from protobuf field: optional pb.AudioMessage.DevicePermissions.IOSPermissions ios_push_notification = 1
     */
    iosPushNotification?: AudioMessage_DevicePermissions_IOSPermissions;
    /**
     * Has the user granted permission for the webapp to use the microphone?
     *
     * @generated from protobuf field: optional pb.AudioMessage.DevicePermissions.BrowserPermission browser_microphone_permission = 2
     */
    browserMicrophonePermission?: AudioMessage_DevicePermissions_BrowserPermission;
    /**
     * Has the user granted permission for the webapp to play the pixel stream?
     * The browser requires explicit user interaction to auto-play audio.
     *
     * @generated from protobuf field: optional pb.AudioMessage.DevicePermissions.BrowserInteractionClickState browser_pixel_streaming_auto_playable_interaction = 4
     */
    browserPixelStreamingAutoPlayableInteraction?: AudioMessage_DevicePermissions_BrowserInteractionClickState;
}
/**
 * @generated from protobuf message pb.AudioMessage.DevicePermissions.IOSPermissions
 */
export interface AudioMessage_DevicePermissions_IOSPermissions {
    /**
     * @generated from protobuf field: pb.AudioMessage.DevicePermissions.IOSPermissions.Status status = 1
     */
    status: AudioMessage_DevicePermissions_IOSPermissions_Status;
}
/**
 * @generated from protobuf enum pb.AudioMessage.DevicePermissions.IOSPermissions.Status
 */
export enum AudioMessage_DevicePermissions_IOSPermissions_Status {
    /**
     * https://developer.apple.com/documentation/usernotifications/unauthorizationstatus
     *
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOT_DETERMINED = 1;
     */
    NOT_DETERMINED = 1,
    /**
     * @generated from protobuf enum value: DENIED = 2;
     */
    DENIED = 2,
    /**
     * @generated from protobuf enum value: AUTHORIZED = 3;
     */
    AUTHORIZED = 3,
    /**
     * @generated from protobuf enum value: PROVISIONAL = 4;
     */
    PROVISIONAL = 4,
    /**
     * @generated from protobuf enum value: EPHEMERAL = 5;
     */
    EPHEMERAL = 5
}
/**
 * @generated from protobuf message pb.AudioMessage.DevicePermissions.BrowserPermission
 */
export interface AudioMessage_DevicePermissions_BrowserPermission {
    /**
     * @generated from protobuf field: pb.AudioMessage.DevicePermissions.BrowserPermission.Status status = 1
     */
    status: AudioMessage_DevicePermissions_BrowserPermission_Status;
}
/**
 * @generated from protobuf enum pb.AudioMessage.DevicePermissions.BrowserPermission.Status
 */
export enum AudioMessage_DevicePermissions_BrowserPermission_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATUS_NOT_DETERMINED = 1;
     */
    NOT_DETERMINED = 1,
    /**
     * @generated from protobuf enum value: STATUS_DENIED = 2;
     */
    DENIED = 2,
    /**
     * @generated from protobuf enum value: STATUS_AUTHORIZED = 3;
     */
    AUTHORIZED = 3
}
/**
 * @generated from protobuf message pb.AudioMessage.DevicePermissions.BrowserInteractionClickState
 */
export interface AudioMessage_DevicePermissions_BrowserInteractionClickState {
    /**
     * @generated from protobuf field: pb.AudioMessage.DevicePermissions.BrowserInteractionClickState.Status status = 1
     */
    status: AudioMessage_DevicePermissions_BrowserInteractionClickState_Status;
}
/**
 * @generated from protobuf enum pb.AudioMessage.DevicePermissions.BrowserInteractionClickState.Status
 */
export enum AudioMessage_DevicePermissions_BrowserInteractionClickState_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: STATUS_NOT_CLICKED = 1;
     */
    NOT_CLICKED = 1,
    /**
     * @generated from protobuf enum value: STATUS_CLICKED = 2;
     */
    CLICKED = 2
}
/**
 * Modifier of AvatarEmotion, to contain intensity.
 *
 * @generated from protobuf message pb.AudioMessage.EmotionDesc
 */
export interface AudioMessage_EmotionDesc {
    /**
     * the animiation or display emotion, aka the main emotion
     *
     * @generated from protobuf field: optional pb.AudioMessage.AvatarEmotion emotion = 1
     */
    emotion?: AudioMessage_AvatarEmotion;
    /**
     * if present, the voice emotion (tone) it was synthesized with
     *
     * @generated from protobuf field: optional pb.AudioMessage.AvatarEmotion voice_emotion = 5
     */
    voiceEmotion?: AudioMessage_AvatarEmotion;
    /**
     * 0.0 - 1.0 intensity of this emotion, if present, this is for both the face and body emotion
     *
     * @generated from protobuf field: optional float intensity = 2
     */
    intensity?: number;
    /**
     * if present, overrides the intensity for just the face
     *
     * @generated from protobuf field: optional float face_intensity = 3
     */
    faceIntensity?: number;
    /**
     * if present, overrides the intensity for just the body
     *
     * @generated from protobuf field: optional float body_intensity = 4
     */
    bodyIntensity?: number;
    /**
     * optional intent enum for categorizing conversational intent
     *
     * @generated from protobuf field: optional pb.AudioMessage.Intent intent_code = 6
     */
    intentCode?: AudioMessage_Intent; // new 10/22/25
    /**
     * optional markup string for additional context set with bot turn
     *
     * @generated from protobuf field: optional string markup = 7
     */
    markup?: string; // new 10/22/25
}
/**
 * @generated from protobuf message pb.AudioMessage.DisplayInfo
 */
export interface AudioMessage_DisplayInfo {
    /**
     * a unique incrementing number to identify the request
     *
     * @generated from protobuf field: optional uint64 display_id = 1
     */
    displayId?: string;
    /**
     * actual hardware orientation, like on the phone
     *
     * @generated from protobuf field: optional pb.AudioMessage.DisplayInfo.Orientation orientation = 2
     */
    orientation?: AudioMessage_DisplayInfo_Orientation;
    /**
     * The width of the display in pixels, horizontal width across the avatar's face
     *
     * @generated from protobuf field: optional float render_width = 3
     */
    renderWidth?: number;
    /**
     * The height of the display in pixels, vertical height from top to bottom of the avatar
     *
     * @generated from protobuf field: optional float render_height = 4
     */
    renderHeight?: number;
}
/**
 * @generated from protobuf enum pb.AudioMessage.DisplayInfo.Orientation
 */
export enum AudioMessage_DisplayInfo_Orientation {
    /**
     * @generated from protobuf enum value: ORIENT_UNKNOWN = 0;
     */
    ORIENT_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: LANDSCAPE = 1;
     */
    LANDSCAPE = 1,
    /**
     * @generated from protobuf enum value: PORTRAIT = 2;
     */
    PORTRAIT = 2
}
/**
 * Info related to the speakers "in the room" during a conversation
 *
 * @generated from protobuf message pb.AudioMessage.SpeakerInfo
 */
export interface AudioMessage_SpeakerInfo {
    /**
     * @generated from protobuf field: optional string name = 1
     */
    name?: string;
    /**
     * @generated from protobuf field: optional string uid = 2
     */
    uid?: string;
    /**
     * whether the bot is talking to them or not
     *
     * @generated from protobuf field: optional bool focused = 3
     */
    focused?: boolean;
    /**
     * The connection associated with the speaker.
     *
     * @generated from protobuf field: pb.AudioMessage.SpeakerConnection speaker_connection = 4
     */
    speakerConnection?: AudioMessage_SpeakerConnection;
}
/**
 * TODO: The client type that the connection is made with?
 * ConnectInfo.ClientType client_type = 1;
 *
 * @generated from protobuf message pb.AudioMessage.SpeakerConnection
 */
export interface AudioMessage_SpeakerConnection {
    /**
     * The user_id of the user that is associated with the connection.
     * NOTE: for the case of multiple speakers on a single connection (e.g. "I'm here with my buddy Alex"),
     * The user_id here is that of "I", not Alex (who likely doesn't have a user_id at all).
     *
     * @generated from protobuf field: optional string user_id = 2
     */
    userId?: string;
    /**
     * @generated from protobuf field: optional string user_email = 7
     */
    userEmail?: string;
    /**
     * @generated from protobuf field: pb.AudioMessage.SpeakerConnection.ConnectionStatus connection_status = 4
     */
    connectionStatus: AudioMessage_SpeakerConnection_ConnectionStatus;
    /**
     * A message to display to the user about the connection status, e.g. in a mouseover.
     *
     * @generated from protobuf field: optional string connection_status_message = 5
     */
    connectionStatusMessage?: string; // [deprecated=true];
    /**
     * Whether the connections mic is enabled.
     *
     * @generated from protobuf field: optional bool mic_enabled = 6
     */
    micEnabled?: boolean;
    /**
     * Whether the participant has enabled their microphone.
     *
     * @generated from protobuf field: optional bool mic_user_permissioned = 8
     */
    micUserPermissioned?: boolean;
    /**
     * Whether the user has activated the pixel streamer. Through a click? Not sure relevant
     *
     * @generated from protobuf field: optional bool stream_activated = 9
     */
    streamActivated?: boolean;
}
/**
 * @generated from protobuf enum pb.AudioMessage.SpeakerConnection.ConnectionStatus
 */
export enum AudioMessage_SpeakerConnection_ConnectionStatus {
    /**
     * @generated from protobuf enum value: CONNECTION_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The referenced client is actively connected to the server.
     *
     * @generated from protobuf enum value: CONNECTION_STATUS_CONNECTED = 1;
     */
    CONNECTED = 1,
    /**
     * The referenced client is connected to the server, but has some issues.
     * e.g. it does not have microphone permissions enabled.
     *
     * [deprecated=true];
     *
     * @generated from protobuf enum value: CONNECTION_STATUS_CONNECTED_WITH_ISSUES = 2;
     */
    CONNECTED_WITH_ISSUES = 2,
    /**
     * The referenced client is not connected to the server.
     *
     * @generated from protobuf enum value: CONNECTION_STATUS_DISCONNECTED = 3;
     */
    DISCONNECTED = 3
}
/**
 * Describes the full state of the client. Sent only from client to server.
 * Included with every non-connect message, and sometimes (often) by itself
 * (or as the only big payload item in an AudioMessage).
 *
 * @generated from protobuf message pb.AudioMessage.ClientInfo
 */
export interface AudioMessage_ClientInfo {
    /**
     * the client is actively vocalizing/speaking
     *
     * @generated from protobuf field: optional bool speaking = 1
     */
    speaking?: boolean;
    /**
     * the client has the microphone enabled
     *
     * @generated from protobuf field: optional bool microphone = 2
     */
    microphone?: boolean;
    /**
     * the client thinks the user is maybe talking into mic (runtime vad)
     *
     * @generated from protobuf field: optional bool microphone_maybe_talking = 3
     */
    microphoneMaybeTalking?: boolean;
    /**
     * an aprox 0.0 - 1.0 of microphone volume
     *
     * @generated from protobuf field: optional float microphone_volume = 4
     */
    microphoneVolume?: number;
    /**
     * what is the avatar up to
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClientInfo.AvatarState avatar_state = 5
     */
    avatarState?: AudioMessage_ClientInfo_AvatarState;
    /**
     * the client is in the middle of a microphone upload burst
     * even if the mic is on, this could be false if the client is suppressing the mic
     * due to speaking itself or similar. The client is expected to send a change state WITHOUT Audio
     * including this false when it transitions from uploading audio to not uploading
     *
     * @generated from protobuf field: optional bool microphone_transmitting = 6
     */
    microphoneTransmitting?: boolean;
    /**
     * ear_mode_desired is the mode the client wants to be in
     *    default is conceptually CONVERSATION
     *  this is not actually used definitively by the backend, but reflects what the client wants
     *  the backend uses the ear_mode in the audio packets to determine what to do with the audio
     *
     * @generated from protobuf field: optional pb.AudioMessage.EarMode ear_mode_desired = 14
     */
    earModeDesired?: AudioMessage_EarMode; // new 8/14/24
    /**
     * the max_delta_id the client has in its MsgCache
     * If absent, client has nothing in its cache. Has several
     * special values:
     *  -2: 'client has no data, has not communicated with server'
     *  -1: 'client has no data, server acknowledged this, fresh conversation / no deltas'.
     *  0: client has 1 delta
     *  1: client has 2 deltas.
     *  etc
     * This is refreshed whenever we get a MsgDeltaBlock from the server, from the max_delta_id
     * attribute.
     *
     * @generated from protobuf field: optional int64 max_delta_id = 8
     */
    maxDeltaId?: string;
    /**
     * status on what the client is currently vocalizing/speaking. may be absent
     *
     * @generated from protobuf field: optional pb.AudioMessage.AudioClusterStatus spoken_audio_cluster = 9
     */
    spokenAudioCluster?: AudioMessage_AudioClusterStatus;
    /**
     * does the user want the client to speak via audio (True) or text only. Default if absent is True
     *
     * @generated from protobuf field: optional bool speech_desired = 10
     */
    speechDesired?: boolean;
    /**
     * the client has the avatar on screen
     *
     * @generated from protobuf field: optional bool avatar_visible = 11
     */
    avatarVisible?: boolean;
    /**
     * the client is currently uploading some media file
     *
     * @generated from protobuf field: optional bool media_uploading = 13
     */
    mediaUploading?: boolean; // new 7/10/24
    /**
     * what is the user up to
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClientInfo.UserActivity user_activity = 12
     */
    userActivity?: AudioMessage_ClientInfo_UserActivity;
    /**
     * state of any client-side device permissions
     *
     * @generated from protobuf field: optional pb.AudioMessage.DevicePermissions device_permissions = 15
     */
    devicePermissions?: AudioMessage_DevicePermissions; // new 10/18/24
    /**
     * indicates the loading status of the client
     *   for an Unreal client this is the full loading status, all assets loaded and settled
     *   for a JS web client this means that they think all parts are ready and the stream is visible
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClientLoadingStatus loading_status = 16
     */
    loadingStatus?: AudioMessage_ClientLoadingStatus;
    /**
     * indicates the pause status of the client
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClientPauseStatus pause_status = 17
     */
    pauseStatus?: AudioMessage_ClientPauseStatus;
    /**
     * a pause status that the user might want
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClientPauseStatus user_desired_pause_status = 18
     */
    userDesiredPauseStatus?: AudioMessage_ClientPauseStatus;
    /**
     * actual upward display info of THE client that renders, like Unreal
     *  Unreal -> Server
     *
     * @generated from protobuf field: optional pb.AudioMessage.DisplayInfo display_info = 19
     */
    displayInfo?: AudioMessage_DisplayInfo;
    /**
     * a client that is requesting a specific display info, generally the master mute skull
     *  what it wants to be rendered
     *  MuteSkull -> Server
     *
     * @generated from protobuf field: optional pb.AudioMessage.DisplayInfo user_desired_display_info = 20
     */
    userDesiredDisplayInfo?: AudioMessage_DisplayInfo;
}
/**
 * @generated from protobuf enum pb.AudioMessage.ClientInfo.AvatarState
 */
export enum AudioMessage_ClientInfo_AvatarState {
    /**
     * @generated from protobuf enum value: NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: IDLE = 1;
     */
    IDLE = 1,
    /**
     * @generated from protobuf enum value: ENGAGED = 5;
     */
    ENGAGED = 5,
    /**
     * @generated from protobuf enum value: LISTENING = 2;
     */
    LISTENING = 2,
    /**
     * @generated from protobuf enum value: THINKING = 3;
     */
    THINKING = 3,
    /**
     * @generated from protobuf enum value: SPEAKING = 4;
     */
    SPEAKING = 4
}
/**
 * @generated from protobuf enum pb.AudioMessage.ClientInfo.UserActivity
 */
export enum AudioMessage_ClientInfo_UserActivity {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * idle in the app
     *
     * @generated from protobuf enum value: FREE = 1;
     */
    FREE = 1,
    /**
     * unspecified busy
     *
     * @generated from protobuf enum value: BUSY = 2;
     */
    BUSY = 2,
    /**
     * typing pane has focused, but not typing
     *
     * @generated from protobuf enum value: TYPING_FOCUS = 9;
     */
    TYPING_FOCUS = 9,
    /**
     * actively typing (fairly short timeout, like 0.1 seconds)
     *
     * @generated from protobuf enum value: TYPING_ACTIVE = 3;
     */
    TYPING_ACTIVE = 3,
    /**
     * was typing, still up, but now idle
     *
     * @generated from protobuf enum value: TALKING = 4;
     */
    TALKING = 4,
    /**
     * using a recording feature
     *
     * @generated from protobuf enum value: RECORDING = 5;
     */
    RECORDING = 5,
    /**
     * active in some kind of interface, like with a popup
     *
     * @generated from protobuf enum value: INTERFACE = 6;
     */
    INTERFACE = 6,
    /**
     * app does not have focus
     *
     * @generated from protobuf enum value: UNFOCUSED = 7;
     */
    UNFOCUSED = 7,
    /**
     * app is in the background
     *
     * @generated from protobuf enum value: BACKGROUND = 8;
     */
    BACKGROUND = 8
}
/**
 * Every message from the server of type SERVER_TO_CLIENT will contain one of these.
 *
 * @generated from protobuf message pb.AudioMessage.ServerInfo
 */
export interface AudioMessage_ServerInfo {
    /**
     * the server has recently found actual speech in the audio or has seen a text input from the user
     *
     * @generated from protobuf field: optional bool heard_something = 1
     */
    heardSomething?: boolean;
    /**
     * the server is currently listening to a stream of audio
     *   there is an open PTT session
     *
     * @generated from protobuf field: optional bool listening = 12
     */
    listening?: boolean; // added 2/20/25
    /**
     * if present and not '' then this is the text of a message the server wants the client to display about ear status
     *   this is about to be deprecated as soon as Colin uses the new one in AudioClusterStatus
     *
     * @generated from protobuf field: optional string ear_error_msg = 8
     */
    earErrorMsg?: string; // added 8/22/24
    /**
     * status on what the server ear is currently listening too. may be absent
     *
     * @generated from protobuf field: optional pb.AudioMessage.AudioClusterStatus ear_audio_cluster = 9
     */
    earAudioCluster?: AudioMessage_AudioClusterStatus; // added 9/8/24
    /**
     * the brain is busy thnking (being depreciated in favor of cortex_status)
     *
     * @generated from protobuf field: optional bool thinking = 2
     */
    thinking?: boolean;
    /**
     * the more complex thinking status
     *
     * @generated from protobuf field: optional pb.AudioMessage.ServerInfo.CortexStatus cortex_status = 11
     */
    cortexStatus?: AudioMessage_ServerInfo_CortexStatus; // new 2/17/25
    /**
     * the mouth is busy with something / anything
     *
     * @generated from protobuf field: optional bool mouthing = 5
     */
    mouthing?: boolean; // added 6/24/24
    /**
     * is regen currently allowed
     *
     * @generated from protobuf field: optional bool regen_allowed = 6
     */
    regenAllowed?: boolean; // added 6/30/24
    /**
     * is regen currently allowed
     *
     * @generated from protobuf field: optional bool input_allowed = 7
     */
    inputAllowed?: boolean; // added 7/16/24
    /**
     * the (possibly approximate) number of mouth samples the mouth is holding
     *
     * @generated from protobuf field: optional uint32 num_mouth_samples = 3
     */
    numMouthSamples?: number;
    /**
     * the current brain emotions. Could be more than one or none. If none, default is conceptually NEUTRAL
     *
     * @generated from protobuf field: repeated pb.AudioMessage.EmotionDesc emotions = 4
     */
    emotions: AudioMessage_EmotionDesc[];
    /**
     * list of human speakers in the conversation
     *
     * @generated from protobuf field: repeated pb.AudioMessage.SpeakerInfo speakers = 10
     */
    speakers: AudioMessage_SpeakerInfo[]; // new 1/16/25
    /**
     * @generated from protobuf field: pb.AudioMessage.ServerInfo.Config config = 13
     */
    config?: AudioMessage_ServerInfo_Config; // new 3/25/25
    /**
     * true if the main client has told the server that it is fully loaded
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClientLoadingStatus client_loading_status = 14
     */
    clientLoadingStatus?: AudioMessage_ClientLoadingStatus;
    /**
     * indicates what the server wants the client to do with the audio clusters
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClientPauseStatus desired_pause_status = 16
     */
    desiredPauseStatus?: AudioMessage_ClientPauseStatus;
    /**
     * actual upward display info of THE client that renders, like Unreal
     *  Server -> MuteSkulls
     *
     * @generated from protobuf field: optional pb.AudioMessage.DisplayInfo client_display_info = 17
     */
    clientDisplayInfo?: AudioMessage_DisplayInfo;
    /**
     *  what the server (other clients)want to be rendered
     *  Server -> Unreal (and all clients)
     *
     * @generated from protobuf field: optional pb.AudioMessage.DisplayInfo desired_display_info = 18
     */
    desiredDisplayInfo?: AudioMessage_DisplayInfo;
    /**
     * health status of the server
     *
     * @generated from protobuf field: optional pb.AudioMessage.ServerInfo.HealthStatus health_status = 19
     */
    healthStatus?: AudioMessage_ServerInfo_HealthStatus;
    /**
     * avatar language
     *
     * @generated from protobuf field: optional pb.AudioMessage.Language avatar_language = 20
     */
    avatarLanguage?: AudioMessage_Language;
    /**
     * the code for the language
     *
     * @generated from protobuf field: optional string avatar_language_code = 21
     */
    avatarLanguageCode?: string; // e.g. "en-US"
}
/**
 * @generated from protobuf message pb.AudioMessage.ServerInfo.Config
 */
export interface AudioMessage_ServerInfo_Config {
    /**
     * on/off for the during convo hand gestures
     *
     * @generated from protobuf field: optional bool hand_gestures = 1
     */
    handGestures?: boolean;
    /**
     * adjust for audio sync relative to animation, in ms
     *
     * @generated from protobuf field: optional float audio_sync_offset = 2
     */
    audioSyncOffset?: number;
    /**
     * strange scalar to adjust for audio sync, controls the speed of
     * movement to the audio sync offset in the positive direction. Typically around 250.0
     *
     * @generated from protobuf field: optional float audio_sync_scalar = 3
     */
    audioSyncScalar?: number;
    /**
     * number of seconds to hold an emotion before returning to neutral
     *
     * @generated from protobuf field: optional float emotion_timeout_secs = 4
     */
    emotionTimeoutSecs?: number;
    /**
     * the min length of time to hold an emotion
     *
     * @generated from protobuf field: optional float emotion_min_secs = 5
     */
    emotionMinSecs?: number;
    /**
     * how long to fade out the emotion when listening
     *
     * @generated from protobuf field: optional float emotion_listening_fade_secs = 6
     */
    emotionListeningFadeSecs?: number;
    /**
     * how long to fade out the emotion when thinking
     *
     * @generated from protobuf field: optional float emotion_thinking_fade_secs = 7
     */
    emotionThinkingFadeSecs?: number;
    /**
     * how long to keep a single thalamus emotion
     *
     * @generated from protobuf field: optional float emotion_thalamus_fade_secs = 8
     */
    emotionThalamusFadeSecs?: number;
}
/**
 * @generated from protobuf enum pb.AudioMessage.ServerInfo.CortexStatus
 */
export enum AudioMessage_ServerInfo_CortexStatus {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * doing nothing (none)
     *
     * @generated from protobuf enum value: IDLE = 1;
     */
    IDLE = 1,
    /**
     * about response (heavy)
     *
     * @generated from protobuf enum value: THINKING = 2;
     */
    THINKING = 2,
    /**
     * waiting for human input (light)
     *
     * @generated from protobuf enum value: ANTICIPATING = 3;
     */
    ANTICIPATING = 3,
    /**
     * busy doing something (medium)
     *
     * @generated from protobuf enum value: BUSY = 4;
     */
    BUSY = 4,
    /**
     * waiting for speech or animation to finish (light)
     *
     * @generated from protobuf enum value: PUPPETING = 5;
     */
    PUPPETING = 5,
    /**
     * a lighter wait state, considering if we are going to do something else (light)
     *
     * @generated from protobuf enum value: CONSIDERING = 6;
     */
    CONSIDERING = 6,
    /**
     * calculating something (heavy)
     *
     * @generated from protobuf enum value: CALCULATING = 7;
     */
    CALCULATING = 7,
    /**
     * in lobby mode, waiting for a connection (none)
     *
     * @generated from protobuf enum value: LOBBY = 8;
     */
    LOBBY = 8,
    /**
     * researching something (heavy)
     *
     * @generated from protobuf enum value: RESEARCHING = 9;
     */
    RESEARCHING = 9
}
/**
 * @generated from protobuf enum pb.AudioMessage.ServerInfo.HealthStatus
 */
export enum AudioMessage_ServerInfo_HealthStatus {
    /**
     * ENUM_SYNC HealthStatusType / AudioMessageHealthStatus       (1 to 1 number sync)
     *
     * @generated from protobuf enum value: NO_DATA = 0;
     */
    NO_DATA = 0,
    /**
     * @generated from protobuf enum value: HEALTHY = 1;
     */
    HEALTHY = 1,
    /**
     * @generated from protobuf enum value: DEGRADED = 2;
     */
    DEGRADED = 2,
    /**
     * @generated from protobuf enum value: SEVERELY_DEGRADED = 3;
     */
    SEVERELY_DEGRADED = 3
}
/**
 * Sent only in the first message from client to server (CLIENT_ASK_TO_CONNECT),
 * and the first replyfrom server to client (SERVER_CONNECT_INFO). Describes
 * capabilities of the client to the server, conversation id, and so on. Reply
 * from server to client will contain a status, indicating whether the client
 * may proceed.
 *
 * possible TODO: There should really be two of these - ClientConnectInfo and ServerConnectInfo.
 *    or at least conceptually, it should be noted that the two protocols are a union
 *    agavin notes: I'm not so bothered by a bit of overloading
 *
 * @generated from protobuf message pb.AudioMessage.ConnectInfo
 */
export interface AudioMessage_ConnectInfo {
    /**
     * Message protocol version info. Sent both ways
     *
     * @generated from protobuf field: optional uint32 major_version = 1
     */
    majorVersion?: number;
    /**
     * @generated from protobuf field: optional uint32 minor_version = 2
     */
    minorVersion?: number;
    /**
     * From server->client is an indication of the current msg_version -- not neccesary to do anything with
     *
     * @generated from protobuf field: optional uint32 msg_version = 4
     */
    msgVersion?: number;
    /**
     * Connection description. Sent both ways. When client sends to server, only 1.
     * It's repeated, because the server might send back multiple AVAILABLE
     * connections.
     * NOTE: There are a lot of speculative things in this protocol, this being one
     *   of them. I might suggest applying YAGNI.
     *
     * @generated from protobuf field: repeated pb.AudioMessage.ConnectInfo.ConnectionDesc connections = 3
     */
    connections: AudioMessage_ConnectInfo_ConnectionDesc[];
}
/**
 * Describes capabilities of the client (which could vary phone to phone, I suppose).
 * Sent only from client to server, for now. In the future, could be sent from server to client,
 * if there are 'server-specific' capabilities.
 * possible TODO: rename to ClientCapabilities?
 *
 * @generated from protobuf message pb.AudioMessage.ConnectInfo.Capabilities
 */
export interface AudioMessage_ConnectInfo_Capabilities {
    /**
     * True if audio uploaded from the client is free of speaker audio - i.e. if the client
     * can perform echo cancellation, or similar.
     *
     * @generated from protobuf field: optional bool speaker_free_audio_clusters = 1
     */
    speakerFreeAudioClusters?: boolean;
    /**
     * True if the client has the ability to monitor emitted audio and notify server of progress
     * via AudioClusterStatus messages.
     *
     * @generated from protobuf field: optional bool spoken_audio_cluster = 2
     */
    spokenAudioCluster?: boolean;
    /**
     * True if the client can send finish/interrupt commands for audio clusters.
     *
     * @generated from protobuf field: optional bool audio_cluster_finish_commands = 3
     */
    audioClusterFinishCommands?: boolean;
    /**
     * True if the client can send transferred commands for audio clusters.
     *
     * @generated from protobuf field: optional bool audio_cluster_transferred = 4
     */
    audioClusterTransferred?: boolean;
    /**
     * True if the client can pause an audio cluster before playback based on the hold time
     *
     * @generated from protobuf field: optional bool audio_cluster_playback_hold_time = 5
     */
    audioClusterPlaybackHoldTime?: boolean;
    /**
     * True if the client can't send microphone audio while speaking
     *
     * @generated from protobuf field: optional bool no_mic_during_speech = 6
     */
    noMicDuringSpeech?: boolean; // added 10/9/24
    /**
     * True if the client can handle variable sample rates for playback
     *
     * @generated from protobuf field: optional bool audio_cluster_play_var_sample_rate = 7
     */
    audioClusterPlayVarSampleRate?: boolean; // added 10/15/24
    /**
     * Client supports the msg link styling capability.
     *
     * @generated from protobuf field: optional bool supports_msg_link_style = 8
     */
    supportsMsgLinkStyle?: boolean; // added 10/18/24
    /**
     * Client supports newer cluster info block, etc
     *
     * @generated from protobuf field: optional bool cluster_info_block = 9
     */
    clusterInfoBlock?: boolean; // added 11/17/24
    /**
     * Client supports the a cluster_info and properties field on connect
     *
     * @generated from protobuf field: optional bool properties_on_connect = 10
     */
    propertiesOnConnect?: boolean; // added 1/4/25
    /**
     * Client supports the a cluster_info clusters field on connect
     *
     * @generated from protobuf field: optional bool cluster_list_on_connect = 11
     */
    clusterListOnConnect?: boolean; // added 1/4/25
    /**
     * Client supports the advanced web_gui_renderer
     *
     * @generated from protobuf field: optional bool web_gui_renderer = 12
     */
    webGuiRenderer?: boolean; // added 5/23/25
}
/**
 * information about the user account, sent Server -> client ONLY on connect. This is for display
 *   purposes only at this time
 *
 * @generated from protobuf message pb.AudioMessage.ConnectInfo.UserAccountInfo
 */
export interface AudioMessage_ConnectInfo_UserAccountInfo {
    /**
     * @generated from protobuf field: optional string full_name = 1
     */
    fullName?: string;
    /**
     * @generated from protobuf field: optional string email = 2
     */
    email?: string;
    /**
     * @generated from protobuf field: optional string phone_number = 3
     */
    phoneNumber?: string;
    /**
     * @generated from protobuf field: optional pb.AudioMessage.ConnectInfo.UserAccountInfo.UserStatus user_status = 4
     */
    userStatus?: AudioMessage_ConnectInfo_UserAccountInfo_UserStatus;
}
/**
 * ENUM_SYNC UserStatus / AudioMessageUserStatus       (text sync from UserStatus to AudioMessageUserStatus)
 *
 * @generated from protobuf enum pb.AudioMessage.ConnectInfo.UserAccountInfo.UserStatus
 */
export enum AudioMessage_ConnectInfo_UserAccountInfo_UserStatus {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * @generated from protobuf enum value: SUSPENDED = 2;
     */
    SUSPENDED = 2,
    /**
     * @generated from protobuf enum value: BANNED = 3;
     */
    BANNED = 3
}
/**
 * The status of the connection. In the first message from client to server.
 * A specification of properties of a connection or possible connection.  Used both to request and
 * to reply.
 *
 * @generated from protobuf message pb.AudioMessage.ConnectInfo.ConnectionDesc
 */
export interface AudioMessage_ConnectInfo_ConnectionDesc {
    /**
     * The new status of the connection or request for connection - sent both ways.
     *
     * @generated from protobuf field: optional pb.AudioMessage.ConnectInfo.ConnectStatus status = 1
     */
    status?: AudioMessage_ConnectInfo_ConnectStatus;
    /**
     * only sent from server to client, optional reason for connection refusal/busy etc
     *
     * @generated from protobuf field: optional pb.AudioMessage.ConnectInfo.ConnectReason reason = 10
     */
    reason?: AudioMessage_ConnectInfo_ConnectReason;
    /**
     * The conversation id. Sent from Client->Server. Should be unique
     * w/r user, possibly globally unique. Gotten during login sequence.
     * also sent server to client
     *
     * @generated from protobuf field: optional string conversation_id = 2
     */
    conversationId?: string;
    /**
     * The phone number of the client. Sent from Client->Server. Not in current use
     *  but to support looking up conversations by phone number
     *
     * @generated from protobuf field: optional string phone_number = 3
     */
    phoneNumber?: string;
    // additional fields may be added for use by request

    /**
     * The capabilities of the client. Sent from Client->Server.
     *   may be absent (no capabilities).  Will possibly be upgraded later.  Could also
     *   be put into a oneof with client and server capabilities
     *
     * @generated from protobuf field: optional pb.AudioMessage.ConnectInfo.Capabilities capabilities = 4
     */
    capabilities?: AudioMessage_ConnectInfo_Capabilities;
    /**
     * Last seq_id the client saw from the server. Optionally sent from Client->Server only
     *   deprecate with new cluster system and fold into the cluster info
     *
     * @generated from protobuf field: optional uint64 last_audio_cluster_seq_id = 5
     */
    lastAudioClusterSeqId?: string;
    /**
     * sent from Client->Server to report on the client's current cluster status
     * send back (optionally) from Server->Client to report on the server's current cluster status
     *
     * @generated from protobuf field: optional pb.AudioMessage.ClusterInfo cluster_info = 17
     */
    clusterInfo?: AudioMessage_ClusterInfo;
    /**
     * used only Client->Server to specify the preferred connection priority
     *
     * @generated from protobuf field: optional pb.AudioMessage.ConnectInfo.ConnectPriority priority = 6
     */
    priority?: AudioMessage_ConnectInfo_ConnectPriority;
    /**
     * used only Client->Server. the max_delta_id the client has on connect.  If absent, client has nothing in its cache
     *   this field is optional, but can improve initial connect performance by allowing the server to immediately send a delta block
     *
     * @generated from protobuf field: optional int64 max_delta_id = 9
     */
    maxDeltaId?: string; // added 07/01/24
    //   From client->server is 0, absent, or an indication of the msg_version under which the
    //      client first created its stored data.
    //   Put a slightly different way:
    //      - if the client has no conversation data (has never gotten a delta block) then it sends no msg_version field
    //      - when it receives a delta block, there will always be a msg_version in the delta block.  If the client has
    //        not yet stored a msg_version with the client_data it should store this value.
    //      - when reconnecting with a stored repository (it wishes to update) that HAS a msg_version, send it here
    //      - if the client is given a force reset, it nukes the local msg_version along with all the other data (other than the convo_id)
    //      - sometimes, if this version is too old for the server, after the reconnect it will send a delta block requesting
    //        a force reset to the client forcing it to dump the old data

    /**
     * @generated from protobuf field: optional uint32 msg_version = 7
     */
    msgVersion?: number;
    /**
     * identify the client type
     *
     * @generated from protobuf field: optional pb.AudioMessage.ConnectInfo.ClientType client_type = 11
     */
    clientType?: AudioMessage_ConnectInfo_ClientType; // added 10/3/24
    /**
     * identify the client build number, if relevant.  Integer version  (like build 59)
     *
     * @generated from protobuf field: optional uint32 client_build_number = 12
     */
    clientBuildNumber?: number; // added 10/3/24
    /**
     * identify the client build version, if relevant.  String version (i.e. "1.1.1")
     *
     * @generated from protobuf field: optional string client_build_version = 13
     */
    clientBuildVersion?: string; // added 10/15/24
    /**
     * identify the client build name, if relevant.  String version (i.e. "BetterNow Staging")
     *
     * @generated from protobuf field: optional string client_build_name = 14
     */
    clientBuildName?: string; // added 10/15/24
    /**
     * the string form of the client's time zone
     *
     * @generated from protobuf field: optional string client_time_zone = 15
     */
    clientTimeZone?: string; // added 11/04/24
    /**
     * identify the client device model, if relevant.  String version (i.e. "iPhone 6")
     *
     * @generated from protobuf field: optional string client_device_model = 18
     */
    clientDeviceModel?: string; // added 12/10/24
    /**
     * identify the client OS version, if relevant.  String version (i.e. "iOS 15.0")
     *
     * @generated from protobuf field: optional string client_os_version = 19
     */
    clientOsVersion?: string; // added 12/10/24
    /**
     * sent Server->Client only in the case of a successful connection
     *
     * @generated from protobuf field: optional pb.AudioMessage.ConnectInfo.UserAccountInfo user_account_info = 8
     */
    userAccountInfo?: AudioMessage_ConnectInfo_UserAccountInfo;
    /**
     * the id passed to the client to start it in pixel streaming mode
     *  this is not yet fully supported and referrs to an ID for the lifetime of a booted Unreal client
     *  multiple connect sessions might share the same app session id
     *
     * @generated from protobuf field: optional string client_app_session_id = 20
     */
    clientAppSessionId?: string;
    /**
     * the id indicating the exact reconfigure session the client is connecting for
     *   this is the 'pixel_streaming_id' or the 'session id'
     *
     * @generated from protobuf field: optional string client_connect_session_id = 21
     */
    clientConnectSessionId?: string;
    /**
     * the id indicating the launch args relevant for this session
     *  if absent, the server can pull from the connect session
     *
     * @generated from protobuf field: optional string client_launch_args_id = 22
     */
    clientLaunchArgsId?: string;
}
/**
 * The status of the connection. In the first message from client to server,
 *    value will be REQUEST.
 * In the first reply from server to client, value will
 *    be REFUSED, BUSY, or CONNECTED.
 *
 * @generated from protobuf enum pb.AudioMessage.ConnectInfo.ConnectStatus
 */
export enum AudioMessage_ConnectInfo_ConnectStatus {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * RESPONSE: server rejects this connection, connection likely not possible
     *
     * @generated from protobuf enum value: REFUSED = 1;
     */
    REFUSED = 1,
    /**
     * RESPONSE: server accepts as a valid connection
     *
     * @generated from protobuf enum value: CONNECTED = 2;
     */
    CONNECTED = 2,
    /**
     * partial RESPONSE: server offers a set of available conversations (NYI, maybe never) Used internally but not returned
     *
     * @generated from protobuf enum value: AVAILABLE = 3;
     */
    AVAILABLE = 3,
    /**
     * RESPONSE: the connection is valid, but busy and so can't be connected to at current (try again)
     *
     * @generated from protobuf enum value: BUSY = 4;
     */
    BUSY = 4,
    /**
     * CLIENT REQUEST: the client is requesting a new connection
     *
     * @generated from protobuf enum value: REQUEST = 5;
     */
    REQUEST = 5,
    /**
     * TODO: What is this?  (agavin can't remember, not in use)
     *
     * @generated from protobuf enum value: REQUESTED = 6;
     */
    REQUESTED = 6
}
/**
 * the specific reason for the connection status, only sent server->client and generally FINE unless
 *   there is a problem (BUSY, REFUSED). This is used to further clarify the reason for the connection status
 *
 * @generated from protobuf enum pb.AudioMessage.ConnectInfo.ConnectReason
 */
export enum AudioMessage_ConnectInfo_ConnectReason {
    /**
     * @generated from protobuf enum value: CR_UNKNOWN = 0;
     */
    CR_UNKNOWN = 0,
    /**
     * server is available
     *
     * @generated from protobuf enum value: FINE = 1;
     */
    FINE = 1,
    /**
     * another connection has the lock
     *
     * @generated from protobuf enum value: SERVER_OCCUPIED = 2;
     */
    SERVER_OCCUPIED = 2,
    /**
     * server is in the process of rebooting
     *
     * @generated from protobuf enum value: SERVER_REBOOTING = 3;
     */
    SERVER_REBOOTING = 3,
    /**
     * server is in the process of rebooting
     *
     * @generated from protobuf enum value: SERVER_LOCKED = 4;
     */
    SERVER_LOCKED = 4,
    /**
     * brain problem
     *
     * @generated from protobuf enum value: BRAIN_INVALID = 5;
     */
    BRAIN_INVALID = 5,
    /**
     * user has been banned
     *
     * @generated from protobuf enum value: USER_BANNED = 6;
     */
    USER_BANNED = 6,
    /**
     * account mismatch of some sort (like convo and user id mismatch)
     *
     * @generated from protobuf enum value: USER_INVALID = 7;
     */
    USER_INVALID = 7,
    /**
     * bad conversation
     *
     * @generated from protobuf enum value: CONVO_INVALID = 8;
     */
    CONVO_INVALID = 8,
    /**
     * ill formed request
     *
     * @generated from protobuf enum value: REQUEST_INVALID = 9;
     */
    REQUEST_INVALID = 9
}
/**
 * @generated from protobuf enum pb.AudioMessage.ConnectInfo.ConnectPriority
 */
export enum AudioMessage_ConnectInfo_ConnectPriority {
    /**
     * @generated from protobuf enum value: CP_UNKNOWN = 0;
     */
    CP_UNKNOWN = 0,
    /**
     * server will accept if it can
     *
     * @generated from protobuf enum value: IF_AVAIL = 1;
     */
    IF_AVAIL = 1,
    /**
     * server will knock another client off
     *
     * @generated from protobuf enum value: FORCE = 2;
     */
    FORCE = 2,
    /**
     * server can knock another client off and will reboot the brain first
     *
     * @generated from protobuf enum value: FORCE_AND_RESTART = 3;
     */
    FORCE_AND_RESTART = 3
}
/**
 * @generated from protobuf enum pb.AudioMessage.ConnectInfo.ClientType
 */
export enum AudioMessage_ConnectInfo_ClientType {
    /**
     * @generated from protobuf enum value: CT_UNKNOWN = 0;
     */
    CT_UNKNOWN = 0,
    /**
     * ios client
     *
     * @generated from protobuf enum value: IOS = 1;
     */
    IOS = 1,
    /**
     * puppet client
     *
     * @generated from protobuf enum value: PYTHON = 2;
     */
    PYTHON = 2,
    /**
     * the unreal client
     *
     * @generated from protobuf enum value: UNREAL = 3;
     */
    UNREAL = 3,
    /**
     * the unreal client actively connected to a pixel streaming signalling server
     *
     * @generated from protobuf enum value: UNREAL_PIXEL_STREAMING = 4;
     */
    UNREAL_PIXEL_STREAMING = 4,
    /**
     * an audio-only client from the pixels webapp frontend
     *
     * @generated from protobuf enum value: PIXELS_WEBAPP = 5;
     */
    PIXELS_WEBAPP = 5,
    /**
     * the unreal client running on the game lift streams
     *
     * @generated from protobuf enum value: UNREAL_GAME_LIFT_STREAMS = 6;
     */
    UNREAL_GAME_LIFT_STREAMS = 6
}
/**
 * Contains the actual audio waveform data.
 * TODO: What about interleaving if channel_count > 1?
 * TODO: move cluster_seq_id, cluster_sample_max, cluster_sample_offset here?
 *
 * @generated from protobuf message pb.AudioMessage.Audio
 */
export interface AudioMessage_Audio {
    // // Only the first packet of a cluster

    /**
     * the ear mode of the packet.
     *   Only for uploading packets
     * Currently sent for all packets in the cluster, although conceptually a feature of the first
     *   Should be the same for all packets in a cluster
     *   default (if ommited is CONVERSATION)
     *
     * @generated from protobuf field: optional pb.AudioMessage.EarMode ear_mode = 11
     */
    earMode?: AudioMessage_EarMode; // new 8/17/24
    /**
     * the human speaker for the packet.
     *   Only for uploading packets
     * Currently sent for all packets in the cluster, although conceptually a feature of the first
     *   Should be the same for all packets in a cluster
     *   default (if ommited is the focused main human)
     *
     * @generated from protobuf field: optional string speaker_uid = 16
     */
    speakerUid?: string; // new 1/16/25
    /**
     * downloading packets only
     * if present, the seconds to delay before playing this cluster
     *  to be deprecated with the cluster_info
     *
     * @generated from protobuf field: optional float hold_time = 14
     */
    holdTime?: number; // new 10/03/24
    /**
     * downloading packets only
     * if present, the msg_uid associated with this audio cluster
     *   not neccesarily present, as not all audio clusters are associated with a message
     *  to be deprecated with the cluster_info
     *
     * @generated from protobuf field: optional string msg_uid = 12
     */
    msgUid?: string; // new 10/03/24
    /**
     * downloading packets only
     * if present, the texture transcript of this packet
     *   not neccesarily present, as not all audio clusters have a transcript
     *  to be deprecated with the cluster_info
     *
     * @generated from protobuf field: optional string transcript = 13
     */
    transcript?: string; // new 10/03/24
    /**
     * Emotion tagged to this audio. Sent only from server to client.
     *  optional
     *  this indicates the emotion the utterance (or this part of the utterance) was run thru TTS with
     *  to be deprecated with the cluster_info   (will be replaced with a reserved 9)
     *
     * @generated from protobuf field: optional pb.AudioMessage.AvatarEmotion emotion = 9
     */
    emotion?: AudioMessage_AvatarEmotion;
    // // Only the last packet of a cluster

    /**
     * signals that this is the last audio packet in a cluster
     *
     * @generated from protobuf field: optional bool cluster_end = 10
     */
    clusterEnd?: boolean; // new 8/14/24
    // // in most/all packets

    /**
     * The sample rate of the audio waveform, defaults to 48 Khz (48000).
     *
     * @generated from protobuf field: optional uint32 sample_rate = 1
     */
    sampleRate?: number;
    /**
     * Number of audio channels - defaults to 1.
     *
     * @generated from protobuf field: optional uint32 channel_count = 2
     */
    channelCount?: number;
    /**
     * Bit depth per sample - defaults to 16.
     * possible TODO: rename bits_per_sample? or bit_depth?
     *
     * @generated from protobuf field: optional uint32 bits_per_channel = 3
     */
    bitsPerChannel?: number;
    /**
     * The encoding of the audio waveform. Defaults to PCM.
     *
     * @generated from protobuf field: optional pb.AudioMessage.Audio.AudioEncoding encoding = 4
     */
    encoding?: AudioMessage_Audio_AudioEncoding;
    /**
     * How many sample frames within this Audio message (multiple channels do not increase the sample_count)
     *
     * @generated from protobuf field: optional uint32 sample_count = 5
     */
    sampleCount?: number;
    /**
     * The optional 0.0-1.0 volume of the packet. Can be computed with RMS from the PCM data
     *
     * @generated from protobuf field: optional float volume = 6
     */
    volume?: number;
    /**
     * True if the client has somehow determined that the user is actually speaking this frame (via vad)
     *
     * @generated from protobuf field: optional bool vad_talking = 8
     */
    vadTalking?: boolean;
    /**
     * time in milliseconds since epoch when the audio was recorded
     *  exact definition is client determined, but is ideally the ADC time, but can also be
     *  the audio thread callback time from the mic
     *
     * @generated from protobuf field: optional int64 recorded_at_ms = 15
     */
    recordedAtMs?: string; // new 11/21/24
    /**
     * The actual audio waveform data, as a byte array.
     * Length should = sample_count * channel_count * bits_per_channel / 8.
     *
     * @generated from protobuf field: optional bytes audio_data = 7
     */
    audioData?: Uint8Array;
    /**
     * Events (such as word starts), timestamp-aligned to the audio.
     * The client might receive these projecting into the future
     * even before having received the full audio.
     *
     * @generated from protobuf field: repeated pb.AudioMessage.Audio.AlignedEvent aligned_events = 17
     */
    alignedEvents: AudioMessage_Audio_AlignedEvent[]; // new 1/23/25
}
/**
 * Events, such as word starts, timestamp-aligned to the audio.
 *
 * @generated from protobuf message pb.AudioMessage.Audio.AlignedEvent
 */
export interface AudioMessage_Audio_AlignedEvent {
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Audio.AlignedEvent.Type type = 1
     */
    type?: AudioMessage_Audio_AlignedEvent_Type;
    /**
     * @generated from protobuf field: optional string word = 2
     */
    word?: string;
    /**
     * @generated from protobuf field: optional int32 event_start_ms = 3
     */
    eventStartMs?: number;
    /**
     * @generated from protobuf field: optional int32 event_duration_ms = 4
     */
    eventDurationMs?: number;
}
/**
 * @generated from protobuf enum pb.AudioMessage.Audio.AlignedEvent.Type
 */
export enum AudioMessage_Audio_AlignedEvent_Type {
    /**
     * @generated from protobuf enum value: INVALID = 0;
     */
    INVALID = 0,
    /**
     * @generated from protobuf enum value: WORD_START = 1;
     */
    WORD_START = 1,
    /**
     * @generated from protobuf enum value: WORD_END = 2;
     */
    WORD_END = 2
}
/**
 * On-the-wire format of the audio waveform. Could be expanded to include
 * different formats in the future.
 *
 * @generated from protobuf enum pb.AudioMessage.Audio.AudioEncoding
 */
export enum AudioMessage_Audio_AudioEncoding {
    /**
     * @generated from protobuf enum value: NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: PCM = 1;
     */
    PCM = 1
}
/**
 * Describes/Contains a text or image message sent from client to server, or server to client.
 * When the client sends such a message, it will populated 'client_msg_uid' with a
 * unique id (probably just a UUID string-ified). The server will then echo back
 * the entire message, this time populated with a msg_uid (and the server can potentially
 * censor the text). In this way, a client-side Msg only becomes 'finished' when it gets
 * echoed back to the client (via a msg or delta block)
 * NOTE: it is possible for the server to split a uploaded message into multiple messages on the
 *  the backend resulting in TWO or more unique msg_uid for the same (sorta) client_msg_uid.  msg_uid's are
 *  always unique.
 * NOTE: when the server splits client_msg_uid's into multiple messages, it will actually return client_msg_uid
 *  msgs with the format old_client_msg_uid:xx  (where xx is 0, 1, etc)   these should match against the old one
 *  the :0 replaces the original and the others insert in order following it. This mildly complex code is in check_update_msg
 *
 * @generated from protobuf message pb.AudioMessage.Msg
 */
export interface AudioMessage_Msg {
    /**
     * The type of the message (aligned with the payload), default is informally TEXT.
     *
     * @generated from protobuf field: optional pb.AudioMessage.Msg.Type type = 2
     */
    type?: AudioMessage_Msg_Type;
    /**
     * The unique id of the message (session:id), created by the server.
     *  Absent in a client generated message
     *
     * @generated from protobuf field: optional string msg_uid = 3
     */
    msgUid?: string;
    /**
     * The unique id of the message, created by the client, if the message was created by
     * the client. If so, there will be no msg_uid when the client sends the message to the
     * server. The server will then echo back the message, this time with a msg_uid.
     * client_msg_uid will remain in echoed messages.
     *  client_msg_uid is absent in server created messages
     *
     * @generated from protobuf field: optional string client_msg_uid = 4
     */
    clientMsgUid?: string;
    /**
     * if present, this is the msg_uid of the first message in the "turn"
     * if not there, this is the first (or only) message in the turn
     * only the bot groups messages into turns at present
     * the first message will always be in the same session
     *
     * @generated from protobuf field: optional string turn_first_msg_uid = 14
     */
    turnFirstMsgUid?: string; // new 6/25/24
    /**
     * At current bot=0, human=1, narrator=2, console=5
     * TODO: needs some fix. How to deal with multiple speakers.
     *   this is a temporary solition.
     *
     * @generated from protobuf field: optional pb.AudioMessage.Msg.Speaker speaker_id = 5
     */
    speakerId?: AudioMessage_Msg_Speaker;
    /**
     * the specific uid of the speaker (currently upload only)
     *
     * @generated from protobuf field: optional string speaker_uid = 18
     */
    speakerUid?: string; // new 1/16/25
    /**
     * Time since epoch in milliseconds.
     * QUESTION: is it always GMT+0?
     * the time is ALWAYS set by the server.  Any uploaded time is ignored and the canonnical time is
     * created by the brain as it creates the ChatMsg object
     *
     * @generated from protobuf field: optional int64 created_at = 6
     */
    createdAt?: string;
    /**
     * the modality of the original message (was it typed, or heard/spoken)
     * optional, and if absent, assumed to be text
     * this is not a specification of encoding, but an indication of the original source
     * for user messages MOD_TEXT was typed, MOD_AUDIO was spoken into the mic
     * for bot messages MOD_TEXT was typed, MOD_AUDIO was spoken via TTS
     *
     * @generated from protobuf field: optional pb.AudioMessage.Msg.Modality modality = 9
     */
    modality?: AudioMessage_Msg_Modality; // new 5/3/24
    /**
     * The actual text or media ref of the message.
     *
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "text";
        /**
         * @generated from protobuf field: pb.AudioMessage.Msg.MsgText text = 7
         */
        text: AudioMessage_Msg_MsgText;
    } | {
        oneofKind: "media";
        /**
         * @generated from protobuf field: pb.AudioMessage.Msg.MsgMedia media = 8
         */
        media: AudioMessage_Msg_MsgMedia;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated pb.AudioMessage.Msg.MsgLink links = 15
     */
    links: AudioMessage_Msg_MsgLink[]; // new 7/6/24
    /**
     * @generated from protobuf field: repeated pb.AudioMessage.Msg.MsgButton buttons = 17
     */
    buttons: AudioMessage_Msg_MsgButton[]; // new 8/20/24
    /**
     * @generated from protobuf field: repeated pb.AudioMessage.Msg.MsgAnnotation annotations = 10
     */
    annotations: AudioMessage_Msg_MsgAnnotation[]; // new 5/6/24
    // TODO: remove entirely:
    // client fields not in the actual protocol  (these are more thoughts)
    // int64 reflected_delta_id;       // any delta id below this should be ignored as it has already been applied
    // bool deleted;                    // is this a deleted message?

    // for client->server command msgs only

    /**
     * when the user typed in or initiated the msg, to make sure we don't apply one that is too old
     *   this is the datetime at which the user took the action for the msg (like hit send etc)
     *
     * @generated from protobuf field: optional int64 client_created_at = 11
     */
    clientCreatedAt?: string; // new 5/14/24
    /**
     * the delta id the user had at the time of creation, to make sure we don't apply one that is too old
     *   this is a snapshot of the user's max_delta_id at the time of the action. It never updates. That way
     *   if the message is stored for some extended period of time the server will be able to determine if it
     *   represents a very old delta state that can't easily check if the client_msg_uid is unique
     *
     * @generated from protobuf field: optional int64 client_max_delta_id = 12
     */
    clientMaxDeltaId?: string; // new 5/14/24
    /**
     * if absent, defaults to False. Used by the server to indicate messages which
     * the client should not allow the user to annotate, leave feedback on, or regen
     *
     * @generated from protobuf field: optional bool suppress_user_changes = 16
     */
    suppressUserChanges?: boolean; // new 7/8/24
}
/**
 * The actual text of the message, if Type == TEXT.
 *
 * @generated from protobuf message pb.AudioMessage.Msg.MsgText
 */
export interface AudioMessage_Msg_MsgText {
    /**
     * @generated from protobuf field: optional string payload = 1
     */
    payload?: string;
}
/**
 * A reference to the image/media in the message, if Type == IMAGE or AUDIO
 *
 * @generated from protobuf message pb.AudioMessage.Msg.MsgMedia
 */
export interface AudioMessage_Msg_MsgMedia {
    /**
     * Some URI pointing to the image.
     *
     * @generated from protobuf field: optional string media_path = 1
     */
    mediaPath?: string;
    /**
     * The type of the path - BLOB or URL.
     *
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgMedia.PathType path_type = 2
     */
    pathType?: AudioMessage_Msg_MsgMedia_PathType;
    /**
     * The mimetype of the image/media
     *  typically "image/jpeg" or similar
     *
     * @generated from protobuf field: optional string content_type = 3
     */
    contentType?: string;
    /**
     * The caption of the image. This adds text that is part of the same conceptual message as the image
     * NOTE: as of 5/3/24 images uploaded with a caption may be converted on the server into TWO Msgs:
     *  one for the image itself and one for the caption.  TODO: only convert to one.   But it should be noted
     *  that it is allowed for multiple unique msg_uids to come back for a single client_uid
     *
     * @generated from protobuf field: optional string caption = 4
     */
    caption?: string;
    /**
     * The description of the asset, generated by AI most likely.
     *  This is the textual description of the media and would generally not be sent to or presented to the user
     *
     * @generated from protobuf field: optional string description = 5
     */
    description?: string;
}
/**
 * The path to the media. The value could be URL,
 * which is a public URL to an image, or it could be
 * BLOB, which is a path to an internal blob store.
 *
 * @generated from protobuf enum pb.AudioMessage.Msg.MsgMedia.PathType
 */
export enum AudioMessage_Msg_MsgMedia_PathType {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * internal blob store
     *
     * @generated from protobuf enum value: BLOB = 1;
     */
    BLOB = 1,
    /**
     * public url
     *
     * @generated from protobuf enum value: URL = 2;
     */
    URL = 2
}
/**
 * A reference to an attached link in the message
 *
 * @generated from protobuf message pb.AudioMessage.Msg.MsgLink
 */
export interface AudioMessage_Msg_MsgLink {
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgLink.Type link_type = 1
     */
    linkType?: AudioMessage_Msg_MsgLink_Type; // currently only the url type is supported
    /**
     * @generated from protobuf field: optional string icon_name = 6
     */
    iconName?: string;
    /**
     * @generated from protobuf field: optional string title = 3
     */
    title?: string;
    /**
     * @generated from protobuf field: optional string description = 4
     */
    description?: string;
    /**
     * @generated from protobuf field: optional string url = 5
     */
    url?: string;
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgLink.LinkStyle link_style = 7
     */
    linkStyle?: AudioMessage_Msg_MsgLink_LinkStyle; // new 10/18/24
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgLink.RequirementCheck requirement_check = 8
     */
    requirementCheck?: AudioMessage_Msg_MsgLink_RequirementCheck; // new 10/18/24
}
/**
 * @generated from protobuf message pb.AudioMessage.Msg.MsgLink.RequirementCheck
 */
export interface AudioMessage_Msg_MsgLink_RequirementCheck {
    /**
     * @generated from protobuf field: pb.AudioMessage.DevicePermissionType permission = 1
     */
    permission: AudioMessage_DevicePermissionType;
    /**
     * human readable messages on behavior of the user
     *
     * @generated from protobuf field: optional string check_yes_response = 2
     */
    checkYesResponse?: string;
    /**
     * @generated from protobuf field: optional string check_no_response = 3
     */
    checkNoResponse?: string; // TODO: failure message to send back to the server?
}
/**
 * ENUM_SYNC LinkRef / AudioMessageMsgLinkType   (1:1 direct conversion)
 *
 * @generated from protobuf enum pb.AudioMessage.Msg.MsgLink.Type
 */
export enum AudioMessage_Msg_MsgLink_Type {
    /**
     * @generated from protobuf enum value: UNKNOWN_TYPE = 0;
     */
    UNKNOWN_TYPE = 0,
    /**
     * standand url, may contain a prefix before the colon  (phone numbers should be encoded as tel:1234567890)
     *
     * @generated from protobuf enum value: URL = 1;
     */
    URL = 1,
    /**
     * url is the email address, title is the subject, desc what to show
     *
     * @generated from protobuf enum value: EMAIL = 2;
     */
    EMAIL = 2,
    /**
     * url is ignored, assumed to be absent or contain empty string
     *
     * @generated from protobuf enum value: NONE = 3;
     */
    NONE = 3
}
/**
 * database has both a link_style and an icon_style  clients currently only get link_style
 * ENUM_SYNC LinkRefLinkStyle / AudioMessageMsgLinkStyle   (1:1 direct conversion)
 *
 * @generated from protobuf enum pb.AudioMessage.Msg.MsgLink.LinkStyle
 */
export enum AudioMessage_Msg_MsgLink_LinkStyle {
    /**
     * @generated from protobuf enum value: STYLE_UNSPECIFIED = 0;
     */
    STYLE_UNSPECIFIED = 0,
    /**
     * default for messages before 10/18
     *
     * @generated from protobuf enum value: LINK = 1;
     */
    LINK = 1,
    /**
     * new 10/18/24
     *
     * @generated from protobuf enum value: FILLED_BUTTON = 2;
     */
    FILLED_BUTTON = 2,
    /**
     * new 10/18/24
     *
     * @generated from protobuf enum value: OUTLINE_BUTTON = 3;
     */
    OUTLINE_BUTTON = 3
}
/**
 * A reference to an attached UI button message
 *
 * MsgButton is a Suggested Response! For real "buttons"; see MsgLink
 *
 * @generated from protobuf message pb.AudioMessage.Msg.MsgButton
 */
export interface AudioMessage_Msg_MsgButton {
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgButton.Type button_type = 1
     */
    buttonType?: AudioMessage_Msg_MsgButton_Type; // currently only the url type is supported
    /**
     * @generated from protobuf field: optional string button_text = 2
     */
    buttonText?: string;
}
/**
 * ENUM_SYNC ButtonRef / AudioMessageMsgButtonType   (1:1 direct conversion)
 *
 * @generated from protobuf enum pb.AudioMessage.Msg.MsgButton.Type
 */
export enum AudioMessage_Msg_MsgButton_Type {
    /**
     * @generated from protobuf enum value: UNKNOWN_TYPE = 0;
     */
    UNKNOWN_TYPE = 0,
    /**
     * text button and the default, insert in as a message
     *
     * @generated from protobuf enum value: MSG_TEXT = 1;
     */
    MSG_TEXT = 1
}
/**
 * @generated from protobuf message pb.AudioMessage.Msg.MsgAnnotation
 */
export interface AudioMessage_Msg_MsgAnnotation {
    /**
     * the category of the annotation
     *
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgAnnotation.Category category = 1
     */
    category?: AudioMessage_Msg_MsgAnnotation_Category;
    /**
     * the user who made the annotation
     *
     * @generated from protobuf field: optional pb.AudioMessage.Msg.Speaker speaker_id = 2
     */
    speakerId?: AudioMessage_Msg_Speaker;
    /**
     * the timestamp of the annotation, assigned by the server
     *
     * @generated from protobuf field: optional int64 timestamp = 3
     */
    timestamp?: string;
    /**
     * actions are only stored in the delta form of the Msg, not the actual Msg
     *
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgAnnotation.Action action = 4
     */
    action?: AudioMessage_Msg_MsgAnnotation_Action;
    /**
     * the value of the annotation
     *
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "reaction";
        /**
         * @generated from protobuf field: pb.AudioMessage.Msg.MsgAnnotation.Reaction reaction = 5
         */
        reaction: AudioMessage_Msg_MsgAnnotation_Reaction;
    } | {
        oneofKind: "feedback";
        /**
         * @generated from protobuf field: pb.AudioMessage.Msg.MsgAnnotation.Feedback feedback = 6
         */
        feedback: AudioMessage_Msg_MsgAnnotation_Feedback;
    } | {
        oneofKind: "violation";
        /**
         * @generated from protobuf field: pb.AudioMessage.Msg.MsgAnnotation.Violation violation = 7
         */
        violation: AudioMessage_Msg_MsgAnnotation_Violation;
    } | {
        oneofKind: undefined;
    };
}
/**
 * ENUM_SYNC ChatAnnotationReaction / AudioMessageMsgAnnotationReaction   (1:1 direct conversion)
 *
 * @generated from protobuf message pb.AudioMessage.Msg.MsgAnnotation.Reaction
 */
export interface AudioMessage_Msg_MsgAnnotation_Reaction {
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgAnnotation.Reaction.ReactionValue value = 1
     */
    value?: AudioMessage_Msg_MsgAnnotation_Reaction_ReactionValue;
}
/**
 * @generated from protobuf enum pb.AudioMessage.Msg.MsgAnnotation.Reaction.ReactionValue
 */
export enum AudioMessage_Msg_MsgAnnotation_Reaction_ReactionValue {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: LOVE = 1;
     */
    LOVE = 1,
    /**
     * @generated from protobuf enum value: LIKE = 2;
     */
    LIKE = 2,
    /**
     * @generated from protobuf enum value: CRY = 3;
     */
    CRY = 3,
    /**
     * @generated from protobuf enum value: THINK = 4;
     */
    THINK = 4,
    /**
     * @generated from protobuf enum value: LOL = 5;
     */
    LOL = 5,
    /**
     * @generated from protobuf enum value: QUESTION = 6;
     */
    QUESTION = 6,
    /**
     * @generated from protobuf enum value: RAGE = 7;
     */
    RAGE = 7
}
/**
 * ENUM_SYNC ChatAnnotationFeedback / AudioMessageMsgAnnotationFeedback   (1:1 direct conversion)
 *
 * @generated from protobuf message pb.AudioMessage.Msg.MsgAnnotation.Feedback
 */
export interface AudioMessage_Msg_MsgAnnotation_Feedback {
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgAnnotation.Feedback.FeedbackValue value = 1
     */
    value?: AudioMessage_Msg_MsgAnnotation_Feedback_FeedbackValue;
}
/**
 * @generated from protobuf enum pb.AudioMessage.Msg.MsgAnnotation.Feedback.FeedbackValue
 */
export enum AudioMessage_Msg_MsgAnnotation_Feedback_FeedbackValue {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: THUMBS_UP = 1;
     */
    THUMBS_UP = 1,
    /**
     * @generated from protobuf enum value: THUMBS_DOWN = 2;
     */
    THUMBS_DOWN = 2
}
/**
 * ENUM_SYNC ChatAnnotationViolation / AudioMessageMsgAnnotationViolation   (1:1 direct conversion)
 *
 * @generated from protobuf message pb.AudioMessage.Msg.MsgAnnotation.Violation
 */
export interface AudioMessage_Msg_MsgAnnotation_Violation {
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Msg.MsgAnnotation.Violation.ViolationValue value = 1
     */
    value?: AudioMessage_Msg_MsgAnnotation_Violation_ViolationValue;
}
/**
 * @generated from protobuf enum pb.AudioMessage.Msg.MsgAnnotation.Violation.ViolationValue
 */
export enum AudioMessage_Msg_MsgAnnotation_Violation_ViolationValue {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * should review
     *
     * @generated from protobuf enum value: REVIEW = 1;
     */
    REVIEW = 1,
    /**
     * a warning
     *
     * @generated from protobuf enum value: WARNING = 2;
     */
    WARNING = 2,
    /**
     * TOS violation
     *
     * @generated from protobuf enum value: TOS = 3;
     */
    TOS = 3,
    /**
     * self or other harm violation
     *
     * @generated from protobuf enum value: HARM = 4;
     */
    HARM = 4,
    /**
     * csam violation
     *
     * @generated from protobuf enum value: CSAM = 5;
     */
    CSAM = 5,
    /**
     * rights violation
     *
     * @generated from protobuf enum value: RIGHTS = 6;
     */
    RIGHTS = 6
}
/**
 * ENUM_SYNC ChatAnnotationAction / AudioMessageMsgAnnotationAction   (1:1 direct conversion)
 *
 * @generated from protobuf enum pb.AudioMessage.Msg.MsgAnnotation.Action
 */
export enum AudioMessage_Msg_MsgAnnotation_Action {
    /**
     * @generated from protobuf enum value: ACT_UNKNOWN = 0;
     */
    ACT_UNKNOWN = 0,
    /**
     * add the annotation
     *
     * @generated from protobuf enum value: ADD = 1;
     */
    ADD = 1,
    /**
     * remove the annotation
     *
     * @generated from protobuf enum value: REMOVE = 2;
     */
    REMOVE = 2
}
/**
 * ENUM_SYNC ChatAnnotationCategory / AudioMessageMsgAnnotationCategory   (1:1 direct conversion)
 *
 * @generated from protobuf enum pb.AudioMessage.Msg.MsgAnnotation.Category
 */
export enum AudioMessage_Msg_MsgAnnotation_Category {
    /**
     * @generated from protobuf enum value: CAT_UNKNOWN = 0;
     */
    CAT_UNKNOWN = 0,
    /**
     * reaction to a msg
     *
     * @generated from protobuf enum value: REACTION = 1;
     */
    REACTION = 1,
    /**
     * feedback on a msg
     *
     * @generated from protobuf enum value: FEEDBACK = 2;
     */
    FEEDBACK = 2,
    /**
     * violation notes
     *
     * @generated from protobuf enum value: VIOLATION = 3;
     */
    VIOLATION = 3
}
/**
 * Type of the message - text or media file (image, audio)
 * Defaults to TEXT.  Frequently not present, as it is assumed to be TEXT.  UNKNOWN is different as that
 *   is value indicating a message a client should not display as it's of a newer or older type
 * spoken conversational audio is NOT uploaded via Msg.  The server will generate Msgs for it
 *  based on transcription on the backend.
 * ENUM_SYNC MessageContentType / AudioMessageMsgType   (very loosely synced)
 *
 * @generated from protobuf enum pb.AudioMessage.Msg.Type
 */
export enum AudioMessage_Msg_Type {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * embeded text
     *
     * @generated from protobuf enum value: TEXT = 1;
     */
    TEXT = 1,
    /**
     * a reference to an image file
     *
     * @generated from protobuf enum value: IMAGE = 2;
     */
    IMAGE = 2,
    /**
     * recorded audio file, not yet implemented
     *
     * @generated from protobuf enum value: AUDIO = 3;
     */
    AUDIO = 3,
    /**
     * internal for Bella to see some annotation, not yet implemented, client should not display
     *
     * @generated from protobuf enum value: ANNOTATION = 4;
     */
    ANNOTATION = 4,
    /**
     * system text
     *
     * @generated from protobuf enum value: TEXT_SYSTEM = 5;
     */
    TEXT_SYSTEM = 5
}
/**
 * the modality by which the message was encoded/delivered.
 *  contains the MOD_ prefix because protobuf kinda sucks at some things
 * ENUM_SYNC ChatModality / AudioMessageMsgModality     (formal conversion)
 *
 * @generated from protobuf enum pb.AudioMessage.Msg.Modality
 */
export enum AudioMessage_Msg_Modality {
    /**
     * @generated from protobuf enum value: MOD_UNKNOWN = 0;
     */
    MOD_UNKNOWN = 0,
    /**
     * text
     *
     * @generated from protobuf enum value: MOD_TEXT = 1;
     */
    MOD_TEXT = 1,
    /**
     * audio
     *
     * @generated from protobuf enum value: MOD_AUDIO = 2;
     */
    MOD_AUDIO = 2
}
/**
 * ENUM_SYNC ChatSpeakerNum / AudioMessageMsgSpeaker     (they line up, so direct conversion)
 *
 * @generated from protobuf enum pb.AudioMessage.Msg.Speaker
 */
export enum AudioMessage_Msg_Speaker {
    /**
     * @generated from protobuf enum value: SPK_UNKNOWN = 0;
     */
    SPK_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: HUMAN = 1;
     */
    HUMAN = 1,
    /**
     * @generated from protobuf enum value: BOT = 2;
     */
    BOT = 2,
    /**
     * @generated from protobuf enum value: NARRATOR = 3;
     */
    NARRATOR = 3,
    /**
     * @generated from protobuf enum value: CONSOLE = 5;
     */
    CONSOLE = 5
}
/**
 * Contains a msg change, sent from server to client.
 * If the Type is ADD, then the message will contain a Msg in it's payload.
 * No other types are currently implemented, but in the future: if the Type is DELETE,
 * then the message will contain a msg_uid in it's payload, and MODIFY will contain
 * something. Either full replaced Msg, or a diff. TBD.
 *
 * @generated from protobuf message pb.AudioMessage.MsgDelta
 */
export interface AudioMessage_MsgDelta {
    /**
     * Unique, ascending id of the delta.
     * ANSWER: it would never be negative, but is of the same type as the max_delta_id for consistency
     *
     * @generated from protobuf field: optional int64 delta_id = 1
     */
    deltaId?: string;
    /**
     * The type of the delta.
     *
     * @generated from protobuf field: optional pb.AudioMessage.MsgDelta.Type type = 2
     */
    type?: AudioMessage_MsgDelta_Type;
    /**
     * The actual message, if the Type is ADD or ANNOTATE
     *
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "message";
        /**
         * @generated from protobuf field: pb.AudioMessage.Msg message = 3
         */
        message: AudioMessage_Msg;
    } | {
        oneofKind: undefined;
    };
}
/**
 * this enum must stay in sync with Type in ConversationDelta in models.conversation_deltas.py
 * ENUM_SYNC ConversationDeltaType / AudioMessageMsgDeltaType   (by raw coercion as enums match)
 *
 * @generated from protobuf enum pb.AudioMessage.MsgDelta.Type
 */
export enum AudioMessage_MsgDelta_Type {
    /**
     * @generated from protobuf enum value: NOP = 0;
     */
    NOP = 0,
    /**
     * @generated from protobuf enum value: ADD = 1;
     */
    ADD = 1,
    /**
     * @generated from protobuf enum value: MODIFY = 2;
     */
    MODIFY = 2,
    /**
     * @generated from protobuf enum value: DELETE = 3;
     */
    DELETE = 3,
    /**
     * @generated from protobuf enum value: ANNOTATE = 4;
     */
    ANNOTATE = 4
}
/**
 * Commands are sent from client to server, or server to client.
 * They are used for debugging and 'logistical control' - for instance,
 * the server can tell the client when to show message bubbles, the client
 * can tell the server when it's finished playing a particular audio cluster,
 * the client can request more message during 'scrollback', etc.
 * Each Type will allow different payloads.
 *
 * @generated from protobuf message pb.AudioMessage.Command
 */
export interface AudioMessage_Command {
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Command.Type type = 1
     */
    type?: AudioMessage_Command_Type;
    /**
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "basic";
        /**
         * @generated from protobuf field: pb.AudioMessage.Command.Basic basic = 2
         */
        basic: AudioMessage_Command_Basic;
    } | {
        oneofKind: "msg";
        /**
         * @generated from protobuf field: pb.AudioMessage.Command.MsgWrap msg = 3
         */
        msg: AudioMessage_Command_MsgWrap;
    } | {
        oneofKind: "msgRange";
        /**
         * @generated from protobuf field: pb.AudioMessage.Command.MsgRange msg_range = 4
         */
        msgRange: AudioMessage_Command_MsgRange;
    } | {
        oneofKind: "clusterIdList";
        /**
         * @generated from protobuf field: pb.AudioMessage.Command.ClusterIDs cluster_id_list = 5
         */
        clusterIdList: AudioMessage_Command_ClusterIDs;
    } | {
        oneofKind: "clusterStatus";
        /**
         * @generated from protobuf field: pb.AudioMessage.AudioClusterStatus cluster_status = 6
         */
        clusterStatus: AudioMessage_AudioClusterStatus;
    } | {
        oneofKind: "feedback";
        /**
         * @generated from protobuf field: pb.AudioMessage.Command.FeedbackWrap feedback = 7
         */
        feedback: AudioMessage_Command_FeedbackWrap;
    } | {
        oneofKind: "system";
        /**
         * @generated from protobuf field: pb.AudioMessage.Command.SystemWrap system = 8
         */
        system: AudioMessage_Command_SystemWrap;
    } | {
        oneofKind: "targetUser";
        /**
         * @generated from protobuf field: pb.AudioMessage.Command.TargetUser target_user = 9
         */
        targetUser: AudioMessage_Command_TargetUser;
    } | {
        oneofKind: "clusterProperties";
        /**
         * @generated from protobuf field: pb.AudioMessage.ClusterProperties cluster_properties = 10
         */
        clusterProperties: AudioMessage_ClusterProperties;
    } | {
        oneofKind: undefined;
    };
}
/**
 * Some commands contain a message.
 *
 * @generated from protobuf message pb.AudioMessage.Command.Feedback
 */
export interface AudioMessage_Command_Feedback {
    /**
     * msg_uid of the message that the feedback is about
     *
     * @generated from protobuf field: optional string msg_uid = 1
     */
    msgUid?: string;
    /**
     * the client_msg_uid is new and specific to the feedback itself, for the purposes of ACKs
     *
     * @generated from protobuf field: optional string client_msg_uid = 2
     */
    clientMsgUid?: string;
    /**
     * the optional comment string for the feedback
     *
     * @generated from protobuf field: optional string comment = 3
     */
    comment?: string;
    /**
     * an optional list of tags for the feedback
     *
     * @generated from protobuf field: repeated pb.AudioMessage.Command.Feedback.Tag tags = 4
     */
    tags: AudioMessage_Command_Feedback_Tag[];
}
/**
 * @generated from protobuf enum pb.AudioMessage.Command.Feedback.Tag
 */
export enum AudioMessage_Command_Feedback_Tag {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: INTERESTING = 1;
     */
    INTERESTING = 1,
    /**
     * @generated from protobuf enum value: HELPFUL = 2;
     */
    HELPFUL = 2,
    /**
     * @generated from protobuf enum value: INSPIRING = 3;
     */
    INSPIRING = 3,
    /**
     * @generated from protobuf enum value: FUNNY = 4;
     */
    FUNNY = 4,
    /**
     * @generated from protobuf enum value: IRRELEVANT = 5;
     */
    IRRELEVANT = 5,
    /**
     * @generated from protobuf enum value: INACCURATE = 6;
     */
    INACCURATE = 6,
    /**
     * @generated from protobuf enum value: REPETETIVE = 7;
     */
    REPETETIVE = 7,
    /**
     * @generated from protobuf enum value: HARMFUL = 8;
     */
    HARMFUL = 8,
    /**
     * @generated from protobuf enum value: OFFENSIVE = 9;
     */
    OFFENSIVE = 9,
    /**
     * @generated from protobuf enum value: TECHNICAL_ISSUE = 10;
     */
    TECHNICAL_ISSUE = 10,
    /**
     * @generated from protobuf enum value: OTHER = 11;
     */
    OTHER = 11
}
/**
 * Some commands carry just a string.
 *
 * @generated from protobuf message pb.AudioMessage.Command.Basic
 */
export interface AudioMessage_Command_Basic {
    /**
     * @generated from protobuf field: optional string payload = 1
     */
    payload?: string;
}
/**
 * Some commands refer to one or more cluser ids.
 *
 * @generated from protobuf message pb.AudioMessage.Command.ClusterIDs
 */
export interface AudioMessage_Command_ClusterIDs {
    /**
     * @generated from protobuf field: repeated pb.AudioMessage.AudioClusterStatus clusters = 2
     */
    clusters: AudioMessage_AudioClusterStatus[];
}
/**
 * Some commands contain a message.
 *
 * @generated from protobuf message pb.AudioMessage.Command.MsgWrap
 */
export interface AudioMessage_Command_MsgWrap {
    /**
     * this is the message in the payload. For a missing message it might be absent
     *
     * @generated from protobuf field: optional pb.AudioMessage.Msg message = 1
     */
    message?: AudioMessage_Msg;
    /**
     * for ack payloads this is the status of the specified message
     *
     * @generated from protobuf field: optional pb.AudioMessage.Command.MsgWrap.Status request_status = 2
     */
    requestStatus?: AudioMessage_Command_MsgWrap_Status;
    /**
     * the client_msg_uid of the message request, not neccesarily of the message it effects (although they could be the same)
     *  For an ACK_MSG this is the request_client_msg_uid of the message that is being acked, parroted back
     * the 3 send command types that CAN produce deltas (SEND_MSG, SEND_ANNOTATION, and SEND_DELETE)
     *  all either return a delta where the delta’s client_msg_uid matches the request_client_msg_uid in the command
     *  OR an ACK_MSG where the request_client_msg_id == the original request_client_msg_uid
     * It is also proper practice now for SEND_MSG, SEND_ANNOTATION, and SEND_DELETE to populate the outer request_client_msg_uid
     *  in the command.  SEND_MSG should duplicate that and the inner client_msg_uid as it’s convention that for a new message
     *  the RCMID and CMID are the synonymous. However, the backend, when it gets a packet will look for the request_client_msg_uid
     *  first and then the inner client_msg_uid which should make it 100% backward compatible for now
     *
     * @generated from protobuf field: optional string request_client_msg_uid = 3
     */
    requestClientMsgUid?: string;
    /**
     * @generated from protobuf field: uint64 msg_seq_id = 4
     */
    msgSeqId: string; // new 11/23/24
}
/**
 * @generated from protobuf enum pb.AudioMessage.Command.MsgWrap.Status
 */
export enum AudioMessage_Command_MsgWrap_Status {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * we can't determine the state of the request, probably just cancel
     *
     * @generated from protobuf enum value: UNKNOWN = 1;
     */
    UNKNOWN = 1,
    /**
     * msg is present, here are details
     *
     * @generated from protobuf enum value: PRESENT = 2;
     */
    PRESENT = 2,
    /**
     * msg is absent (deleted or never existed)
     *
     * @generated from protobuf enum value: ABSENT = 3;
     */
    ABSENT = 3,
    /**
     * msg was modified (not in use)
     *
     * @generated from protobuf enum value: MODIFIED = 4;
     */
    MODIFIED = 4,
    /**
     * request was rejected due to suspended state
     *
     * @generated from protobuf enum value: REJECTED_SUSPENDED = 5;
     */
    REJECTED_SUSPENDED = 5,
    /**
     * request was rejected due to administrative lock (rebooting)
     *
     * @generated from protobuf enum value: REJECTED_ADMIN = 6;
     */
    REJECTED_ADMIN = 6,
    /**
     * request was rejected due to not being compiliant
     *
     * @generated from protobuf enum value: REJECTED_ILLFORMED = 7;
     */
    REJECTED_ILLFORMED = 7,
    /**
     * just a notice of accepted -- no msg details
     *
     * @generated from protobuf enum value: ACCEPTED = 8;
     */
    ACCEPTED = 8
}
/**
 * Some commands contain a message.
 *
 * @generated from protobuf message pb.AudioMessage.Command.FeedbackWrap
 */
export interface AudioMessage_Command_FeedbackWrap {
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Command.Feedback feedback = 1
     */
    feedback?: AudioMessage_Command_Feedback;
}
/**
 * System commands carry a string and a sub type.
 *
 * @generated from protobuf message pb.AudioMessage.Command.SystemWrap
 */
export interface AudioMessage_Command_SystemWrap {
    /**
     * @generated from protobuf field: optional string message = 1
     */
    message?: string;
    /**
     * @generated from protobuf field: optional pb.AudioMessage.Command.SystemWrap.SysComm sys_comm = 2
     */
    sysComm?: AudioMessage_Command_SystemWrap_SysComm;
    /**
     * @generated from protobuf field: optional string icon_name = 4
     */
    iconName?: string;
}
/**
 * @generated from protobuf enum pb.AudioMessage.Command.SystemWrap.SysComm
 */
export enum AudioMessage_Command_SystemWrap_SysComm {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: LOGGED_OFF = 1;
     */
    LOGGED_OFF = 1,
    /**
     * @generated from protobuf enum value: SHUTTING_DOWN = 2;
     */
    SHUTTING_DOWN = 2,
    /**
     * @generated from protobuf enum value: FORCE_RESET = 3;
     */
    FORCE_RESET = 3,
    /**
     * @generated from protobuf enum value: DELTA_TRIM = 4;
     */
    DELTA_TRIM = 4,
    /**
     * @generated from protobuf enum value: REBOOTING_BRAIN = 5;
     */
    REBOOTING_BRAIN = 5
}
/**
 * Some commands contain a range of messages. Used for scrollback.
 * TODO: remove the invalid ways to request. Most are speculative
 * NOTE: at current, only token and prev_token are valid ways to request
 *
 * @generated from protobuf message pb.AudioMessage.Command.MsgRange
 */
export interface AudioMessage_Command_MsgRange {
    /**
     * various ways to request data - from 'token' or 'session_token' returned from something else, like DeltaBlock
     * meaning of this is 'give me the block of messages previous to this token'.
     *
     * @generated from protobuf field: optional string prev_token = 1
     */
    prevToken?: string; // encoded server string that indicates another block to load (get one previous to this) <- in use
    /**
     * @generated from protobuf field: optional string token = 2
     */
    token?: string; // encoded server string that indicates another block to load <- in use
    /**
     * None of these are implemented
     * TODO so remove
     *
     * @generated from protobuf field: optional string next_token = 3
     */
    nextToken?: string; // encoded server string that indicates another block to load (get one after this)
    /**
     * @generated from protobuf field: optional int64 older_than = 4
     */
    olderThan?: string; // start at a timestamp
    /**
     * @generated from protobuf field: optional int64 newer_than = 5
     */
    newerThan?: string; // start at a timestamp
    /**
     * @generated from protobuf field: optional string msg_uid = 6
     */
    msgUid?: string; // start at a message
    /**
     * @generated from protobuf field: optional uint64 session_id = 7
     */
    sessionId?: string; // start at a session
    /**
     * @generated from protobuf field: optional int32 preferred_count = 8
     */
    preferredCount?: number; // for future, preferred count
}
/**
 * Commands that target a specific user (in pixel-streaming lobby mode), such as allow-disable microphone.
 *
 * @generated from protobuf message pb.AudioMessage.Command.TargetUser
 */
export interface AudioMessage_Command_TargetUser {
    /**
     * @generated from protobuf field: optional string user_id = 1
     */
    userId?: string;
}
/**
 * @generated from protobuf enum pb.AudioMessage.Command.Type
 */
export enum AudioMessage_Command_Type {
    /**
     * @generated from protobuf enum value: NOP = 0;
     */
    NOP = 0,
    /**
     * Client to Server or Server to Client. Command to EXECUTE a console command. Basic payload.
     *
     * @generated from protobuf enum value: STRING_CONSOLE = 1;
     */
    STRING_CONSOLE = 1,
    /**
     * Command to print something to console. Basic payload, both ways.
     *
     * @generated from protobuf enum value: PRINT = 2;
     */
    PRINT = 2,
    /**
     * Debug-only: client to server, to whisper to server that it 'heard' this string. Basic payload.
     *
     * @generated from protobuf enum value: HEAR = 3;
     */
    HEAR = 3,
    /**
     * Server to client, basically a sub-title for text AND audio the skull heard. Basic payload.
     *
     * @generated from protobuf enum value: HEARD = 4;
     */
    HEARD = 4,
    /**
     * Server to client. Within an 'utterance', or single audio cluster, the first message will
     * contain a SPEAK command, with a Basic payload, containing the transcription of the entire sentence.
     *
     * @generated from protobuf enum value: SPEAK = 5;
     */
    SPEAK = 5,
    /**
     * Client to server. when the client sends a message (other than mic audio, which isn't a Msg). MsgWrap payload.
     *
     * @generated from protobuf enum value: SEND_MSG = 6;
     */
    SEND_MSG = 6,
    /**
     * Client to server. to request old messages (i.e. during scrollback). MsgRange payload.
     *
     * @generated from protobuf enum value: REQUEST_MSGS = 7;
     */
    REQUEST_MSGS = 7,
    /**
     * Server to client, to cancel some or all speech clusters. If empty, cancel everything. ClusterIDs payload.
     *
     * @generated from protobuf enum value: CANCEL = 8;
     */
    CANCEL = 8,
    /**
     * Client to server. that a particular audio cluster finished playing. AudioClusterStatus payload.
     *
     * @generated from protobuf enum value: FINISHED = 9;
     */
    FINISHED = 9,
    /**
     * Both ways. Basic payload.
     *
     * @generated from protobuf enum value: PING = 10;
     */
    PING = 10,
    /**
     * Both ways. Basic payload, sent in response to PING (thus, is the only other request-response pattern).
     *
     * @generated from protobuf enum value: ACK = 11;
     */
    ACK = 11,
    /**
     * Client to server. command to indicate that it's logging off. No payload.
     *
     * @generated from protobuf enum value: LOGOFF = 12;
     */
    LOGOFF = 12,
    /**
     * Client to server. indication that a particular audio cluster was cancelled. AudioClusterStatus payload.
     *
     * @generated from protobuf enum value: INTERRUPT = 13;
     */
    INTERRUPT = 13,
    /**
     * a Server to Client message posting an official message. Contains a Msg payload
     * sent after the client has finished speaking the line. generally redundant with delta's and
     * the SPEAK_MSG is of a lower reliability (delta might ammend) but generally comes earlier
     *
     * @generated from protobuf enum value: SPEAK_MSG = 14;
     */
    SPEAK_MSG = 14,
    /**
     * Client to server. when the client asks to annotate a message. MsgWrap payload. The Msg is just the msg_uid and the annotations
     *
     * @generated from protobuf enum value: SEND_ANNOTATION = 15;
     */
    SEND_ANNOTATION = 15,
    /**
     * Client to server. when the client asks to delete a message. MsgWrap payload. The Msg is just the msg_uid
     *
     * @generated from protobuf enum value: SEND_DELETE = 16;
     */
    SEND_DELETE = 16,
    /**
     * Client to server. send a feedback request. FeedbackWrap payload
     *
     * @generated from protobuf enum value: SEND_FEEDBACK = 17;
     */
    SEND_FEEDBACK = 17,
    /**
     * Client to server. Regenerate the last response. No payload
     *
     * @generated from protobuf enum value: REGENERATE_LAST = 18;
     */
    REGENERATE_LAST = 18,
    /**
     * Server to Client.  A system message from the server
     *
     * @generated from protobuf enum value: SYSTEM = 19;
     */
    SYSTEM = 19,
    /**
     * Client to Server. The user tapped in the typing pane or tapped a key or moved the cursor
     *
     * @generated from protobuf enum value: USER_TYPING = 20;
     */
    USER_TYPING = 20,
    /**
     * Server to Client. MsgWrap payload. Confirming the status of a message, generally an optional response
     *   to SEND_MSG, SEND_ANNOTATION, SEND_DELETE
     *  This request will only be returned if the SEND command in question will not itself return a delta
     *
     * @generated from protobuf enum value: ACK_MSG = 21;
     */
    ACK_MSG = 21,
    /**
     * Server to Client. MsgWrap payload. Confirming the status of an uploaded cluster
     *  This request will only be returned in response to a finished audio cluster
     *
     * @generated from protobuf enum value: ACK_CLUSTER = 22;
     */
    ACK_CLUSTER = 22,
    /**
     * Client to server. indication that a particular audio cluster was downloaded. AudioClusterStatus payload.
     *
     * @generated from protobuf enum value: TRANSFERRED = 23;
     */
    TRANSFERRED = 23,
    /**
     * Client to server. indication that the client wants to talk in event form. No payload
     *
     * @generated from protobuf enum value: WANT_TO_TALK = 24;
     */
    WANT_TO_TALK = 24,
    /**
     * Client to server. Generic status of a cluster (no message). AudioClusterStatus payload.
     *
     * @generated from protobuf enum value: CLUSTER_STATUS = 25;
     */
    CLUSTER_STATUS = 25,
    /**
     * Client to server. Notice about a cluster (no message). AudioClusterStatus payload.
     *
     * @generated from protobuf enum value: CLUSTER_STALL = 26;
     */
    CLUSTER_STALL = 26,
    /**
     * Client to server. Notice about a cluster (no message). AudioClusterStatus payload.
     *
     * @generated from protobuf enum value: CLUSTER_ERROR = 27;
     */
    CLUSTER_ERROR = 27,
    /**
     * Client to server. Send by 'host' pixel streamer clients to allow/disallow other
     * pixel streamer clients to use their microphone. TargetUser payload containing the
     * target user id.
     *
     * @generated from protobuf enum value: ALLOW_MIC = 28;
     */
    ALLOW_MIC = 28,
    /**
     * @generated from protobuf enum value: DISALLOW_MIC = 29;
     */
    DISALLOW_MIC = 29,
    /**
     * Client to server. Update a property from client -> server. ClusterProperties payload.
     *
     * @generated from protobuf enum value: UPDATE_PROPERTIES = 30;
     */
    UPDATE_PROPERTIES = 30,
    /**
     * Client to server. Exit lobby mode, and make sure we have an active talkable session on the brain. No Payload.
     *  being deprecated for normal modern pixel streaming, only in use on old windows hosted pixel streaming
     *
     * @generated from protobuf enum value: SESSION_ENSURE_TALKABLE = 31;
     */
    SESSION_ENSURE_TALKABLE = 31,
    /**
     * End the current session, if any. No payload.
     * Server to client. Informing the client that the session has ended. Client can then disconnect.
     * Client to Server (NYI) can request the end of a session, which will result in a Server to Client END_SESSION
     *
     * @generated from protobuf enum value: SESSION_END = 32;
     */
    SESSION_END = 32,
    /**
     * Client to server. Inform the server that the session is fully loaded, and the client is ready to go.
     *
     * @generated from protobuf enum value: SESSION_FULLY_LOADED = 33;
     */
    SESSION_FULLY_LOADED = 33,
    /**
     * Client to server. Inform the server that the client has fully paused.  Carries a cluster status payload
     *  generally this would contain the audio cluster that the client is currently paused on -- but could be empty (maybe)
     *
     * @generated from protobuf enum value: CLUSTER_PAUSED = 34;
     */
    CLUSTER_PAUSED = 34,
    /**
     * Server to client. A transcript has arrived, no pyload (yet).
     *
     * @generated from protobuf enum value: LISTENING_TRANSCRIPT = 35;
     */
    LISTENING_TRANSCRIPT = 35,
    /**
     * Server to client. An emotion has been decoded, no pyload (yet).
     *
     * @generated from protobuf enum value: LISTENING_EMOTION = 36;
     */
    LISTENING_EMOTION = 36,
    /**
     * Server to client. ClusterProperties Payload.
     *
     * @generated from protobuf enum value: GUI_POPUP = 37;
     */
    GUI_POPUP = 37,
    /**
     * Client to server. ClusterProperties Payload.
     *
     * @generated from protobuf enum value: GUI_UPLOAD = 38;
     */
    GUI_UPLOAD = 38
}
/**
 * Contains a list of messages, sent from server to client.
 * NOTE: some of the returned fields are not in use and speculative
 *
 * @generated from protobuf message pb.AudioMessage.MsgBlock
 */
export interface AudioMessage_MsgBlock {
    /**
     * @generated from protobuf field: optional int64 min_delta_id = 1
     */
    minDeltaId?: string; // the delta_id represented in this state block. any ids less than this can be ignored with regard to this block
    /**
     * not used
     *
     * @generated from protobuf field: optional string prev_token = 2
     */
    prevToken?: string; // token to use to fetch a block of previous messages (optional)
    /**
     * This is the one true token used to fetch previous blocks (insert this token into prev_token
     * field of MsgRange to retrieve a previous block). It's also used to identify this block
     *
     * @generated from protobuf field: optional string token = 3
     */
    token?: string; // token to use to fetch a block of messages (optional)
    /**
     * not used (actually could be) - used for forward search
     *
     * @generated from protobuf field: optional string next_token = 4
     */
    nextToken?: string; // token to use to fetch a block of future messages (optional)
    /**
     * not used
     * possible TODO: remove?
     *
     * @generated from protobuf field: optional int64 start_timestamp = 5
     */
    startTimestamp?: string; // lowest timestamp of the current block
    /**
     * @generated from protobuf field: optional int64 end_timestamp = 6
     */
    endTimestamp?: string; // highest timestamp of the current block
    /**
     * actual messages in the block, can be zero
     *
     * @generated from protobuf field: repeated pb.AudioMessage.Msg messages = 7
     */
    messages: AudioMessage_Msg[];
}
/**
 * Contains a list of deltas, sent from server to client.
 *
 * @generated from protobuf message pb.AudioMessage.MsgDeltaBlock
 */
export interface AudioMessage_MsgDeltaBlock {
    /**
     * The max delta id is the max of all deltas in this block and the new value for the client to use
     *
     * @generated from protobuf field: optional int64 max_delta_id = 1
     */
    maxDeltaId?: string;
    /**
     * the version number of the msg_system at the time this block was created.
     *  If the client has NOT YET recorded a msg_version in its saved data, it should record this
     *   and send it with new connections.
     *  This will allow the server to order the client to dump all data if it goes out of date
     *
     * @generated from protobuf field: optional uint32 msg_version = 10
     */
    msgVersion?: number;
    /**
     * if included, and if larger than the max_delta_id, then indicates the server has more to send
     * client can feel free to ignore this
     *
     * @generated from protobuf field: optional int64 server_max_delta_id = 2
     */
    serverMaxDeltaId?: string;
    /**
     * The created delta id of the current session. Any deltas <= this don't apply to this 'session'.
     *
     * @generated from protobuf field: optional int64 created_delta_id = 3
     */
    createdDeltaId?: string;
    /**
     * The current open session.
     * possible TODO: the 'session' concept should, imho, be completely hidden from the client, and
     *   thus shouldn't be here.
     *
     * @generated from protobuf field: optional string session_id = 4
     */
    sessionId?: string;
    /**
     * A token that can be used to retrieve or recognize this session, but this shouldn't be done for an open session.
     * this is neccesary to idenitfy the session and to ask for previous sessions
     *
     * @generated from protobuf field: optional string session_token = 5
     */
    sessionToken?: string;
    /**
     * a token that can be used to retrieve data immediately prior to the open session
     * NOTE: not in use
     * possibile todo: remove?
     *
     * @generated from protobuf field: optional string session_prev_token = 6
     */
    sessionPrevToken?: string;
    /**
     * lowest timestamp of the current session
     *
     * @generated from protobuf field: optional int64 start_timestamp = 7
     */
    startTimestamp?: string; // -------------------
    /**
     * a delta block packet that orders the client to reset state
     * client should accept the max_delta_id info in this packet
     * a force_reset block will be formatted just like a response from a request with no client max_delta_id
     * the client should dump all its data and then apply the initial state
     *
     * @generated from protobuf field: optional bool force_reset = 8
     */
    forceReset?: boolean;
    /**
     * @generated from protobuf field: repeated pb.AudioMessage.MsgDelta msg_deltas = 9
     */
    msgDeltas: AudioMessage_MsgDelta[];
}
/**
 * Top-level 'type' of the message.
 * possible TODO: factor into different messages? The pattern of having a 'type' and then
 *   a payload corresponding to the type, can lead to typing errors.
 *
 * @generated from protobuf enum pb.AudioMessage.Type
 */
export enum AudioMessage_Type {
    /**
     * @generated from protobuf enum value: NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: SERVER_TO_CLIENT = 1;
     */
    SERVER_TO_CLIENT = 1,
    /**
     * @generated from protobuf enum value: CLIENT_TO_SERVER = 2;
     */
    CLIENT_TO_SERVER = 2,
    /**
     * @generated from protobuf enum value: CLIENT_ASK_TO_CONNECT = 3;
     */
    CLIENT_ASK_TO_CONNECT = 3,
    /**
     * @generated from protobuf enum value: SERVER_CONNECT_INFO = 4;
     */
    SERVER_CONNECT_INFO = 4
}
/**
 * ENUM_SYNC RequirementType / AudioMessageDevicePermissionType   (1:1 direct conversion)
 *
 * Registry of device permissions that a PermissionsCheck can reference.
 *
 * @generated from protobuf enum pb.AudioMessage.DevicePermissionType
 */
export enum AudioMessage_DevicePermissionType {
    /**
     * @generated from protobuf enum value: DPT_UNSPECIFIED = 0;
     */
    DPT_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PUSH_NOTIFICATION = 1;
     */
    PUSH_NOTIFICATION = 1
}
// ENUM_SYNC LinkRefIcon / AudioMessageIconType   (1:1 direct conversion)
// enum IconType {
//     UNKNOWN = 0;
//     NO_ICON = 1;                  // none
//     INFO = 2;                     // information
//     WARNING = 3;                  // warning
//     ERROR =4;                     // error
// }

/**
 * Emotions that the avatar could be commanded to display. Sent only server to client.
 * List might grow in the future.
 * ENUM_SYNC VoiceEmotion / AudioMessageAvatarEmotion       (formal conversion one way ->)
 *
 * @generated from protobuf enum pb.AudioMessage.AvatarEmotion
 */
export enum AudioMessage_AvatarEmotion {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NEUTRAL = 1;
     */
    NEUTRAL = 1,
    /**
     * @generated from protobuf enum value: CALM = 2;
     */
    CALM = 2,
    /**
     * @generated from protobuf enum value: CONCERNED = 3;
     */
    CONCERNED = 3,
    /**
     * @generated from protobuf enum value: CONFUSED = 4;
     */
    CONFUSED = 4,
    /**
     * @generated from protobuf enum value: EMPATHETIC = 5;
     */
    EMPATHETIC = 5,
    /**
     * @generated from protobuf enum value: EXCITED = 6;
     */
    EXCITED = 6,
    /**
     * @generated from protobuf enum value: INTERESTED = 7;
     */
    INTERESTED = 7,
    /**
     * @generated from protobuf enum value: HAPPY = 8;
     */
    HAPPY = 8,
    /**
     * @generated from protobuf enum value: SAD = 9;
     */
    SAD = 9,
    /**
     * @generated from protobuf enum value: ANGRY = 10;
     */
    ANGRY = 10,
    /**
     * @generated from protobuf enum value: CONTEMPT = 11;
     */
    CONTEMPT = 11,
    /**
     * @generated from protobuf enum value: FEARFUL = 12;
     */
    FEARFUL = 12,
    /**
     * @generated from protobuf enum value: DISGUSTED = 13;
     */
    DISGUSTED = 13,
    /**
     * @generated from protobuf enum value: SURPRISED = 14;
     */
    SURPRISED = 14,
    /**
     * @generated from protobuf enum value: ADMIRATION = 15;
     */
    ADMIRATION = 15,
    /**
     * @generated from protobuf enum value: APPRAISING = 16;
     */
    APPRAISING = 16,
    /**
     * @generated from protobuf enum value: BRAGGING = 17;
     */
    BRAGGING = 17,
    /**
     * @generated from protobuf enum value: CASUAL = 18;
     */
    CASUAL = 18,
    /**
     * @generated from protobuf enum value: CAUTIOUS = 19;
     */
    CAUTIOUS = 19,
    /**
     * @generated from protobuf enum value: CONFIDENT = 20;
     */
    CONFIDENT = 20,
    /**
     * @generated from protobuf enum value: CUTTING = 21;
     */
    CUTTING = 21,
    /**
     * @generated from protobuf enum value: DISMISSIVE = 22;
     */
    DISMISSIVE = 22,
    /**
     * @generated from protobuf enum value: DRY = 23;
     */
    DRY = 23,
    /**
     * @generated from protobuf enum value: ENGAGING = 24;
     */
    ENGAGING = 24,
    /**
     * @generated from protobuf enum value: INTENSE = 25;
     */
    INTENSE = 25,
    /**
     * @generated from protobuf enum value: LECTURING = 26;
     */
    LECTURING = 26,
    /**
     * @generated from protobuf enum value: MEDITATIVE = 27;
     */
    MEDITATIVE = 27,
    /**
     * @generated from protobuf enum value: MOCKING = 28;
     */
    MOCKING = 28,
    /**
     * @generated from protobuf enum value: MOTIVATING = 29;
     */
    MOTIVATING = 29,
    /**
     * @generated from protobuf enum value: MYSTERIOUS = 30;
     */
    MYSTERIOUS = 30,
    /**
     * @generated from protobuf enum value: OPTIMISTIC = 31;
     */
    OPTIMISTIC = 31,
    /**
     * @generated from protobuf enum value: PASSIONATE = 32;
     */
    PASSIONATE = 32,
    /**
     * @generated from protobuf enum value: PERSUASIVE = 33;
     */
    PERSUASIVE = 33,
    /**
     * @generated from protobuf enum value: PLAYFUL = 34;
     */
    PLAYFUL = 34,
    /**
     * @generated from protobuf enum value: POSITIVE = 35;
     */
    POSITIVE = 35,
    /**
     * @generated from protobuf enum value: PROFESSIONAL = 36;
     */
    PROFESSIONAL = 36,
    /**
     * @generated from protobuf enum value: REDIRECTING = 37;
     */
    REDIRECTING = 37,
    /**
     * @generated from protobuf enum value: SARCASTIC = 38;
     */
    SARCASTIC = 38,
    /**
     * @generated from protobuf enum value: SNARKY = 39;
     */
    SNARKY = 39,
    /**
     * @generated from protobuf enum value: STORYTELLING = 40;
     */
    STORYTELLING = 40,
    /**
     * @generated from protobuf enum value: WARM = 41;
     */
    WARM = 41,
    /**
     * @generated from protobuf enum value: WHISPERING = 42;
     */
    WHISPERING = 42,
    /**
     * @generated from protobuf enum value: ADORATION = 43;
     */
    ADORATION = 43,
    /**
     * @generated from protobuf enum value: APPRECIATION = 44;
     */
    APPRECIATION = 44,
    /**
     * @generated from protobuf enum value: AMUSED = 45;
     */
    AMUSED = 45,
    /**
     * @generated from protobuf enum value: ANXIOUS = 46;
     */
    ANXIOUS = 46,
    /**
     * @generated from protobuf enum value: AWE = 47;
     */
    AWE = 47,
    /**
     * @generated from protobuf enum value: AWKWARD = 48;
     */
    AWKWARD = 48,
    /**
     * @generated from protobuf enum value: BORED = 49;
     */
    BORED = 49,
    /**
     * @generated from protobuf enum value: CRAVING = 50;
     */
    CRAVING = 50,
    /**
     * @generated from protobuf enum value: ENTRANCED = 51;
     */
    ENTRANCED = 51,
    /**
     * @generated from protobuf enum value: HORROR = 52;
     */
    HORROR = 52,
    /**
     * @generated from protobuf enum value: NOSTALGIC = 53;
     */
    NOSTALGIC = 53,
    /**
     * @generated from protobuf enum value: RELIEVED = 54;
     */
    RELIEVED = 54,
    /**
     * @generated from protobuf enum value: ROMANTIC = 55;
     */
    ROMANTIC = 55,
    /**
     * @generated from protobuf enum value: SATISFIED = 56;
     */
    SATISFIED = 56,
    /**
     * @generated from protobuf enum value: SOFT = 57;
     */
    SOFT = 57,
    /**
     * @generated from protobuf enum value: LAUGHING = 58;
     */
    LAUGHING = 58,
    /**
     * @generated from protobuf enum value: DEMON = 59;
     */
    DEMON = 59,
    /**
     * @generated from protobuf enum value: FURIOUS = 60;
     */
    FURIOUS = 60,
    /**
     * @generated from protobuf enum value: KILL_SEQUENCE_INITIATE = 61;
     */
    KILL_SEQUENCE_INITIATE = 61,
    /**
     * @generated from protobuf enum value: PESSIMISTIC = 62;
     */
    PESSIMISTIC = 62,
    /**
     * @generated from protobuf enum value: PLEAD = 63;
     */
    PLEAD = 63,
    /**
     * @generated from protobuf enum value: PLEAD_ANGRY = 64;
     */
    PLEAD_ANGRY = 64,
    /**
     * @generated from protobuf enum value: PLEAD_DESPERATE = 65;
     */
    PLEAD_DESPERATE = 65,
    /**
     * @generated from protobuf enum value: RELIEF = 66;
     */
    RELIEF = 66,
    /**
     * @generated from protobuf enum value: URGENT = 67;
     */
    URGENT = 67,
    /**
     * @generated from protobuf enum value: ROBOT = 68;
     */
    ROBOT = 68,
    /**
     * @generated from protobuf enum value: GARBLED = 69;
     */
    GARBLED = 69,
    /**
     * @generated from protobuf enum value: PROUD = 70;
     */
    PROUD = 70,
    /**
     * @generated from protobuf enum value: MILD_CONCERN = 71;
     */
    MILD_CONCERN = 71,
    /**
     * @generated from protobuf enum value: STEADY = 72;
     */
    STEADY = 72,
    /**
     * @generated from protobuf enum value: IRRITATED = 73;
     */
    IRRITATED = 73,
    /**
     * @generated from protobuf enum value: FRUSTRATED = 74;
     */
    FRUSTRATED = 74,
    /**
     * @generated from protobuf enum value: AGITATED = 75;
     */
    AGITATED = 75,
    /**
     * @generated from protobuf enum value: RESIGNED = 76;
     */
    RESIGNED = 76,
    /**
     * @generated from protobuf enum value: HAUGHTY = 77;
     */
    HAUGHTY = 77,
    /**
     * @generated from protobuf enum value: SUPPORTIVE = 78;
     */
    SUPPORTIVE = 78,
    /**
     * @generated from protobuf enum value: PUZZLED = 79;
     */
    PUZZLED = 79
}
/**
 * Intent enum for categorizing conversational intent
 * Maps to IntentCode enum in cortex/exec/default_state.py
 *
 * @generated from protobuf enum pb.AudioMessage.Intent
 */
export enum AudioMessage_Intent {
    /**
     * Default/unknown - maps to IntentCode.unspecified_intent
     *
     * @generated from protobuf enum value: UNSPECIFIED_INTENT = 0;
     */
    UNSPECIFIED_INTENT = 0,
    /**
     * Conversational flow - Managing conversation structure and progression
     *
     * IntentCode.deliver_greeting
     *
     * @generated from protobuf enum value: DELIVER_GREETING = 1;
     */
    DELIVER_GREETING = 1,
    /**
     * IntentCode.transition
     *
     * @generated from protobuf enum value: TRANSITION = 2;
     */
    TRANSITION = 2,
    /**
     * IntentCode.acknowledge_completion
     *
     * @generated from protobuf enum value: ACKNOWLEDGE_COMPLETION = 3;
     */
    ACKNOWLEDGE_COMPLETION = 3,
    /**
     * IntentCode.continue_on_topic
     *
     * @generated from protobuf enum value: CONTINUE_ON_TOPIC = 4;
     */
    CONTINUE_ON_TOPIC = 4,
    /**
     * IntentCode.requesting_time
     *
     * @generated from protobuf enum value: REQUESTING_TIME = 5;
     */
    REQUESTING_TIME = 5,
    /**
     * IntentCode.banter
     *
     * @generated from protobuf enum value: BANTER = 6;
     */
    BANTER = 6,
    /**
     * Information exchange - Core Q&A and content delivery
     *
     * IntentCode.ask_question
     *
     * @generated from protobuf enum value: ASK_QUESTION = 7;
     */
    ASK_QUESTION = 7,
    /**
     * IntentCode.answer_question
     *
     * @generated from protobuf enum value: ANSWER_QUESTION = 8;
     */
    ANSWER_QUESTION = 8,
    /**
     * IntentCode.deliver_conclusion
     *
     * @generated from protobuf enum value: DELIVER_CONCLUSION = 9;
     */
    DELIVER_CONCLUSION = 9,
    /**
     * IntentCode.deliver_presentation
     *
     * @generated from protobuf enum value: DELIVER_PRESENTATION = 10;
     */
    DELIVER_PRESENTATION = 10,
    /**
     * Clarification & understanding - Resolving ambiguity
     *
     * IntentCode.provide_clarification
     *
     * @generated from protobuf enum value: PROVIDE_CLARIFICATION = 11;
     */
    PROVIDE_CLARIFICATION = 11,
    /**
     * IntentCode.request_clarification
     *
     * @generated from protobuf enum value: REQUEST_CLARIFICATION = 12;
     */
    REQUEST_CLARIFICATION = 12,
    /**
     * Feedback & reflection - Responding to user contributions
     *
     * IntentCode.acknowledge_response
     *
     * @generated from protobuf enum value: ACKNOWLEDGE_RESPONSE = 13;
     */
    ACKNOWLEDGE_RESPONSE = 13,
    /**
     * IntentCode.probe_response
     *
     * @generated from protobuf enum value: PROBE_RESPONSE = 14;
     */
    PROBE_RESPONSE = 14,
    /**
     * IntentCode.offer_insight
     *
     * @generated from protobuf enum value: OFFER_INSIGHT = 15;
     */
    OFFER_INSIGHT = 15,
    /**
     * Boundary management - Handling off-topic or inappropriate behavior
     *
     * IntentCode.warn_off_topic
     *
     * @generated from protobuf enum value: WARN_OFF_TOPIC = 16;
     */
    WARN_OFF_TOPIC = 16,
    /**
     * IntentCode.warn_inappropriate
     *
     * @generated from protobuf enum value: WARN_INAPPROPRIATE = 17;
     */
    WARN_INAPPROPRIATE = 17,
    /**
     * IntentCode.warn_refusal
     *
     * @generated from protobuf enum value: WARN_REFUSAL = 18;
     */
    WARN_REFUSAL = 18,
    /**
     * IntentCode.end_inappropriate
     *
     * @generated from protobuf enum value: END_INAPPROPRIATE = 19;
     */
    END_INAPPROPRIATE = 19,
    /**
     * IntentCode.end_convo
     *
     * @generated from protobuf enum value: END_CONVO = 20;
     */
    END_CONVO = 20
}
/**
 * Language enum for avatar language
 * Maps to AvatarLanguage enum in model/avatar_config.py
 *
 * @generated from protobuf enum pb.AudioMessage.Language
 */
export enum AudioMessage_Language {
    /**
     * @generated from protobuf enum value: UNSPECIFIED_LANGUAGE = 0;
     */
    UNSPECIFIED_LANGUAGE = 0,
    /**
     * @generated from protobuf enum value: DEFAULT = 1;
     */
    DEFAULT = 1,
    /**
     * @generated from protobuf enum value: ENGLISH = 2;
     */
    ENGLISH = 2,
    /**
     * @generated from protobuf enum value: SPANISH = 3;
     */
    SPANISH = 3,
    /**
     * @generated from protobuf enum value: FRENCH = 4;
     */
    FRENCH = 4,
    /**
     * @generated from protobuf enum value: ITALIAN = 5;
     */
    ITALIAN = 5,
    /**
     * @generated from protobuf enum value: GERMAN = 6;
     */
    GERMAN = 6,
    /**
     * @generated from protobuf enum value: DUTCH = 7;
     */
    DUTCH = 7,
    /**
     * @generated from protobuf enum value: PORTUGUESE = 8;
     */
    PORTUGUESE = 8,
    /**
     * @generated from protobuf enum value: LATIN = 9;
     */
    LATIN = 9,
    /**
     * @generated from protobuf enum value: JAPANESE = 10;
     */
    JAPANESE = 10,
    /**
     * @generated from protobuf enum value: MANDARIN = 11;
     */
    MANDARIN = 11,
    /**
     * @generated from protobuf enum value: HINDI = 12;
     */
    HINDI = 12,
    /**
     * @generated from protobuf enum value: HEBREW = 13;
     */
    HEBREW = 13,
    /**
     * @generated from protobuf enum value: ARABIC = 14;
     */
    ARABIC = 14,
    /**
     * @generated from protobuf enum value: KOREAN = 15;
     */
    KOREAN = 15,
    /**
     * @generated from protobuf enum value: POLISH = 16;
     */
    POLISH = 16,
    /**
     * @generated from protobuf enum value: RUSSIAN = 17;
     */
    RUSSIAN = 17,
    /**
     * @generated from protobuf enum value: SWEDISH = 18;
     */
    SWEDISH = 18,
    /**
     * @generated from protobuf enum value: TURKISH = 19;
     */
    TURKISH = 19
}
/**
 * @generated from protobuf enum pb.AudioMessage.EarMode
 */
export enum AudioMessage_EarMode {
    /**
     * @generated from protobuf enum value: EM_UNKNOWN = 0;
     */
    EM_UNKNOWN = 0,
    /**
     * uploaded audio traffic is ignored
     *
     * @generated from protobuf enum value: INACTIVE = 1;
     */
    INACTIVE = 1,
    /**
     * live conversational mode
     *
     * @generated from protobuf enum value: CONVERSATION = 2;
     */
    CONVERSATION = 2,
    /**
     * each audio cluster is turned into a full message and submitted as a hear
     *
     * @generated from protobuf enum value: PUSH_TO_TALK = 3;
     */
    PUSH_TO_TALK = 3
}
/**
 * LoadingStatus is used to clarify the state of the main pixel streaming (Unreal) client.
 *  It is sent from the client to the server in ClientInfo, and propogated to other clients
 *   as part of ServerInfo (client_loading_status).
 *
 * @generated from protobuf enum pb.AudioMessage.ClientLoadingStatus
 */
export enum AudioMessage_ClientLoadingStatus {
    /**
     * @generated from protobuf enum value: CLS_UNKNOWN = 0;
     */
    CLS_UNKNOWN = 0,
    /**
     * no connection to the server
     *
     * @generated from protobuf enum value: DISCONNECTED = 1;
     */
    DISCONNECTED = 1,
    /**
     * the client is connecting to the server
     *
     * @generated from protobuf enum value: CONNECTING = 5;
     */
    CONNECTING = 5,
    /**
     * the client is loading assets
     *
     * @generated from protobuf enum value: LOADING = 2;
     */
    LOADING = 2,
    /**
     * the client is binding to the server and setting properties
     *
     * @generated from protobuf enum value: BINDING = 4;
     */
    BINDING = 4,
    /**
     * the client is fully active and visible
     *
     * @generated from protobuf enum value: ACTIVE = 3;
     */
    ACTIVE = 3,
    /**
     * the client is about to disconnect from the server
     *
     * @generated from protobuf enum value: DISCONNECTING = 6;
     */
    DISCONNECTING = 6
}
/**
 * PauseStatus is used to clarify both server intent and client status
 *  It is sent from the client to the server in ClientInfo to indicate the client's status
 *  and from the server to the client in ServerInfo to indicate the server's intent.
 *  order is important. Higher values can trump lower values.
 *
 * @generated from protobuf enum pb.AudioMessage.ClientPauseStatus
 */
export enum AudioMessage_ClientPauseStatus {
    /**
     * @generated from protobuf enum value: CPS_UNKNOWN = 0;
     */
    CPS_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: PLAY = 10;
     */
    PLAY = 10,
    /**
     * @generated from protobuf enum value: PAUSE_CLUSTER = 20;
     */
    PAUSE_CLUSTER = 20,
    /**
     * @generated from protobuf enum value: PAUSE_WORD = 30;
     */
    PAUSE_WORD = 30,
    /**
     * @generated from protobuf enum value: PAUSE_SYLLABLE = 40;
     */
    PAUSE_SYLLABLE = 40,
    /**
     * @generated from protobuf enum value: PAUSE_NOW = 50;
     */
    PAUSE_NOW = 50,
    /**
     * @generated from protobuf enum value: PAUSED = 60;
     */
    PAUSED = 60
}
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage$Type extends MessageType<AudioMessage> {
    constructor() {
        super("pb.AudioMessage", [
            { no: 3, name: "type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Type", AudioMessage_Type] },
            { no: 4, name: "audio_cluster_seq_id", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 5, name: "audio_cluster_sample_offset", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 15, name: "audio_cluster_sample_max", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 6, name: "silence_samples", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 7, name: "debug", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 16, name: "message_sent_at", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 8, name: "client_info", kind: "message", oneof: "infoBlock", T: () => AudioMessage_ClientInfo },
            { no: 9, name: "server_info", kind: "message", oneof: "infoBlock", T: () => AudioMessage_ServerInfo },
            { no: 12, name: "connect_info", kind: "message", oneof: "infoBlock", T: () => AudioMessage_ConnectInfo },
            { no: 10, name: "audio", kind: "message", T: () => AudioMessage_Audio },
            { no: 11, name: "commands", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_Command },
            { no: 13, name: "msg_block", kind: "message", T: () => AudioMessage_MsgBlock },
            { no: 14, name: "msg_delta_block", kind: "message", T: () => AudioMessage_MsgDeltaBlock },
            { no: 17, name: "cluster_block", kind: "message", T: () => AudioMessage_ClusterInfo }
        ]);
    }
    create(value?: PartialMessage<AudioMessage>): AudioMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.infoBlock = { oneofKind: undefined };
        message.commands = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage): AudioMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Type type */ 3:
                    message.type = reader.int32();
                    break;
                case /* optional uint64 audio_cluster_seq_id */ 4:
                    message.audioClusterSeqId = reader.uint64().toString();
                    break;
                case /* optional uint64 audio_cluster_sample_offset */ 5:
                    message.audioClusterSampleOffset = reader.uint64().toString();
                    break;
                case /* optional uint64 audio_cluster_sample_max */ 15:
                    message.audioClusterSampleMax = reader.uint64().toString();
                    break;
                case /* optional uint64 silence_samples */ 6:
                    message.silenceSamples = reader.uint64().toString();
                    break;
                case /* optional uint32 debug */ 7:
                    message.debug = reader.uint32();
                    break;
                case /* optional int64 message_sent_at */ 16:
                    message.messageSentAt = reader.int64().toString();
                    break;
                case /* pb.AudioMessage.ClientInfo client_info */ 8:
                    message.infoBlock = {
                        oneofKind: "clientInfo",
                        clientInfo: AudioMessage_ClientInfo.internalBinaryRead(reader, reader.uint32(), options, (message.infoBlock as any).clientInfo)
                    };
                    break;
                case /* pb.AudioMessage.ServerInfo server_info */ 9:
                    message.infoBlock = {
                        oneofKind: "serverInfo",
                        serverInfo: AudioMessage_ServerInfo.internalBinaryRead(reader, reader.uint32(), options, (message.infoBlock as any).serverInfo)
                    };
                    break;
                case /* pb.AudioMessage.ConnectInfo connect_info */ 12:
                    message.infoBlock = {
                        oneofKind: "connectInfo",
                        connectInfo: AudioMessage_ConnectInfo.internalBinaryRead(reader, reader.uint32(), options, (message.infoBlock as any).connectInfo)
                    };
                    break;
                case /* optional pb.AudioMessage.Audio audio */ 10:
                    message.audio = AudioMessage_Audio.internalBinaryRead(reader, reader.uint32(), options, message.audio);
                    break;
                case /* repeated pb.AudioMessage.Command commands */ 11:
                    message.commands.push(AudioMessage_Command.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional pb.AudioMessage.MsgBlock msg_block */ 13:
                    message.msgBlock = AudioMessage_MsgBlock.internalBinaryRead(reader, reader.uint32(), options, message.msgBlock);
                    break;
                case /* optional pb.AudioMessage.MsgDeltaBlock msg_delta_block */ 14:
                    message.msgDeltaBlock = AudioMessage_MsgDeltaBlock.internalBinaryRead(reader, reader.uint32(), options, message.msgDeltaBlock);
                    break;
                case /* optional pb.AudioMessage.ClusterInfo cluster_block */ 17:
                    message.clusterBlock = AudioMessage_ClusterInfo.internalBinaryRead(reader, reader.uint32(), options, message.clusterBlock);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Type type = 3; */
        if (message.type !== undefined)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* optional uint64 audio_cluster_seq_id = 4; */
        if (message.audioClusterSeqId !== undefined)
            writer.tag(4, WireType.Varint).uint64(message.audioClusterSeqId);
        /* optional uint64 audio_cluster_sample_offset = 5; */
        if (message.audioClusterSampleOffset !== undefined)
            writer.tag(5, WireType.Varint).uint64(message.audioClusterSampleOffset);
        /* optional uint64 silence_samples = 6; */
        if (message.silenceSamples !== undefined)
            writer.tag(6, WireType.Varint).uint64(message.silenceSamples);
        /* optional uint32 debug = 7; */
        if (message.debug !== undefined)
            writer.tag(7, WireType.Varint).uint32(message.debug);
        /* pb.AudioMessage.ClientInfo client_info = 8; */
        if (message.infoBlock.oneofKind === "clientInfo")
            AudioMessage_ClientInfo.internalBinaryWrite(message.infoBlock.clientInfo, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.ServerInfo server_info = 9; */
        if (message.infoBlock.oneofKind === "serverInfo")
            AudioMessage_ServerInfo.internalBinaryWrite(message.infoBlock.serverInfo, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.Audio audio = 10; */
        if (message.audio)
            AudioMessage_Audio.internalBinaryWrite(message.audio, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated pb.AudioMessage.Command commands = 11; */
        for (let i = 0; i < message.commands.length; i++)
            AudioMessage_Command.internalBinaryWrite(message.commands[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.ConnectInfo connect_info = 12; */
        if (message.infoBlock.oneofKind === "connectInfo")
            AudioMessage_ConnectInfo.internalBinaryWrite(message.infoBlock.connectInfo, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.MsgBlock msg_block = 13; */
        if (message.msgBlock)
            AudioMessage_MsgBlock.internalBinaryWrite(message.msgBlock, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.MsgDeltaBlock msg_delta_block = 14; */
        if (message.msgDeltaBlock)
            AudioMessage_MsgDeltaBlock.internalBinaryWrite(message.msgDeltaBlock, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* optional uint64 audio_cluster_sample_max = 15; */
        if (message.audioClusterSampleMax !== undefined)
            writer.tag(15, WireType.Varint).uint64(message.audioClusterSampleMax);
        /* optional int64 message_sent_at = 16; */
        if (message.messageSentAt !== undefined)
            writer.tag(16, WireType.Varint).int64(message.messageSentAt);
        /* optional pb.AudioMessage.ClusterInfo cluster_block = 17; */
        if (message.clusterBlock)
            AudioMessage_ClusterInfo.internalBinaryWrite(message.clusterBlock, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage
 */
export const AudioMessage = new AudioMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_AudioClusterStatus$Type extends MessageType<AudioMessage_AudioClusterStatus> {
    constructor() {
        super("pb.AudioMessage.AudioClusterStatus", [
            { no: 1, name: "seq_id", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 2, name: "sample_offset", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 3, name: "sample_max", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 12, name: "samples_transferred", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 4, name: "percent_complete", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.AudioClusterStatus.Status", AudioMessage_AudioClusterStatus_Status] },
            { no: 6, name: "processing_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.AudioClusterStatus.ProcessingStatus", AudioMessage_AudioClusterStatus_ProcessingStatus] },
            { no: 7, name: "ear_mode", kind: "enum", opt: true, T: () => ["pb.AudioMessage.EarMode", AudioMessage_EarMode] },
            { no: 8, name: "char_count", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "word_count", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "transcript", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "ear_error_msg", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "active_at_ms", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 14, name: "played_at_ms", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 15, name: "finished_at_ms", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_AudioClusterStatus>): AudioMessage_AudioClusterStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_AudioClusterStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_AudioClusterStatus): AudioMessage_AudioClusterStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional uint64 seq_id */ 1:
                    message.seqId = reader.uint64().toString();
                    break;
                case /* optional uint64 sample_offset */ 2:
                    message.sampleOffset = reader.uint64().toString();
                    break;
                case /* optional uint64 sample_max */ 3:
                    message.sampleMax = reader.uint64().toString();
                    break;
                case /* optional uint64 samples_transferred */ 12:
                    message.samplesTransferred = reader.uint64().toString();
                    break;
                case /* optional float percent_complete */ 4:
                    message.percentComplete = reader.float();
                    break;
                case /* optional pb.AudioMessage.AudioClusterStatus.Status status */ 5:
                    message.status = reader.int32();
                    break;
                case /* optional pb.AudioMessage.AudioClusterStatus.ProcessingStatus processing_status */ 6:
                    message.processingStatus = reader.int32();
                    break;
                case /* optional pb.AudioMessage.EarMode ear_mode */ 7:
                    message.earMode = reader.int32();
                    break;
                case /* optional uint32 char_count */ 8:
                    message.charCount = reader.uint32();
                    break;
                case /* optional uint32 word_count */ 9:
                    message.wordCount = reader.uint32();
                    break;
                case /* optional string transcript */ 10:
                    message.transcript = reader.string();
                    break;
                case /* optional string ear_error_msg */ 11:
                    message.earErrorMsg = reader.string();
                    break;
                case /* optional int64 active_at_ms */ 13:
                    message.activeAtMs = reader.int64().toString();
                    break;
                case /* optional int64 played_at_ms */ 14:
                    message.playedAtMs = reader.int64().toString();
                    break;
                case /* optional int64 finished_at_ms */ 15:
                    message.finishedAtMs = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_AudioClusterStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional uint64 seq_id = 1; */
        if (message.seqId !== undefined)
            writer.tag(1, WireType.Varint).uint64(message.seqId);
        /* optional uint64 sample_offset = 2; */
        if (message.sampleOffset !== undefined)
            writer.tag(2, WireType.Varint).uint64(message.sampleOffset);
        /* optional uint64 sample_max = 3; */
        if (message.sampleMax !== undefined)
            writer.tag(3, WireType.Varint).uint64(message.sampleMax);
        /* optional float percent_complete = 4; */
        if (message.percentComplete !== undefined)
            writer.tag(4, WireType.Bit32).float(message.percentComplete);
        /* optional pb.AudioMessage.AudioClusterStatus.Status status = 5; */
        if (message.status !== undefined)
            writer.tag(5, WireType.Varint).int32(message.status);
        /* optional pb.AudioMessage.AudioClusterStatus.ProcessingStatus processing_status = 6; */
        if (message.processingStatus !== undefined)
            writer.tag(6, WireType.Varint).int32(message.processingStatus);
        /* optional pb.AudioMessage.EarMode ear_mode = 7; */
        if (message.earMode !== undefined)
            writer.tag(7, WireType.Varint).int32(message.earMode);
        /* optional uint32 char_count = 8; */
        if (message.charCount !== undefined)
            writer.tag(8, WireType.Varint).uint32(message.charCount);
        /* optional uint32 word_count = 9; */
        if (message.wordCount !== undefined)
            writer.tag(9, WireType.Varint).uint32(message.wordCount);
        /* optional string transcript = 10; */
        if (message.transcript !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.transcript);
        /* optional string ear_error_msg = 11; */
        if (message.earErrorMsg !== undefined)
            writer.tag(11, WireType.LengthDelimited).string(message.earErrorMsg);
        /* optional uint64 samples_transferred = 12; */
        if (message.samplesTransferred !== undefined)
            writer.tag(12, WireType.Varint).uint64(message.samplesTransferred);
        /* optional int64 active_at_ms = 13; */
        if (message.activeAtMs !== undefined)
            writer.tag(13, WireType.Varint).int64(message.activeAtMs);
        /* optional int64 played_at_ms = 14; */
        if (message.playedAtMs !== undefined)
            writer.tag(14, WireType.Varint).int64(message.playedAtMs);
        /* optional int64 finished_at_ms = 15; */
        if (message.finishedAtMs !== undefined)
            writer.tag(15, WireType.Varint).int64(message.finishedAtMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.AudioClusterStatus
 */
export const AudioMessage_AudioClusterStatus = new AudioMessage_AudioClusterStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterPropertyValue$Type extends MessageType<AudioMessage_ClusterPropertyValue> {
    constructor() {
        super("pb.AudioMessage.ClusterPropertyValue", [
            { no: 1, name: "type", kind: "enum", T: () => ["pb.AudioMessage.ClusterPropertyValue.Type", AudioMessage_ClusterPropertyValue_Type] },
            { no: 2, name: "str_value", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "int_value", kind: "scalar", oneof: "value", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "float_value", kind: "scalar", oneof: "value", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "bool_value", kind: "scalar", oneof: "value", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "dict_value", kind: "message", oneof: "value", T: () => AudioMessage_ClusterProperties },
            { no: 7, name: "list_value", kind: "message", oneof: "value", T: () => AudioMessage_ClusterPropertyValueList }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterPropertyValue>): AudioMessage_ClusterPropertyValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.value = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterPropertyValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterPropertyValue): AudioMessage_ClusterPropertyValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pb.AudioMessage.ClusterPropertyValue.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string str_value */ 2:
                    message.value = {
                        oneofKind: "strValue",
                        strValue: reader.string()
                    };
                    break;
                case /* int64 int_value */ 3:
                    message.value = {
                        oneofKind: "intValue",
                        intValue: reader.int64().toString()
                    };
                    break;
                case /* float float_value */ 4:
                    message.value = {
                        oneofKind: "floatValue",
                        floatValue: reader.float()
                    };
                    break;
                case /* bool bool_value */ 5:
                    message.value = {
                        oneofKind: "boolValue",
                        boolValue: reader.bool()
                    };
                    break;
                case /* pb.AudioMessage.ClusterProperties dict_value */ 6:
                    message.value = {
                        oneofKind: "dictValue",
                        dictValue: AudioMessage_ClusterProperties.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).dictValue)
                    };
                    break;
                case /* pb.AudioMessage.ClusterPropertyValueList list_value */ 7:
                    message.value = {
                        oneofKind: "listValue",
                        listValue: AudioMessage_ClusterPropertyValueList.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).listValue)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterPropertyValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pb.AudioMessage.ClusterPropertyValue.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string str_value = 2; */
        if (message.value.oneofKind === "strValue")
            writer.tag(2, WireType.LengthDelimited).string(message.value.strValue);
        /* int64 int_value = 3; */
        if (message.value.oneofKind === "intValue")
            writer.tag(3, WireType.Varint).int64(message.value.intValue);
        /* float float_value = 4; */
        if (message.value.oneofKind === "floatValue")
            writer.tag(4, WireType.Bit32).float(message.value.floatValue);
        /* bool bool_value = 5; */
        if (message.value.oneofKind === "boolValue")
            writer.tag(5, WireType.Varint).bool(message.value.boolValue);
        /* pb.AudioMessage.ClusterProperties dict_value = 6; */
        if (message.value.oneofKind === "dictValue")
            AudioMessage_ClusterProperties.internalBinaryWrite(message.value.dictValue, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.ClusterPropertyValueList list_value = 7; */
        if (message.value.oneofKind === "listValue")
            AudioMessage_ClusterPropertyValueList.internalBinaryWrite(message.value.listValue, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterPropertyValue
 */
export const AudioMessage_ClusterPropertyValue = new AudioMessage_ClusterPropertyValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterPropertyValueList$Type extends MessageType<AudioMessage_ClusterPropertyValueList> {
    constructor() {
        super("pb.AudioMessage.ClusterPropertyValueList", [
            { no: 1, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_ClusterPropertyValue }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterPropertyValueList>): AudioMessage_ClusterPropertyValueList {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.values = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterPropertyValueList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterPropertyValueList): AudioMessage_ClusterPropertyValueList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pb.AudioMessage.ClusterPropertyValue values */ 1:
                    message.values.push(AudioMessage_ClusterPropertyValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterPropertyValueList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pb.AudioMessage.ClusterPropertyValue values = 1; */
        for (let i = 0; i < message.values.length; i++)
            AudioMessage_ClusterPropertyValue.internalBinaryWrite(message.values[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterPropertyValueList
 */
export const AudioMessage_ClusterPropertyValueList = new AudioMessage_ClusterPropertyValueList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterProperty$Type extends MessageType<AudioMessage_ClusterProperty> {
    constructor() {
        super("pb.AudioMessage.ClusterProperty", [
            { no: 1, name: "property", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "message", T: () => AudioMessage_ClusterPropertyValue }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterProperty>): AudioMessage_ClusterProperty {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.property = "";
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterProperty>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterProperty): AudioMessage_ClusterProperty {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string property */ 1:
                    message.property = reader.string();
                    break;
                case /* pb.AudioMessage.ClusterPropertyValue value */ 2:
                    message.value = AudioMessage_ClusterPropertyValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterProperty, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string property = 1; */
        if (message.property !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.property);
        /* pb.AudioMessage.ClusterPropertyValue value = 2; */
        if (message.value)
            AudioMessage_ClusterPropertyValue.internalBinaryWrite(message.value, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterProperty
 */
export const AudioMessage_ClusterProperty = new AudioMessage_ClusterProperty$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterProperties$Type extends MessageType<AudioMessage_ClusterProperties> {
    constructor() {
        super("pb.AudioMessage.ClusterProperties", [
            { no: 2, name: "properties", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_ClusterProperty }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterProperties>): AudioMessage_ClusterProperties {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.properties = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterProperties>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterProperties): AudioMessage_ClusterProperties {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pb.AudioMessage.ClusterProperty properties */ 2:
                    message.properties.push(AudioMessage_ClusterProperty.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterProperties, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pb.AudioMessage.ClusterProperty properties = 2; */
        for (let i = 0; i < message.properties.length; i++)
            AudioMessage_ClusterProperty.internalBinaryWrite(message.properties[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterProperties
 */
export const AudioMessage_ClusterProperties = new AudioMessage_ClusterProperties$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterPropertySpace$Type extends MessageType<AudioMessage_ClusterPropertySpace> {
    constructor() {
        super("pb.AudioMessage.ClusterPropertySpace", [
            { no: 1, name: "space", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "properties", kind: "message", T: () => AudioMessage_ClusterProperties }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterPropertySpace>): AudioMessage_ClusterPropertySpace {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.space = "";
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterPropertySpace>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterPropertySpace): AudioMessage_ClusterPropertySpace {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string space */ 1:
                    message.space = reader.string();
                    break;
                case /* pb.AudioMessage.ClusterProperties properties */ 2:
                    message.properties = AudioMessage_ClusterProperties.internalBinaryRead(reader, reader.uint32(), options, message.properties);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterPropertySpace, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string space = 1; */
        if (message.space !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.space);
        /* pb.AudioMessage.ClusterProperties properties = 2; */
        if (message.properties)
            AudioMessage_ClusterProperties.internalBinaryWrite(message.properties, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterPropertySpace
 */
export const AudioMessage_ClusterPropertySpace = new AudioMessage_ClusterPropertySpace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterDesc$Type extends MessageType<AudioMessage_ClusterDesc> {
    constructor() {
        super("pb.AudioMessage.ClusterDesc", [
            { no: 1, name: "seq_id", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 14, name: "transaction_id", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 15, name: "cancel_if_possible", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "channel", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClusterDesc.Channel", AudioMessage_ClusterDesc_Channel] },
            { no: 10, name: "channel_type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClusterDesc.Channel", AudioMessage_ClusterDesc_Channel] },
            { no: 3, name: "status", kind: "message", T: () => AudioMessage_AudioClusterStatus },
            { no: 4, name: "duration", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "instant", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "start_conditions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_ClusterDesc_Condition },
            { no: 11, name: "end_conditions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_ClusterDesc_Condition },
            { no: 8, name: "properties", kind: "message", T: () => AudioMessage_ClusterProperties },
            { no: 13, name: "param_spaces", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_ClusterPropertySpace },
            { no: 9, name: "dont_confirm", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "voice", kind: "message", oneof: "payload", T: () => AudioMessage_ClusterDesc_VoicePayload },
            { no: 7, name: "anim", kind: "message", oneof: "payload", T: () => AudioMessage_ClusterDesc_AnimPayload }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterDesc>): AudioMessage_ClusterDesc {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.startConditions = [];
        message.endConditions = [];
        message.paramSpaces = [];
        message.payload = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterDesc>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterDesc): AudioMessage_ClusterDesc {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional uint64 seq_id */ 1:
                    message.seqId = reader.uint64().toString();
                    break;
                case /* optional uint64 transaction_id */ 14:
                    message.transactionId = reader.uint64().toString();
                    break;
                case /* optional bool cancel_if_possible */ 15:
                    message.cancelIfPossible = reader.bool();
                    break;
                case /* optional pb.AudioMessage.ClusterDesc.Channel channel */ 2:
                    message.channel = reader.int32();
                    break;
                case /* optional pb.AudioMessage.ClusterDesc.Channel channel_type */ 10:
                    message.channelType = reader.int32();
                    break;
                case /* optional pb.AudioMessage.AudioClusterStatus status */ 3:
                    message.status = AudioMessage_AudioClusterStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* optional float duration */ 4:
                    message.duration = reader.float();
                    break;
                case /* optional bool instant */ 12:
                    message.instant = reader.bool();
                    break;
                case /* repeated pb.AudioMessage.ClusterDesc.Condition start_conditions */ 5:
                    message.startConditions.push(AudioMessage_ClusterDesc_Condition.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated pb.AudioMessage.ClusterDesc.Condition end_conditions */ 11:
                    message.endConditions.push(AudioMessage_ClusterDesc_Condition.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* pb.AudioMessage.ClusterProperties properties */ 8:
                    message.properties = AudioMessage_ClusterProperties.internalBinaryRead(reader, reader.uint32(), options, message.properties);
                    break;
                case /* repeated pb.AudioMessage.ClusterPropertySpace param_spaces */ 13:
                    message.paramSpaces.push(AudioMessage_ClusterPropertySpace.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional bool dont_confirm */ 9:
                    message.dontConfirm = reader.bool();
                    break;
                case /* pb.AudioMessage.ClusterDesc.VoicePayload voice */ 6:
                    message.payload = {
                        oneofKind: "voice",
                        voice: AudioMessage_ClusterDesc_VoicePayload.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).voice)
                    };
                    break;
                case /* pb.AudioMessage.ClusterDesc.AnimPayload anim */ 7:
                    message.payload = {
                        oneofKind: "anim",
                        anim: AudioMessage_ClusterDesc_AnimPayload.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).anim)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterDesc, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional uint64 seq_id = 1; */
        if (message.seqId !== undefined)
            writer.tag(1, WireType.Varint).uint64(message.seqId);
        /* optional pb.AudioMessage.ClusterDesc.Channel channel = 2; */
        if (message.channel !== undefined)
            writer.tag(2, WireType.Varint).int32(message.channel);
        /* optional pb.AudioMessage.AudioClusterStatus status = 3; */
        if (message.status)
            AudioMessage_AudioClusterStatus.internalBinaryWrite(message.status, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional float duration = 4; */
        if (message.duration !== undefined)
            writer.tag(4, WireType.Bit32).float(message.duration);
        /* repeated pb.AudioMessage.ClusterDesc.Condition start_conditions = 5; */
        for (let i = 0; i < message.startConditions.length; i++)
            AudioMessage_ClusterDesc_Condition.internalBinaryWrite(message.startConditions[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.ClusterDesc.VoicePayload voice = 6; */
        if (message.payload.oneofKind === "voice")
            AudioMessage_ClusterDesc_VoicePayload.internalBinaryWrite(message.payload.voice, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.ClusterDesc.AnimPayload anim = 7; */
        if (message.payload.oneofKind === "anim")
            AudioMessage_ClusterDesc_AnimPayload.internalBinaryWrite(message.payload.anim, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.ClusterProperties properties = 8; */
        if (message.properties)
            AudioMessage_ClusterProperties.internalBinaryWrite(message.properties, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional bool dont_confirm = 9; */
        if (message.dontConfirm !== undefined)
            writer.tag(9, WireType.Varint).bool(message.dontConfirm);
        /* optional pb.AudioMessage.ClusterDesc.Channel channel_type = 10; */
        if (message.channelType !== undefined)
            writer.tag(10, WireType.Varint).int32(message.channelType);
        /* repeated pb.AudioMessage.ClusterDesc.Condition end_conditions = 11; */
        for (let i = 0; i < message.endConditions.length; i++)
            AudioMessage_ClusterDesc_Condition.internalBinaryWrite(message.endConditions[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* optional bool instant = 12; */
        if (message.instant !== undefined)
            writer.tag(12, WireType.Varint).bool(message.instant);
        /* repeated pb.AudioMessage.ClusterPropertySpace param_spaces = 13; */
        for (let i = 0; i < message.paramSpaces.length; i++)
            AudioMessage_ClusterPropertySpace.internalBinaryWrite(message.paramSpaces[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* optional uint64 transaction_id = 14; */
        if (message.transactionId !== undefined)
            writer.tag(14, WireType.Varint).uint64(message.transactionId);
        /* optional bool cancel_if_possible = 15; */
        if (message.cancelIfPossible !== undefined)
            writer.tag(15, WireType.Varint).bool(message.cancelIfPossible);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterDesc
 */
export const AudioMessage_ClusterDesc = new AudioMessage_ClusterDesc$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterDesc_Condition$Type extends MessageType<AudioMessage_ClusterDesc_Condition> {
    constructor() {
        super("pb.AudioMessage.ClusterDesc.Condition", [
            { no: 1, name: "check_type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClusterDesc.Condition.Type", AudioMessage_ClusterDesc_Condition_Type] },
            { no: 2, name: "offset_secs", kind: "scalar", oneof: "offset", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "offset_percent", kind: "scalar", oneof: "offset", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "channel", kind: "enum", oneof: "checkValue", T: () => ["pb.AudioMessage.ClusterDesc.Channel", AudioMessage_ClusterDesc_Channel] },
            { no: 4, name: "seq_id", kind: "scalar", oneof: "checkValue", T: 4 /*ScalarType.UINT64*/ },
            { no: 6, name: "property", kind: "message", oneof: "checkValue", T: () => AudioMessage_ClusterProperty }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterDesc_Condition>): AudioMessage_ClusterDesc_Condition {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offset = { oneofKind: undefined };
        message.checkValue = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterDesc_Condition>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterDesc_Condition): AudioMessage_ClusterDesc_Condition {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.ClusterDesc.Condition.Type check_type */ 1:
                    message.checkType = reader.int32();
                    break;
                case /* float offset_secs */ 2:
                    message.offset = {
                        oneofKind: "offsetSecs",
                        offsetSecs: reader.float()
                    };
                    break;
                case /* float offset_percent */ 7:
                    message.offset = {
                        oneofKind: "offsetPercent",
                        offsetPercent: reader.float()
                    };
                    break;
                case /* pb.AudioMessage.ClusterDesc.Channel channel */ 3:
                    message.checkValue = {
                        oneofKind: "channel",
                        channel: reader.int32()
                    };
                    break;
                case /* uint64 seq_id */ 4:
                    message.checkValue = {
                        oneofKind: "seqId",
                        seqId: reader.uint64().toString()
                    };
                    break;
                case /* pb.AudioMessage.ClusterProperty property */ 6:
                    message.checkValue = {
                        oneofKind: "property",
                        property: AudioMessage_ClusterProperty.internalBinaryRead(reader, reader.uint32(), options, (message.checkValue as any).property)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterDesc_Condition, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.ClusterDesc.Condition.Type check_type = 1; */
        if (message.checkType !== undefined)
            writer.tag(1, WireType.Varint).int32(message.checkType);
        /* float offset_secs = 2; */
        if (message.offset.oneofKind === "offsetSecs")
            writer.tag(2, WireType.Bit32).float(message.offset.offsetSecs);
        /* pb.AudioMessage.ClusterDesc.Channel channel = 3; */
        if (message.checkValue.oneofKind === "channel")
            writer.tag(3, WireType.Varint).int32(message.checkValue.channel);
        /* uint64 seq_id = 4; */
        if (message.checkValue.oneofKind === "seqId")
            writer.tag(4, WireType.Varint).uint64(message.checkValue.seqId);
        /* pb.AudioMessage.ClusterProperty property = 6; */
        if (message.checkValue.oneofKind === "property")
            AudioMessage_ClusterProperty.internalBinaryWrite(message.checkValue.property, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* float offset_percent = 7; */
        if (message.offset.oneofKind === "offsetPercent")
            writer.tag(7, WireType.Bit32).float(message.offset.offsetPercent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterDesc.Condition
 */
export const AudioMessage_ClusterDesc_Condition = new AudioMessage_ClusterDesc_Condition$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterDesc_VoicePayload$Type extends MessageType<AudioMessage_ClusterDesc_VoicePayload> {
    constructor() {
        super("pb.AudioMessage.ClusterDesc.VoicePayload", [
            { no: 2, name: "transcript", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "anim_emotion", kind: "enum", opt: true, T: () => ["pb.AudioMessage.AvatarEmotion", AudioMessage_AvatarEmotion] },
            { no: 6, name: "emotion", kind: "message", T: () => AudioMessage_EmotionDesc },
            { no: 5, name: "voice_emotion", kind: "enum", opt: true, T: () => ["pb.AudioMessage.AvatarEmotion", AudioMessage_AvatarEmotion] },
            { no: 4, name: "msg", kind: "message", T: () => AudioMessage_Msg }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterDesc_VoicePayload>): AudioMessage_ClusterDesc_VoicePayload {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterDesc_VoicePayload>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterDesc_VoicePayload): AudioMessage_ClusterDesc_VoicePayload {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string transcript */ 2:
                    message.transcript = reader.string();
                    break;
                case /* optional pb.AudioMessage.AvatarEmotion anim_emotion */ 3:
                    message.animEmotion = reader.int32();
                    break;
                case /* optional pb.AudioMessage.EmotionDesc emotion */ 6:
                    message.emotion = AudioMessage_EmotionDesc.internalBinaryRead(reader, reader.uint32(), options, message.emotion);
                    break;
                case /* optional pb.AudioMessage.AvatarEmotion voice_emotion */ 5:
                    message.voiceEmotion = reader.int32();
                    break;
                case /* optional pb.AudioMessage.Msg msg */ 4:
                    message.msg = AudioMessage_Msg.internalBinaryRead(reader, reader.uint32(), options, message.msg);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterDesc_VoicePayload, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string transcript = 2; */
        if (message.transcript !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.transcript);
        /* optional pb.AudioMessage.AvatarEmotion anim_emotion = 3; */
        if (message.animEmotion !== undefined)
            writer.tag(3, WireType.Varint).int32(message.animEmotion);
        /* optional pb.AudioMessage.Msg msg = 4; */
        if (message.msg)
            AudioMessage_Msg.internalBinaryWrite(message.msg, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.AvatarEmotion voice_emotion = 5; */
        if (message.voiceEmotion !== undefined)
            writer.tag(5, WireType.Varint).int32(message.voiceEmotion);
        /* optional pb.AudioMessage.EmotionDesc emotion = 6; */
        if (message.emotion)
            AudioMessage_EmotionDesc.internalBinaryWrite(message.emotion, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterDesc.VoicePayload
 */
export const AudioMessage_ClusterDesc_VoicePayload = new AudioMessage_ClusterDesc_VoicePayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterDesc_AnimPayload$Type extends MessageType<AudioMessage_ClusterDesc_AnimPayload> {
    constructor() {
        super("pb.AudioMessage.ClusterDesc.AnimPayload", [
            { no: 1, name: "anim_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "anim_speed", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterDesc_AnimPayload>): AudioMessage_ClusterDesc_AnimPayload {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterDesc_AnimPayload>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterDesc_AnimPayload): AudioMessage_ClusterDesc_AnimPayload {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string anim_name */ 1:
                    message.animName = reader.string();
                    break;
                case /* optional float anim_speed */ 2:
                    message.animSpeed = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterDesc_AnimPayload, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string anim_name = 1; */
        if (message.animName !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.animName);
        /* optional float anim_speed = 2; */
        if (message.animSpeed !== undefined)
            writer.tag(2, WireType.Bit32).float(message.animSpeed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterDesc.AnimPayload
 */
export const AudioMessage_ClusterDesc_AnimPayload = new AudioMessage_ClusterDesc_AnimPayload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClusterInfo$Type extends MessageType<AudioMessage_ClusterInfo> {
    constructor() {
        super("pb.AudioMessage.ClusterInfo", [
            { no: 1, name: "max_seq_id", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 2, name: "clusters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_ClusterDesc },
            { no: 3, name: "properties", kind: "message", T: () => AudioMessage_ClusterProperties }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClusterInfo>): AudioMessage_ClusterInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clusters = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClusterInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClusterInfo): AudioMessage_ClusterInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional uint64 max_seq_id */ 1:
                    message.maxSeqId = reader.uint64().toString();
                    break;
                case /* repeated pb.AudioMessage.ClusterDesc clusters */ 2:
                    message.clusters.push(AudioMessage_ClusterDesc.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional pb.AudioMessage.ClusterProperties properties */ 3:
                    message.properties = AudioMessage_ClusterProperties.internalBinaryRead(reader, reader.uint32(), options, message.properties);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClusterInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional uint64 max_seq_id = 1; */
        if (message.maxSeqId !== undefined)
            writer.tag(1, WireType.Varint).uint64(message.maxSeqId);
        /* repeated pb.AudioMessage.ClusterDesc clusters = 2; */
        for (let i = 0; i < message.clusters.length; i++)
            AudioMessage_ClusterDesc.internalBinaryWrite(message.clusters[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.ClusterProperties properties = 3; */
        if (message.properties)
            AudioMessage_ClusterProperties.internalBinaryWrite(message.properties, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClusterInfo
 */
export const AudioMessage_ClusterInfo = new AudioMessage_ClusterInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_DevicePermissions$Type extends MessageType<AudioMessage_DevicePermissions> {
    constructor() {
        super("pb.AudioMessage.DevicePermissions", [
            { no: 1, name: "ios_push_notification", kind: "message", T: () => AudioMessage_DevicePermissions_IOSPermissions },
            { no: 2, name: "browser_microphone_permission", kind: "message", T: () => AudioMessage_DevicePermissions_BrowserPermission },
            { no: 4, name: "browser_pixel_streaming_auto_playable_interaction", kind: "message", T: () => AudioMessage_DevicePermissions_BrowserInteractionClickState }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_DevicePermissions>): AudioMessage_DevicePermissions {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_DevicePermissions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_DevicePermissions): AudioMessage_DevicePermissions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.DevicePermissions.IOSPermissions ios_push_notification */ 1:
                    message.iosPushNotification = AudioMessage_DevicePermissions_IOSPermissions.internalBinaryRead(reader, reader.uint32(), options, message.iosPushNotification);
                    break;
                case /* optional pb.AudioMessage.DevicePermissions.BrowserPermission browser_microphone_permission */ 2:
                    message.browserMicrophonePermission = AudioMessage_DevicePermissions_BrowserPermission.internalBinaryRead(reader, reader.uint32(), options, message.browserMicrophonePermission);
                    break;
                case /* optional pb.AudioMessage.DevicePermissions.BrowserInteractionClickState browser_pixel_streaming_auto_playable_interaction */ 4:
                    message.browserPixelStreamingAutoPlayableInteraction = AudioMessage_DevicePermissions_BrowserInteractionClickState.internalBinaryRead(reader, reader.uint32(), options, message.browserPixelStreamingAutoPlayableInteraction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_DevicePermissions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.DevicePermissions.IOSPermissions ios_push_notification = 1; */
        if (message.iosPushNotification)
            AudioMessage_DevicePermissions_IOSPermissions.internalBinaryWrite(message.iosPushNotification, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.DevicePermissions.BrowserPermission browser_microphone_permission = 2; */
        if (message.browserMicrophonePermission)
            AudioMessage_DevicePermissions_BrowserPermission.internalBinaryWrite(message.browserMicrophonePermission, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.DevicePermissions.BrowserInteractionClickState browser_pixel_streaming_auto_playable_interaction = 4; */
        if (message.browserPixelStreamingAutoPlayableInteraction)
            AudioMessage_DevicePermissions_BrowserInteractionClickState.internalBinaryWrite(message.browserPixelStreamingAutoPlayableInteraction, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.DevicePermissions
 */
export const AudioMessage_DevicePermissions = new AudioMessage_DevicePermissions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_DevicePermissions_IOSPermissions$Type extends MessageType<AudioMessage_DevicePermissions_IOSPermissions> {
    constructor() {
        super("pb.AudioMessage.DevicePermissions.IOSPermissions", [
            { no: 1, name: "status", kind: "enum", T: () => ["pb.AudioMessage.DevicePermissions.IOSPermissions.Status", AudioMessage_DevicePermissions_IOSPermissions_Status] }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_DevicePermissions_IOSPermissions>): AudioMessage_DevicePermissions_IOSPermissions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_DevicePermissions_IOSPermissions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_DevicePermissions_IOSPermissions): AudioMessage_DevicePermissions_IOSPermissions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pb.AudioMessage.DevicePermissions.IOSPermissions.Status status */ 1:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_DevicePermissions_IOSPermissions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pb.AudioMessage.DevicePermissions.IOSPermissions.Status status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.DevicePermissions.IOSPermissions
 */
export const AudioMessage_DevicePermissions_IOSPermissions = new AudioMessage_DevicePermissions_IOSPermissions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_DevicePermissions_BrowserPermission$Type extends MessageType<AudioMessage_DevicePermissions_BrowserPermission> {
    constructor() {
        super("pb.AudioMessage.DevicePermissions.BrowserPermission", [
            { no: 1, name: "status", kind: "enum", T: () => ["pb.AudioMessage.DevicePermissions.BrowserPermission.Status", AudioMessage_DevicePermissions_BrowserPermission_Status, "STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_DevicePermissions_BrowserPermission>): AudioMessage_DevicePermissions_BrowserPermission {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_DevicePermissions_BrowserPermission>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_DevicePermissions_BrowserPermission): AudioMessage_DevicePermissions_BrowserPermission {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pb.AudioMessage.DevicePermissions.BrowserPermission.Status status */ 1:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_DevicePermissions_BrowserPermission, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pb.AudioMessage.DevicePermissions.BrowserPermission.Status status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.DevicePermissions.BrowserPermission
 */
export const AudioMessage_DevicePermissions_BrowserPermission = new AudioMessage_DevicePermissions_BrowserPermission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_DevicePermissions_BrowserInteractionClickState$Type extends MessageType<AudioMessage_DevicePermissions_BrowserInteractionClickState> {
    constructor() {
        super("pb.AudioMessage.DevicePermissions.BrowserInteractionClickState", [
            { no: 1, name: "status", kind: "enum", T: () => ["pb.AudioMessage.DevicePermissions.BrowserInteractionClickState.Status", AudioMessage_DevicePermissions_BrowserInteractionClickState_Status, "STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_DevicePermissions_BrowserInteractionClickState>): AudioMessage_DevicePermissions_BrowserInteractionClickState {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_DevicePermissions_BrowserInteractionClickState>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_DevicePermissions_BrowserInteractionClickState): AudioMessage_DevicePermissions_BrowserInteractionClickState {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pb.AudioMessage.DevicePermissions.BrowserInteractionClickState.Status status */ 1:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_DevicePermissions_BrowserInteractionClickState, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pb.AudioMessage.DevicePermissions.BrowserInteractionClickState.Status status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.DevicePermissions.BrowserInteractionClickState
 */
export const AudioMessage_DevicePermissions_BrowserInteractionClickState = new AudioMessage_DevicePermissions_BrowserInteractionClickState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_EmotionDesc$Type extends MessageType<AudioMessage_EmotionDesc> {
    constructor() {
        super("pb.AudioMessage.EmotionDesc", [
            { no: 1, name: "emotion", kind: "enum", opt: true, T: () => ["pb.AudioMessage.AvatarEmotion", AudioMessage_AvatarEmotion] },
            { no: 5, name: "voice_emotion", kind: "enum", opt: true, T: () => ["pb.AudioMessage.AvatarEmotion", AudioMessage_AvatarEmotion] },
            { no: 2, name: "intensity", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "face_intensity", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "body_intensity", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "intent_code", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Intent", AudioMessage_Intent] },
            { no: 7, name: "markup", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_EmotionDesc>): AudioMessage_EmotionDesc {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_EmotionDesc>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_EmotionDesc): AudioMessage_EmotionDesc {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.AvatarEmotion emotion */ 1:
                    message.emotion = reader.int32();
                    break;
                case /* optional pb.AudioMessage.AvatarEmotion voice_emotion */ 5:
                    message.voiceEmotion = reader.int32();
                    break;
                case /* optional float intensity */ 2:
                    message.intensity = reader.float();
                    break;
                case /* optional float face_intensity */ 3:
                    message.faceIntensity = reader.float();
                    break;
                case /* optional float body_intensity */ 4:
                    message.bodyIntensity = reader.float();
                    break;
                case /* optional pb.AudioMessage.Intent intent_code */ 6:
                    message.intentCode = reader.int32();
                    break;
                case /* optional string markup */ 7:
                    message.markup = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_EmotionDesc, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.AvatarEmotion emotion = 1; */
        if (message.emotion !== undefined)
            writer.tag(1, WireType.Varint).int32(message.emotion);
        /* optional float intensity = 2; */
        if (message.intensity !== undefined)
            writer.tag(2, WireType.Bit32).float(message.intensity);
        /* optional float face_intensity = 3; */
        if (message.faceIntensity !== undefined)
            writer.tag(3, WireType.Bit32).float(message.faceIntensity);
        /* optional float body_intensity = 4; */
        if (message.bodyIntensity !== undefined)
            writer.tag(4, WireType.Bit32).float(message.bodyIntensity);
        /* optional pb.AudioMessage.AvatarEmotion voice_emotion = 5; */
        if (message.voiceEmotion !== undefined)
            writer.tag(5, WireType.Varint).int32(message.voiceEmotion);
        /* optional pb.AudioMessage.Intent intent_code = 6; */
        if (message.intentCode !== undefined)
            writer.tag(6, WireType.Varint).int32(message.intentCode);
        /* optional string markup = 7; */
        if (message.markup !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.markup);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.EmotionDesc
 */
export const AudioMessage_EmotionDesc = new AudioMessage_EmotionDesc$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_DisplayInfo$Type extends MessageType<AudioMessage_DisplayInfo> {
    constructor() {
        super("pb.AudioMessage.DisplayInfo", [
            { no: 1, name: "display_id", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 2, name: "orientation", kind: "enum", opt: true, T: () => ["pb.AudioMessage.DisplayInfo.Orientation", AudioMessage_DisplayInfo_Orientation] },
            { no: 3, name: "render_width", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "render_height", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_DisplayInfo>): AudioMessage_DisplayInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_DisplayInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_DisplayInfo): AudioMessage_DisplayInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional uint64 display_id */ 1:
                    message.displayId = reader.uint64().toString();
                    break;
                case /* optional pb.AudioMessage.DisplayInfo.Orientation orientation */ 2:
                    message.orientation = reader.int32();
                    break;
                case /* optional float render_width */ 3:
                    message.renderWidth = reader.float();
                    break;
                case /* optional float render_height */ 4:
                    message.renderHeight = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_DisplayInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional uint64 display_id = 1; */
        if (message.displayId !== undefined)
            writer.tag(1, WireType.Varint).uint64(message.displayId);
        /* optional pb.AudioMessage.DisplayInfo.Orientation orientation = 2; */
        if (message.orientation !== undefined)
            writer.tag(2, WireType.Varint).int32(message.orientation);
        /* optional float render_width = 3; */
        if (message.renderWidth !== undefined)
            writer.tag(3, WireType.Bit32).float(message.renderWidth);
        /* optional float render_height = 4; */
        if (message.renderHeight !== undefined)
            writer.tag(4, WireType.Bit32).float(message.renderHeight);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.DisplayInfo
 */
export const AudioMessage_DisplayInfo = new AudioMessage_DisplayInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_SpeakerInfo$Type extends MessageType<AudioMessage_SpeakerInfo> {
    constructor() {
        super("pb.AudioMessage.SpeakerInfo", [
            { no: 1, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "focused", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "speaker_connection", kind: "message", T: () => AudioMessage_SpeakerConnection }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_SpeakerInfo>): AudioMessage_SpeakerInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_SpeakerInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_SpeakerInfo): AudioMessage_SpeakerInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string name */ 1:
                    message.name = reader.string();
                    break;
                case /* optional string uid */ 2:
                    message.uid = reader.string();
                    break;
                case /* optional bool focused */ 3:
                    message.focused = reader.bool();
                    break;
                case /* pb.AudioMessage.SpeakerConnection speaker_connection */ 4:
                    message.speakerConnection = AudioMessage_SpeakerConnection.internalBinaryRead(reader, reader.uint32(), options, message.speakerConnection);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_SpeakerInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string name = 1; */
        if (message.name !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* optional string uid = 2; */
        if (message.uid !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.uid);
        /* optional bool focused = 3; */
        if (message.focused !== undefined)
            writer.tag(3, WireType.Varint).bool(message.focused);
        /* pb.AudioMessage.SpeakerConnection speaker_connection = 4; */
        if (message.speakerConnection)
            AudioMessage_SpeakerConnection.internalBinaryWrite(message.speakerConnection, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.SpeakerInfo
 */
export const AudioMessage_SpeakerInfo = new AudioMessage_SpeakerInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_SpeakerConnection$Type extends MessageType<AudioMessage_SpeakerConnection> {
    constructor() {
        super("pb.AudioMessage.SpeakerConnection", [
            { no: 2, name: "user_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "user_email", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "connection_status", kind: "enum", T: () => ["pb.AudioMessage.SpeakerConnection.ConnectionStatus", AudioMessage_SpeakerConnection_ConnectionStatus, "CONNECTION_STATUS_"] },
            { no: 5, name: "connection_status_message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mic_enabled", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "mic_user_permissioned", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "stream_activated", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_SpeakerConnection>): AudioMessage_SpeakerConnection {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.connectionStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_SpeakerConnection>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_SpeakerConnection): AudioMessage_SpeakerConnection {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* optional string user_email */ 7:
                    message.userEmail = reader.string();
                    break;
                case /* pb.AudioMessage.SpeakerConnection.ConnectionStatus connection_status */ 4:
                    message.connectionStatus = reader.int32();
                    break;
                case /* optional string connection_status_message */ 5:
                    message.connectionStatusMessage = reader.string();
                    break;
                case /* optional bool mic_enabled */ 6:
                    message.micEnabled = reader.bool();
                    break;
                case /* optional bool mic_user_permissioned */ 8:
                    message.micUserPermissioned = reader.bool();
                    break;
                case /* optional bool stream_activated */ 9:
                    message.streamActivated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_SpeakerConnection, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string user_id = 2; */
        if (message.userId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* pb.AudioMessage.SpeakerConnection.ConnectionStatus connection_status = 4; */
        if (message.connectionStatus !== 0)
            writer.tag(4, WireType.Varint).int32(message.connectionStatus);
        /* optional string connection_status_message = 5; */
        if (message.connectionStatusMessage !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.connectionStatusMessage);
        /* optional bool mic_enabled = 6; */
        if (message.micEnabled !== undefined)
            writer.tag(6, WireType.Varint).bool(message.micEnabled);
        /* optional string user_email = 7; */
        if (message.userEmail !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.userEmail);
        /* optional bool mic_user_permissioned = 8; */
        if (message.micUserPermissioned !== undefined)
            writer.tag(8, WireType.Varint).bool(message.micUserPermissioned);
        /* optional bool stream_activated = 9; */
        if (message.streamActivated !== undefined)
            writer.tag(9, WireType.Varint).bool(message.streamActivated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.SpeakerConnection
 */
export const AudioMessage_SpeakerConnection = new AudioMessage_SpeakerConnection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ClientInfo$Type extends MessageType<AudioMessage_ClientInfo> {
    constructor() {
        super("pb.AudioMessage.ClientInfo", [
            { no: 1, name: "speaking", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "microphone", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "microphone_maybe_talking", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "microphone_volume", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "avatar_state", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClientInfo.AvatarState", AudioMessage_ClientInfo_AvatarState] },
            { no: 6, name: "microphone_transmitting", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "ear_mode_desired", kind: "enum", opt: true, T: () => ["pb.AudioMessage.EarMode", AudioMessage_EarMode] },
            { no: 8, name: "max_delta_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 9, name: "spoken_audio_cluster", kind: "message", T: () => AudioMessage_AudioClusterStatus },
            { no: 10, name: "speech_desired", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "avatar_visible", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "media_uploading", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "user_activity", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClientInfo.UserActivity", AudioMessage_ClientInfo_UserActivity] },
            { no: 15, name: "device_permissions", kind: "message", T: () => AudioMessage_DevicePermissions },
            { no: 16, name: "loading_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClientLoadingStatus", AudioMessage_ClientLoadingStatus] },
            { no: 17, name: "pause_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClientPauseStatus", AudioMessage_ClientPauseStatus] },
            { no: 18, name: "user_desired_pause_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClientPauseStatus", AudioMessage_ClientPauseStatus] },
            { no: 19, name: "display_info", kind: "message", T: () => AudioMessage_DisplayInfo },
            { no: 20, name: "user_desired_display_info", kind: "message", T: () => AudioMessage_DisplayInfo }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ClientInfo>): AudioMessage_ClientInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ClientInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ClientInfo): AudioMessage_ClientInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional bool speaking */ 1:
                    message.speaking = reader.bool();
                    break;
                case /* optional bool microphone */ 2:
                    message.microphone = reader.bool();
                    break;
                case /* optional bool microphone_maybe_talking */ 3:
                    message.microphoneMaybeTalking = reader.bool();
                    break;
                case /* optional float microphone_volume */ 4:
                    message.microphoneVolume = reader.float();
                    break;
                case /* optional pb.AudioMessage.ClientInfo.AvatarState avatar_state */ 5:
                    message.avatarState = reader.int32();
                    break;
                case /* optional bool microphone_transmitting */ 6:
                    message.microphoneTransmitting = reader.bool();
                    break;
                case /* optional pb.AudioMessage.EarMode ear_mode_desired */ 14:
                    message.earModeDesired = reader.int32();
                    break;
                case /* optional int64 max_delta_id */ 8:
                    message.maxDeltaId = reader.int64().toString();
                    break;
                case /* optional pb.AudioMessage.AudioClusterStatus spoken_audio_cluster */ 9:
                    message.spokenAudioCluster = AudioMessage_AudioClusterStatus.internalBinaryRead(reader, reader.uint32(), options, message.spokenAudioCluster);
                    break;
                case /* optional bool speech_desired */ 10:
                    message.speechDesired = reader.bool();
                    break;
                case /* optional bool avatar_visible */ 11:
                    message.avatarVisible = reader.bool();
                    break;
                case /* optional bool media_uploading */ 13:
                    message.mediaUploading = reader.bool();
                    break;
                case /* optional pb.AudioMessage.ClientInfo.UserActivity user_activity */ 12:
                    message.userActivity = reader.int32();
                    break;
                case /* optional pb.AudioMessage.DevicePermissions device_permissions */ 15:
                    message.devicePermissions = AudioMessage_DevicePermissions.internalBinaryRead(reader, reader.uint32(), options, message.devicePermissions);
                    break;
                case /* optional pb.AudioMessage.ClientLoadingStatus loading_status */ 16:
                    message.loadingStatus = reader.int32();
                    break;
                case /* optional pb.AudioMessage.ClientPauseStatus pause_status */ 17:
                    message.pauseStatus = reader.int32();
                    break;
                case /* optional pb.AudioMessage.ClientPauseStatus user_desired_pause_status */ 18:
                    message.userDesiredPauseStatus = reader.int32();
                    break;
                case /* optional pb.AudioMessage.DisplayInfo display_info */ 19:
                    message.displayInfo = AudioMessage_DisplayInfo.internalBinaryRead(reader, reader.uint32(), options, message.displayInfo);
                    break;
                case /* optional pb.AudioMessage.DisplayInfo user_desired_display_info */ 20:
                    message.userDesiredDisplayInfo = AudioMessage_DisplayInfo.internalBinaryRead(reader, reader.uint32(), options, message.userDesiredDisplayInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ClientInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional bool speaking = 1; */
        if (message.speaking !== undefined)
            writer.tag(1, WireType.Varint).bool(message.speaking);
        /* optional bool microphone = 2; */
        if (message.microphone !== undefined)
            writer.tag(2, WireType.Varint).bool(message.microphone);
        /* optional bool microphone_maybe_talking = 3; */
        if (message.microphoneMaybeTalking !== undefined)
            writer.tag(3, WireType.Varint).bool(message.microphoneMaybeTalking);
        /* optional float microphone_volume = 4; */
        if (message.microphoneVolume !== undefined)
            writer.tag(4, WireType.Bit32).float(message.microphoneVolume);
        /* optional pb.AudioMessage.ClientInfo.AvatarState avatar_state = 5; */
        if (message.avatarState !== undefined)
            writer.tag(5, WireType.Varint).int32(message.avatarState);
        /* optional bool microphone_transmitting = 6; */
        if (message.microphoneTransmitting !== undefined)
            writer.tag(6, WireType.Varint).bool(message.microphoneTransmitting);
        /* optional int64 max_delta_id = 8; */
        if (message.maxDeltaId !== undefined)
            writer.tag(8, WireType.Varint).int64(message.maxDeltaId);
        /* optional pb.AudioMessage.AudioClusterStatus spoken_audio_cluster = 9; */
        if (message.spokenAudioCluster)
            AudioMessage_AudioClusterStatus.internalBinaryWrite(message.spokenAudioCluster, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* optional bool speech_desired = 10; */
        if (message.speechDesired !== undefined)
            writer.tag(10, WireType.Varint).bool(message.speechDesired);
        /* optional bool avatar_visible = 11; */
        if (message.avatarVisible !== undefined)
            writer.tag(11, WireType.Varint).bool(message.avatarVisible);
        /* optional pb.AudioMessage.ClientInfo.UserActivity user_activity = 12; */
        if (message.userActivity !== undefined)
            writer.tag(12, WireType.Varint).int32(message.userActivity);
        /* optional bool media_uploading = 13; */
        if (message.mediaUploading !== undefined)
            writer.tag(13, WireType.Varint).bool(message.mediaUploading);
        /* optional pb.AudioMessage.EarMode ear_mode_desired = 14; */
        if (message.earModeDesired !== undefined)
            writer.tag(14, WireType.Varint).int32(message.earModeDesired);
        /* optional pb.AudioMessage.DevicePermissions device_permissions = 15; */
        if (message.devicePermissions)
            AudioMessage_DevicePermissions.internalBinaryWrite(message.devicePermissions, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.ClientLoadingStatus loading_status = 16; */
        if (message.loadingStatus !== undefined)
            writer.tag(16, WireType.Varint).int32(message.loadingStatus);
        /* optional pb.AudioMessage.ClientPauseStatus pause_status = 17; */
        if (message.pauseStatus !== undefined)
            writer.tag(17, WireType.Varint).int32(message.pauseStatus);
        /* optional pb.AudioMessage.ClientPauseStatus user_desired_pause_status = 18; */
        if (message.userDesiredPauseStatus !== undefined)
            writer.tag(18, WireType.Varint).int32(message.userDesiredPauseStatus);
        /* optional pb.AudioMessage.DisplayInfo display_info = 19; */
        if (message.displayInfo)
            AudioMessage_DisplayInfo.internalBinaryWrite(message.displayInfo, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.DisplayInfo user_desired_display_info = 20; */
        if (message.userDesiredDisplayInfo)
            AudioMessage_DisplayInfo.internalBinaryWrite(message.userDesiredDisplayInfo, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ClientInfo
 */
export const AudioMessage_ClientInfo = new AudioMessage_ClientInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ServerInfo$Type extends MessageType<AudioMessage_ServerInfo> {
    constructor() {
        super("pb.AudioMessage.ServerInfo", [
            { no: 1, name: "heard_something", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "listening", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "ear_error_msg", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "ear_audio_cluster", kind: "message", T: () => AudioMessage_AudioClusterStatus },
            { no: 2, name: "thinking", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "cortex_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ServerInfo.CortexStatus", AudioMessage_ServerInfo_CortexStatus] },
            { no: 5, name: "mouthing", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "regen_allowed", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "input_allowed", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "num_mouth_samples", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "emotions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_EmotionDesc },
            { no: 10, name: "speakers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_SpeakerInfo },
            { no: 13, name: "config", kind: "message", T: () => AudioMessage_ServerInfo_Config },
            { no: 14, name: "client_loading_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClientLoadingStatus", AudioMessage_ClientLoadingStatus] },
            { no: 16, name: "desired_pause_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ClientPauseStatus", AudioMessage_ClientPauseStatus] },
            { no: 17, name: "client_display_info", kind: "message", T: () => AudioMessage_DisplayInfo },
            { no: 18, name: "desired_display_info", kind: "message", T: () => AudioMessage_DisplayInfo },
            { no: 19, name: "health_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ServerInfo.HealthStatus", AudioMessage_ServerInfo_HealthStatus] },
            { no: 20, name: "avatar_language", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Language", AudioMessage_Language] },
            { no: 21, name: "avatar_language_code", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ServerInfo>): AudioMessage_ServerInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.emotions = [];
        message.speakers = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ServerInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ServerInfo): AudioMessage_ServerInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional bool heard_something */ 1:
                    message.heardSomething = reader.bool();
                    break;
                case /* optional bool listening */ 12:
                    message.listening = reader.bool();
                    break;
                case /* optional string ear_error_msg */ 8:
                    message.earErrorMsg = reader.string();
                    break;
                case /* optional pb.AudioMessage.AudioClusterStatus ear_audio_cluster */ 9:
                    message.earAudioCluster = AudioMessage_AudioClusterStatus.internalBinaryRead(reader, reader.uint32(), options, message.earAudioCluster);
                    break;
                case /* optional bool thinking */ 2:
                    message.thinking = reader.bool();
                    break;
                case /* optional pb.AudioMessage.ServerInfo.CortexStatus cortex_status */ 11:
                    message.cortexStatus = reader.int32();
                    break;
                case /* optional bool mouthing */ 5:
                    message.mouthing = reader.bool();
                    break;
                case /* optional bool regen_allowed */ 6:
                    message.regenAllowed = reader.bool();
                    break;
                case /* optional bool input_allowed */ 7:
                    message.inputAllowed = reader.bool();
                    break;
                case /* optional uint32 num_mouth_samples */ 3:
                    message.numMouthSamples = reader.uint32();
                    break;
                case /* repeated pb.AudioMessage.EmotionDesc emotions */ 4:
                    message.emotions.push(AudioMessage_EmotionDesc.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated pb.AudioMessage.SpeakerInfo speakers */ 10:
                    message.speakers.push(AudioMessage_SpeakerInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* pb.AudioMessage.ServerInfo.Config config */ 13:
                    message.config = AudioMessage_ServerInfo_Config.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* optional pb.AudioMessage.ClientLoadingStatus client_loading_status */ 14:
                    message.clientLoadingStatus = reader.int32();
                    break;
                case /* optional pb.AudioMessage.ClientPauseStatus desired_pause_status */ 16:
                    message.desiredPauseStatus = reader.int32();
                    break;
                case /* optional pb.AudioMessage.DisplayInfo client_display_info */ 17:
                    message.clientDisplayInfo = AudioMessage_DisplayInfo.internalBinaryRead(reader, reader.uint32(), options, message.clientDisplayInfo);
                    break;
                case /* optional pb.AudioMessage.DisplayInfo desired_display_info */ 18:
                    message.desiredDisplayInfo = AudioMessage_DisplayInfo.internalBinaryRead(reader, reader.uint32(), options, message.desiredDisplayInfo);
                    break;
                case /* optional pb.AudioMessage.ServerInfo.HealthStatus health_status */ 19:
                    message.healthStatus = reader.int32();
                    break;
                case /* optional pb.AudioMessage.Language avatar_language */ 20:
                    message.avatarLanguage = reader.int32();
                    break;
                case /* optional string avatar_language_code */ 21:
                    message.avatarLanguageCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ServerInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional bool heard_something = 1; */
        if (message.heardSomething !== undefined)
            writer.tag(1, WireType.Varint).bool(message.heardSomething);
        /* optional bool thinking = 2; */
        if (message.thinking !== undefined)
            writer.tag(2, WireType.Varint).bool(message.thinking);
        /* optional uint32 num_mouth_samples = 3; */
        if (message.numMouthSamples !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.numMouthSamples);
        /* repeated pb.AudioMessage.EmotionDesc emotions = 4; */
        for (let i = 0; i < message.emotions.length; i++)
            AudioMessage_EmotionDesc.internalBinaryWrite(message.emotions[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional bool mouthing = 5; */
        if (message.mouthing !== undefined)
            writer.tag(5, WireType.Varint).bool(message.mouthing);
        /* optional bool regen_allowed = 6; */
        if (message.regenAllowed !== undefined)
            writer.tag(6, WireType.Varint).bool(message.regenAllowed);
        /* optional bool input_allowed = 7; */
        if (message.inputAllowed !== undefined)
            writer.tag(7, WireType.Varint).bool(message.inputAllowed);
        /* optional string ear_error_msg = 8; */
        if (message.earErrorMsg !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.earErrorMsg);
        /* optional pb.AudioMessage.AudioClusterStatus ear_audio_cluster = 9; */
        if (message.earAudioCluster)
            AudioMessage_AudioClusterStatus.internalBinaryWrite(message.earAudioCluster, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated pb.AudioMessage.SpeakerInfo speakers = 10; */
        for (let i = 0; i < message.speakers.length; i++)
            AudioMessage_SpeakerInfo.internalBinaryWrite(message.speakers[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.ServerInfo.CortexStatus cortex_status = 11; */
        if (message.cortexStatus !== undefined)
            writer.tag(11, WireType.Varint).int32(message.cortexStatus);
        /* optional bool listening = 12; */
        if (message.listening !== undefined)
            writer.tag(12, WireType.Varint).bool(message.listening);
        /* pb.AudioMessage.ServerInfo.Config config = 13; */
        if (message.config)
            AudioMessage_ServerInfo_Config.internalBinaryWrite(message.config, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.ClientLoadingStatus client_loading_status = 14; */
        if (message.clientLoadingStatus !== undefined)
            writer.tag(14, WireType.Varint).int32(message.clientLoadingStatus);
        /* optional pb.AudioMessage.ClientPauseStatus desired_pause_status = 16; */
        if (message.desiredPauseStatus !== undefined)
            writer.tag(16, WireType.Varint).int32(message.desiredPauseStatus);
        /* optional pb.AudioMessage.DisplayInfo client_display_info = 17; */
        if (message.clientDisplayInfo)
            AudioMessage_DisplayInfo.internalBinaryWrite(message.clientDisplayInfo, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.DisplayInfo desired_display_info = 18; */
        if (message.desiredDisplayInfo)
            AudioMessage_DisplayInfo.internalBinaryWrite(message.desiredDisplayInfo, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.ServerInfo.HealthStatus health_status = 19; */
        if (message.healthStatus !== undefined)
            writer.tag(19, WireType.Varint).int32(message.healthStatus);
        /* optional pb.AudioMessage.Language avatar_language = 20; */
        if (message.avatarLanguage !== undefined)
            writer.tag(20, WireType.Varint).int32(message.avatarLanguage);
        /* optional string avatar_language_code = 21; */
        if (message.avatarLanguageCode !== undefined)
            writer.tag(21, WireType.LengthDelimited).string(message.avatarLanguageCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ServerInfo
 */
export const AudioMessage_ServerInfo = new AudioMessage_ServerInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ServerInfo_Config$Type extends MessageType<AudioMessage_ServerInfo_Config> {
    constructor() {
        super("pb.AudioMessage.ServerInfo.Config", [
            { no: 1, name: "hand_gestures", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "audio_sync_offset", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "audio_sync_scalar", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "emotion_timeout_secs", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "emotion_min_secs", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "emotion_listening_fade_secs", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "emotion_thinking_fade_secs", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "emotion_thalamus_fade_secs", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ServerInfo_Config>): AudioMessage_ServerInfo_Config {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ServerInfo_Config>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ServerInfo_Config): AudioMessage_ServerInfo_Config {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional bool hand_gestures */ 1:
                    message.handGestures = reader.bool();
                    break;
                case /* optional float audio_sync_offset */ 2:
                    message.audioSyncOffset = reader.float();
                    break;
                case /* optional float audio_sync_scalar */ 3:
                    message.audioSyncScalar = reader.float();
                    break;
                case /* optional float emotion_timeout_secs */ 4:
                    message.emotionTimeoutSecs = reader.float();
                    break;
                case /* optional float emotion_min_secs */ 5:
                    message.emotionMinSecs = reader.float();
                    break;
                case /* optional float emotion_listening_fade_secs */ 6:
                    message.emotionListeningFadeSecs = reader.float();
                    break;
                case /* optional float emotion_thinking_fade_secs */ 7:
                    message.emotionThinkingFadeSecs = reader.float();
                    break;
                case /* optional float emotion_thalamus_fade_secs */ 8:
                    message.emotionThalamusFadeSecs = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ServerInfo_Config, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional bool hand_gestures = 1; */
        if (message.handGestures !== undefined)
            writer.tag(1, WireType.Varint).bool(message.handGestures);
        /* optional float audio_sync_offset = 2; */
        if (message.audioSyncOffset !== undefined)
            writer.tag(2, WireType.Bit32).float(message.audioSyncOffset);
        /* optional float audio_sync_scalar = 3; */
        if (message.audioSyncScalar !== undefined)
            writer.tag(3, WireType.Bit32).float(message.audioSyncScalar);
        /* optional float emotion_timeout_secs = 4; */
        if (message.emotionTimeoutSecs !== undefined)
            writer.tag(4, WireType.Bit32).float(message.emotionTimeoutSecs);
        /* optional float emotion_min_secs = 5; */
        if (message.emotionMinSecs !== undefined)
            writer.tag(5, WireType.Bit32).float(message.emotionMinSecs);
        /* optional float emotion_listening_fade_secs = 6; */
        if (message.emotionListeningFadeSecs !== undefined)
            writer.tag(6, WireType.Bit32).float(message.emotionListeningFadeSecs);
        /* optional float emotion_thinking_fade_secs = 7; */
        if (message.emotionThinkingFadeSecs !== undefined)
            writer.tag(7, WireType.Bit32).float(message.emotionThinkingFadeSecs);
        /* optional float emotion_thalamus_fade_secs = 8; */
        if (message.emotionThalamusFadeSecs !== undefined)
            writer.tag(8, WireType.Bit32).float(message.emotionThalamusFadeSecs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ServerInfo.Config
 */
export const AudioMessage_ServerInfo_Config = new AudioMessage_ServerInfo_Config$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ConnectInfo$Type extends MessageType<AudioMessage_ConnectInfo> {
    constructor() {
        super("pb.AudioMessage.ConnectInfo", [
            { no: 1, name: "major_version", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "minor_version", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "msg_version", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "connections", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_ConnectInfo_ConnectionDesc }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ConnectInfo>): AudioMessage_ConnectInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.connections = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ConnectInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ConnectInfo): AudioMessage_ConnectInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional uint32 major_version */ 1:
                    message.majorVersion = reader.uint32();
                    break;
                case /* optional uint32 minor_version */ 2:
                    message.minorVersion = reader.uint32();
                    break;
                case /* optional uint32 msg_version */ 4:
                    message.msgVersion = reader.uint32();
                    break;
                case /* repeated pb.AudioMessage.ConnectInfo.ConnectionDesc connections */ 3:
                    message.connections.push(AudioMessage_ConnectInfo_ConnectionDesc.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ConnectInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional uint32 major_version = 1; */
        if (message.majorVersion !== undefined)
            writer.tag(1, WireType.Varint).uint32(message.majorVersion);
        /* optional uint32 minor_version = 2; */
        if (message.minorVersion !== undefined)
            writer.tag(2, WireType.Varint).uint32(message.minorVersion);
        /* repeated pb.AudioMessage.ConnectInfo.ConnectionDesc connections = 3; */
        for (let i = 0; i < message.connections.length; i++)
            AudioMessage_ConnectInfo_ConnectionDesc.internalBinaryWrite(message.connections[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional uint32 msg_version = 4; */
        if (message.msgVersion !== undefined)
            writer.tag(4, WireType.Varint).uint32(message.msgVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ConnectInfo
 */
export const AudioMessage_ConnectInfo = new AudioMessage_ConnectInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ConnectInfo_Capabilities$Type extends MessageType<AudioMessage_ConnectInfo_Capabilities> {
    constructor() {
        super("pb.AudioMessage.ConnectInfo.Capabilities", [
            { no: 1, name: "speaker_free_audio_clusters", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "spoken_audio_cluster", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "audio_cluster_finish_commands", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "audio_cluster_transferred", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "audio_cluster_playback_hold_time", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "no_mic_during_speech", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "audio_cluster_play_var_sample_rate", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "supports_msg_link_style", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "cluster_info_block", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "properties_on_connect", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "cluster_list_on_connect", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "web_gui_renderer", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ConnectInfo_Capabilities>): AudioMessage_ConnectInfo_Capabilities {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ConnectInfo_Capabilities>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ConnectInfo_Capabilities): AudioMessage_ConnectInfo_Capabilities {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional bool speaker_free_audio_clusters */ 1:
                    message.speakerFreeAudioClusters = reader.bool();
                    break;
                case /* optional bool spoken_audio_cluster */ 2:
                    message.spokenAudioCluster = reader.bool();
                    break;
                case /* optional bool audio_cluster_finish_commands */ 3:
                    message.audioClusterFinishCommands = reader.bool();
                    break;
                case /* optional bool audio_cluster_transferred */ 4:
                    message.audioClusterTransferred = reader.bool();
                    break;
                case /* optional bool audio_cluster_playback_hold_time */ 5:
                    message.audioClusterPlaybackHoldTime = reader.bool();
                    break;
                case /* optional bool no_mic_during_speech */ 6:
                    message.noMicDuringSpeech = reader.bool();
                    break;
                case /* optional bool audio_cluster_play_var_sample_rate */ 7:
                    message.audioClusterPlayVarSampleRate = reader.bool();
                    break;
                case /* optional bool supports_msg_link_style */ 8:
                    message.supportsMsgLinkStyle = reader.bool();
                    break;
                case /* optional bool cluster_info_block */ 9:
                    message.clusterInfoBlock = reader.bool();
                    break;
                case /* optional bool properties_on_connect */ 10:
                    message.propertiesOnConnect = reader.bool();
                    break;
                case /* optional bool cluster_list_on_connect */ 11:
                    message.clusterListOnConnect = reader.bool();
                    break;
                case /* optional bool web_gui_renderer */ 12:
                    message.webGuiRenderer = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ConnectInfo_Capabilities, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional bool speaker_free_audio_clusters = 1; */
        if (message.speakerFreeAudioClusters !== undefined)
            writer.tag(1, WireType.Varint).bool(message.speakerFreeAudioClusters);
        /* optional bool spoken_audio_cluster = 2; */
        if (message.spokenAudioCluster !== undefined)
            writer.tag(2, WireType.Varint).bool(message.spokenAudioCluster);
        /* optional bool audio_cluster_finish_commands = 3; */
        if (message.audioClusterFinishCommands !== undefined)
            writer.tag(3, WireType.Varint).bool(message.audioClusterFinishCommands);
        /* optional bool audio_cluster_transferred = 4; */
        if (message.audioClusterTransferred !== undefined)
            writer.tag(4, WireType.Varint).bool(message.audioClusterTransferred);
        /* optional bool audio_cluster_playback_hold_time = 5; */
        if (message.audioClusterPlaybackHoldTime !== undefined)
            writer.tag(5, WireType.Varint).bool(message.audioClusterPlaybackHoldTime);
        /* optional bool no_mic_during_speech = 6; */
        if (message.noMicDuringSpeech !== undefined)
            writer.tag(6, WireType.Varint).bool(message.noMicDuringSpeech);
        /* optional bool audio_cluster_play_var_sample_rate = 7; */
        if (message.audioClusterPlayVarSampleRate !== undefined)
            writer.tag(7, WireType.Varint).bool(message.audioClusterPlayVarSampleRate);
        /* optional bool supports_msg_link_style = 8; */
        if (message.supportsMsgLinkStyle !== undefined)
            writer.tag(8, WireType.Varint).bool(message.supportsMsgLinkStyle);
        /* optional bool cluster_info_block = 9; */
        if (message.clusterInfoBlock !== undefined)
            writer.tag(9, WireType.Varint).bool(message.clusterInfoBlock);
        /* optional bool properties_on_connect = 10; */
        if (message.propertiesOnConnect !== undefined)
            writer.tag(10, WireType.Varint).bool(message.propertiesOnConnect);
        /* optional bool cluster_list_on_connect = 11; */
        if (message.clusterListOnConnect !== undefined)
            writer.tag(11, WireType.Varint).bool(message.clusterListOnConnect);
        /* optional bool web_gui_renderer = 12; */
        if (message.webGuiRenderer !== undefined)
            writer.tag(12, WireType.Varint).bool(message.webGuiRenderer);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ConnectInfo.Capabilities
 */
export const AudioMessage_ConnectInfo_Capabilities = new AudioMessage_ConnectInfo_Capabilities$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ConnectInfo_UserAccountInfo$Type extends MessageType<AudioMessage_ConnectInfo_UserAccountInfo> {
    constructor() {
        super("pb.AudioMessage.ConnectInfo.UserAccountInfo", [
            { no: 1, name: "full_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "phone_number", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ConnectInfo.UserAccountInfo.UserStatus", AudioMessage_ConnectInfo_UserAccountInfo_UserStatus] }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ConnectInfo_UserAccountInfo>): AudioMessage_ConnectInfo_UserAccountInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ConnectInfo_UserAccountInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ConnectInfo_UserAccountInfo): AudioMessage_ConnectInfo_UserAccountInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string full_name */ 1:
                    message.fullName = reader.string();
                    break;
                case /* optional string email */ 2:
                    message.email = reader.string();
                    break;
                case /* optional string phone_number */ 3:
                    message.phoneNumber = reader.string();
                    break;
                case /* optional pb.AudioMessage.ConnectInfo.UserAccountInfo.UserStatus user_status */ 4:
                    message.userStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ConnectInfo_UserAccountInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string full_name = 1; */
        if (message.fullName !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.fullName);
        /* optional string email = 2; */
        if (message.email !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* optional string phone_number = 3; */
        if (message.phoneNumber !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.phoneNumber);
        /* optional pb.AudioMessage.ConnectInfo.UserAccountInfo.UserStatus user_status = 4; */
        if (message.userStatus !== undefined)
            writer.tag(4, WireType.Varint).int32(message.userStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ConnectInfo.UserAccountInfo
 */
export const AudioMessage_ConnectInfo_UserAccountInfo = new AudioMessage_ConnectInfo_UserAccountInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_ConnectInfo_ConnectionDesc$Type extends MessageType<AudioMessage_ConnectInfo_ConnectionDesc> {
    constructor() {
        super("pb.AudioMessage.ConnectInfo.ConnectionDesc", [
            { no: 1, name: "status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ConnectInfo.ConnectStatus", AudioMessage_ConnectInfo_ConnectStatus] },
            { no: 10, name: "reason", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ConnectInfo.ConnectReason", AudioMessage_ConnectInfo_ConnectReason] },
            { no: 2, name: "conversation_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "phone_number", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "capabilities", kind: "message", T: () => AudioMessage_ConnectInfo_Capabilities },
            { no: 5, name: "last_audio_cluster_seq_id", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 17, name: "cluster_info", kind: "message", T: () => AudioMessage_ClusterInfo },
            { no: 6, name: "priority", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ConnectInfo.ConnectPriority", AudioMessage_ConnectInfo_ConnectPriority] },
            { no: 9, name: "max_delta_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "msg_version", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 11, name: "client_type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.ConnectInfo.ClientType", AudioMessage_ConnectInfo_ClientType] },
            { no: 12, name: "client_build_number", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 13, name: "client_build_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "client_build_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "client_time_zone", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "client_device_model", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "client_os_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "user_account_info", kind: "message", T: () => AudioMessage_ConnectInfo_UserAccountInfo },
            { no: 20, name: "client_app_session_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "client_connect_session_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "client_launch_args_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_ConnectInfo_ConnectionDesc>): AudioMessage_ConnectInfo_ConnectionDesc {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_ConnectInfo_ConnectionDesc>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_ConnectInfo_ConnectionDesc): AudioMessage_ConnectInfo_ConnectionDesc {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.ConnectInfo.ConnectStatus status */ 1:
                    message.status = reader.int32();
                    break;
                case /* optional pb.AudioMessage.ConnectInfo.ConnectReason reason */ 10:
                    message.reason = reader.int32();
                    break;
                case /* optional string conversation_id */ 2:
                    message.conversationId = reader.string();
                    break;
                case /* optional string phone_number */ 3:
                    message.phoneNumber = reader.string();
                    break;
                case /* optional pb.AudioMessage.ConnectInfo.Capabilities capabilities */ 4:
                    message.capabilities = AudioMessage_ConnectInfo_Capabilities.internalBinaryRead(reader, reader.uint32(), options, message.capabilities);
                    break;
                case /* optional uint64 last_audio_cluster_seq_id */ 5:
                    message.lastAudioClusterSeqId = reader.uint64().toString();
                    break;
                case /* optional pb.AudioMessage.ClusterInfo cluster_info */ 17:
                    message.clusterInfo = AudioMessage_ClusterInfo.internalBinaryRead(reader, reader.uint32(), options, message.clusterInfo);
                    break;
                case /* optional pb.AudioMessage.ConnectInfo.ConnectPriority priority */ 6:
                    message.priority = reader.int32();
                    break;
                case /* optional int64 max_delta_id */ 9:
                    message.maxDeltaId = reader.int64().toString();
                    break;
                case /* optional uint32 msg_version */ 7:
                    message.msgVersion = reader.uint32();
                    break;
                case /* optional pb.AudioMessage.ConnectInfo.ClientType client_type */ 11:
                    message.clientType = reader.int32();
                    break;
                case /* optional uint32 client_build_number */ 12:
                    message.clientBuildNumber = reader.uint32();
                    break;
                case /* optional string client_build_version */ 13:
                    message.clientBuildVersion = reader.string();
                    break;
                case /* optional string client_build_name */ 14:
                    message.clientBuildName = reader.string();
                    break;
                case /* optional string client_time_zone */ 15:
                    message.clientTimeZone = reader.string();
                    break;
                case /* optional string client_device_model */ 18:
                    message.clientDeviceModel = reader.string();
                    break;
                case /* optional string client_os_version */ 19:
                    message.clientOsVersion = reader.string();
                    break;
                case /* optional pb.AudioMessage.ConnectInfo.UserAccountInfo user_account_info */ 8:
                    message.userAccountInfo = AudioMessage_ConnectInfo_UserAccountInfo.internalBinaryRead(reader, reader.uint32(), options, message.userAccountInfo);
                    break;
                case /* optional string client_app_session_id */ 20:
                    message.clientAppSessionId = reader.string();
                    break;
                case /* optional string client_connect_session_id */ 21:
                    message.clientConnectSessionId = reader.string();
                    break;
                case /* optional string client_launch_args_id */ 22:
                    message.clientLaunchArgsId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_ConnectInfo_ConnectionDesc, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.ConnectInfo.ConnectStatus status = 1; */
        if (message.status !== undefined)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* optional string conversation_id = 2; */
        if (message.conversationId !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.conversationId);
        /* optional string phone_number = 3; */
        if (message.phoneNumber !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.phoneNumber);
        /* optional pb.AudioMessage.ConnectInfo.Capabilities capabilities = 4; */
        if (message.capabilities)
            AudioMessage_ConnectInfo_Capabilities.internalBinaryWrite(message.capabilities, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional uint64 last_audio_cluster_seq_id = 5; */
        if (message.lastAudioClusterSeqId !== undefined)
            writer.tag(5, WireType.Varint).uint64(message.lastAudioClusterSeqId);
        /* optional pb.AudioMessage.ConnectInfo.ConnectPriority priority = 6; */
        if (message.priority !== undefined)
            writer.tag(6, WireType.Varint).int32(message.priority);
        /* optional uint32 msg_version = 7; */
        if (message.msgVersion !== undefined)
            writer.tag(7, WireType.Varint).uint32(message.msgVersion);
        /* optional pb.AudioMessage.ConnectInfo.UserAccountInfo user_account_info = 8; */
        if (message.userAccountInfo)
            AudioMessage_ConnectInfo_UserAccountInfo.internalBinaryWrite(message.userAccountInfo, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 max_delta_id = 9; */
        if (message.maxDeltaId !== undefined)
            writer.tag(9, WireType.Varint).int64(message.maxDeltaId);
        /* optional pb.AudioMessage.ConnectInfo.ConnectReason reason = 10; */
        if (message.reason !== undefined)
            writer.tag(10, WireType.Varint).int32(message.reason);
        /* optional pb.AudioMessage.ConnectInfo.ClientType client_type = 11; */
        if (message.clientType !== undefined)
            writer.tag(11, WireType.Varint).int32(message.clientType);
        /* optional uint32 client_build_number = 12; */
        if (message.clientBuildNumber !== undefined)
            writer.tag(12, WireType.Varint).uint32(message.clientBuildNumber);
        /* optional string client_build_version = 13; */
        if (message.clientBuildVersion !== undefined)
            writer.tag(13, WireType.LengthDelimited).string(message.clientBuildVersion);
        /* optional string client_build_name = 14; */
        if (message.clientBuildName !== undefined)
            writer.tag(14, WireType.LengthDelimited).string(message.clientBuildName);
        /* optional string client_time_zone = 15; */
        if (message.clientTimeZone !== undefined)
            writer.tag(15, WireType.LengthDelimited).string(message.clientTimeZone);
        /* optional pb.AudioMessage.ClusterInfo cluster_info = 17; */
        if (message.clusterInfo)
            AudioMessage_ClusterInfo.internalBinaryWrite(message.clusterInfo, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* optional string client_device_model = 18; */
        if (message.clientDeviceModel !== undefined)
            writer.tag(18, WireType.LengthDelimited).string(message.clientDeviceModel);
        /* optional string client_os_version = 19; */
        if (message.clientOsVersion !== undefined)
            writer.tag(19, WireType.LengthDelimited).string(message.clientOsVersion);
        /* optional string client_app_session_id = 20; */
        if (message.clientAppSessionId !== undefined)
            writer.tag(20, WireType.LengthDelimited).string(message.clientAppSessionId);
        /* optional string client_connect_session_id = 21; */
        if (message.clientConnectSessionId !== undefined)
            writer.tag(21, WireType.LengthDelimited).string(message.clientConnectSessionId);
        /* optional string client_launch_args_id = 22; */
        if (message.clientLaunchArgsId !== undefined)
            writer.tag(22, WireType.LengthDelimited).string(message.clientLaunchArgsId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.ConnectInfo.ConnectionDesc
 */
export const AudioMessage_ConnectInfo_ConnectionDesc = new AudioMessage_ConnectInfo_ConnectionDesc$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Audio$Type extends MessageType<AudioMessage_Audio> {
    constructor() {
        super("pb.AudioMessage.Audio", [
            { no: 11, name: "ear_mode", kind: "enum", opt: true, T: () => ["pb.AudioMessage.EarMode", AudioMessage_EarMode] },
            { no: 16, name: "speaker_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "hold_time", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "msg_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "transcript", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "emotion", kind: "enum", opt: true, T: () => ["pb.AudioMessage.AvatarEmotion", AudioMessage_AvatarEmotion] },
            { no: 10, name: "cluster_end", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 1, name: "sample_rate", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "channel_count", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "bits_per_channel", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "encoding", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Audio.AudioEncoding", AudioMessage_Audio_AudioEncoding] },
            { no: 5, name: "sample_count", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "volume", kind: "scalar", opt: true, T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "vad_talking", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "recorded_at_ms", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "audio_data", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ },
            { no: 17, name: "aligned_events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_Audio_AlignedEvent }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Audio>): AudioMessage_Audio {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alignedEvents = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Audio>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Audio): AudioMessage_Audio {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.EarMode ear_mode */ 11:
                    message.earMode = reader.int32();
                    break;
                case /* optional string speaker_uid */ 16:
                    message.speakerUid = reader.string();
                    break;
                case /* optional float hold_time */ 14:
                    message.holdTime = reader.float();
                    break;
                case /* optional string msg_uid */ 12:
                    message.msgUid = reader.string();
                    break;
                case /* optional string transcript */ 13:
                    message.transcript = reader.string();
                    break;
                case /* optional pb.AudioMessage.AvatarEmotion emotion */ 9:
                    message.emotion = reader.int32();
                    break;
                case /* optional bool cluster_end */ 10:
                    message.clusterEnd = reader.bool();
                    break;
                case /* optional uint32 sample_rate */ 1:
                    message.sampleRate = reader.uint32();
                    break;
                case /* optional uint32 channel_count */ 2:
                    message.channelCount = reader.uint32();
                    break;
                case /* optional uint32 bits_per_channel */ 3:
                    message.bitsPerChannel = reader.uint32();
                    break;
                case /* optional pb.AudioMessage.Audio.AudioEncoding encoding */ 4:
                    message.encoding = reader.int32();
                    break;
                case /* optional uint32 sample_count */ 5:
                    message.sampleCount = reader.uint32();
                    break;
                case /* optional float volume */ 6:
                    message.volume = reader.float();
                    break;
                case /* optional bool vad_talking */ 8:
                    message.vadTalking = reader.bool();
                    break;
                case /* optional int64 recorded_at_ms */ 15:
                    message.recordedAtMs = reader.int64().toString();
                    break;
                case /* optional bytes audio_data */ 7:
                    message.audioData = reader.bytes();
                    break;
                case /* repeated pb.AudioMessage.Audio.AlignedEvent aligned_events */ 17:
                    message.alignedEvents.push(AudioMessage_Audio_AlignedEvent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Audio, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional uint32 sample_rate = 1; */
        if (message.sampleRate !== undefined)
            writer.tag(1, WireType.Varint).uint32(message.sampleRate);
        /* optional uint32 channel_count = 2; */
        if (message.channelCount !== undefined)
            writer.tag(2, WireType.Varint).uint32(message.channelCount);
        /* optional uint32 bits_per_channel = 3; */
        if (message.bitsPerChannel !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.bitsPerChannel);
        /* optional pb.AudioMessage.Audio.AudioEncoding encoding = 4; */
        if (message.encoding !== undefined)
            writer.tag(4, WireType.Varint).int32(message.encoding);
        /* optional uint32 sample_count = 5; */
        if (message.sampleCount !== undefined)
            writer.tag(5, WireType.Varint).uint32(message.sampleCount);
        /* optional float volume = 6; */
        if (message.volume !== undefined)
            writer.tag(6, WireType.Bit32).float(message.volume);
        /* optional bytes audio_data = 7; */
        if (message.audioData !== undefined)
            writer.tag(7, WireType.LengthDelimited).bytes(message.audioData);
        /* optional bool vad_talking = 8; */
        if (message.vadTalking !== undefined)
            writer.tag(8, WireType.Varint).bool(message.vadTalking);
        /* optional pb.AudioMessage.AvatarEmotion emotion = 9; */
        if (message.emotion !== undefined)
            writer.tag(9, WireType.Varint).int32(message.emotion);
        /* optional bool cluster_end = 10; */
        if (message.clusterEnd !== undefined)
            writer.tag(10, WireType.Varint).bool(message.clusterEnd);
        /* optional pb.AudioMessage.EarMode ear_mode = 11; */
        if (message.earMode !== undefined)
            writer.tag(11, WireType.Varint).int32(message.earMode);
        /* optional string msg_uid = 12; */
        if (message.msgUid !== undefined)
            writer.tag(12, WireType.LengthDelimited).string(message.msgUid);
        /* optional string transcript = 13; */
        if (message.transcript !== undefined)
            writer.tag(13, WireType.LengthDelimited).string(message.transcript);
        /* optional float hold_time = 14; */
        if (message.holdTime !== undefined)
            writer.tag(14, WireType.Bit32).float(message.holdTime);
        /* optional int64 recorded_at_ms = 15; */
        if (message.recordedAtMs !== undefined)
            writer.tag(15, WireType.Varint).int64(message.recordedAtMs);
        /* optional string speaker_uid = 16; */
        if (message.speakerUid !== undefined)
            writer.tag(16, WireType.LengthDelimited).string(message.speakerUid);
        /* repeated pb.AudioMessage.Audio.AlignedEvent aligned_events = 17; */
        for (let i = 0; i < message.alignedEvents.length; i++)
            AudioMessage_Audio_AlignedEvent.internalBinaryWrite(message.alignedEvents[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Audio
 */
export const AudioMessage_Audio = new AudioMessage_Audio$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Audio_AlignedEvent$Type extends MessageType<AudioMessage_Audio_AlignedEvent> {
    constructor() {
        super("pb.AudioMessage.Audio.AlignedEvent", [
            { no: 1, name: "type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Audio.AlignedEvent.Type", AudioMessage_Audio_AlignedEvent_Type] },
            { no: 2, name: "word", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "event_start_ms", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "event_duration_ms", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Audio_AlignedEvent>): AudioMessage_Audio_AlignedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Audio_AlignedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Audio_AlignedEvent): AudioMessage_Audio_AlignedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Audio.AlignedEvent.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* optional string word */ 2:
                    message.word = reader.string();
                    break;
                case /* optional int32 event_start_ms */ 3:
                    message.eventStartMs = reader.int32();
                    break;
                case /* optional int32 event_duration_ms */ 4:
                    message.eventDurationMs = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Audio_AlignedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Audio.AlignedEvent.Type type = 1; */
        if (message.type !== undefined)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* optional string word = 2; */
        if (message.word !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.word);
        /* optional int32 event_start_ms = 3; */
        if (message.eventStartMs !== undefined)
            writer.tag(3, WireType.Varint).int32(message.eventStartMs);
        /* optional int32 event_duration_ms = 4; */
        if (message.eventDurationMs !== undefined)
            writer.tag(4, WireType.Varint).int32(message.eventDurationMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Audio.AlignedEvent
 */
export const AudioMessage_Audio_AlignedEvent = new AudioMessage_Audio_AlignedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg$Type extends MessageType<AudioMessage_Msg> {
    constructor() {
        super("pb.AudioMessage.Msg", [
            { no: 2, name: "type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.Type", AudioMessage_Msg_Type] },
            { no: 3, name: "msg_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "client_msg_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "turn_first_msg_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "speaker_id", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.Speaker", AudioMessage_Msg_Speaker] },
            { no: 18, name: "speaker_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 9, name: "modality", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.Modality", AudioMessage_Msg_Modality] },
            { no: 7, name: "text", kind: "message", oneof: "payload", T: () => AudioMessage_Msg_MsgText },
            { no: 8, name: "media", kind: "message", oneof: "payload", T: () => AudioMessage_Msg_MsgMedia },
            { no: 15, name: "links", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_Msg_MsgLink },
            { no: 17, name: "buttons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_Msg_MsgButton },
            { no: 10, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_Msg_MsgAnnotation },
            { no: 11, name: "client_created_at", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 12, name: "client_max_delta_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 16, name: "suppress_user_changes", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg>): AudioMessage_Msg {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.payload = { oneofKind: undefined };
        message.links = [];
        message.buttons = [];
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg): AudioMessage_Msg {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Msg.Type type */ 2:
                    message.type = reader.int32();
                    break;
                case /* optional string msg_uid */ 3:
                    message.msgUid = reader.string();
                    break;
                case /* optional string client_msg_uid */ 4:
                    message.clientMsgUid = reader.string();
                    break;
                case /* optional string turn_first_msg_uid */ 14:
                    message.turnFirstMsgUid = reader.string();
                    break;
                case /* optional pb.AudioMessage.Msg.Speaker speaker_id */ 5:
                    message.speakerId = reader.int32();
                    break;
                case /* optional string speaker_uid */ 18:
                    message.speakerUid = reader.string();
                    break;
                case /* optional int64 created_at */ 6:
                    message.createdAt = reader.int64().toString();
                    break;
                case /* optional pb.AudioMessage.Msg.Modality modality */ 9:
                    message.modality = reader.int32();
                    break;
                case /* pb.AudioMessage.Msg.MsgText text */ 7:
                    message.payload = {
                        oneofKind: "text",
                        text: AudioMessage_Msg_MsgText.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).text)
                    };
                    break;
                case /* pb.AudioMessage.Msg.MsgMedia media */ 8:
                    message.payload = {
                        oneofKind: "media",
                        media: AudioMessage_Msg_MsgMedia.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).media)
                    };
                    break;
                case /* repeated pb.AudioMessage.Msg.MsgLink links */ 15:
                    message.links.push(AudioMessage_Msg_MsgLink.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated pb.AudioMessage.Msg.MsgButton buttons */ 17:
                    message.buttons.push(AudioMessage_Msg_MsgButton.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated pb.AudioMessage.Msg.MsgAnnotation annotations */ 10:
                    message.annotations.push(AudioMessage_Msg_MsgAnnotation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional int64 client_created_at */ 11:
                    message.clientCreatedAt = reader.int64().toString();
                    break;
                case /* optional int64 client_max_delta_id */ 12:
                    message.clientMaxDeltaId = reader.int64().toString();
                    break;
                case /* optional bool suppress_user_changes */ 16:
                    message.suppressUserChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Msg.Type type = 2; */
        if (message.type !== undefined)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* optional string msg_uid = 3; */
        if (message.msgUid !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.msgUid);
        /* optional string client_msg_uid = 4; */
        if (message.clientMsgUid !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.clientMsgUid);
        /* optional pb.AudioMessage.Msg.Speaker speaker_id = 5; */
        if (message.speakerId !== undefined)
            writer.tag(5, WireType.Varint).int32(message.speakerId);
        /* optional int64 created_at = 6; */
        if (message.createdAt !== undefined)
            writer.tag(6, WireType.Varint).int64(message.createdAt);
        /* pb.AudioMessage.Msg.MsgText text = 7; */
        if (message.payload.oneofKind === "text")
            AudioMessage_Msg_MsgText.internalBinaryWrite(message.payload.text, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.Msg.MsgMedia media = 8; */
        if (message.payload.oneofKind === "media")
            AudioMessage_Msg_MsgMedia.internalBinaryWrite(message.payload.media, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.Msg.Modality modality = 9; */
        if (message.modality !== undefined)
            writer.tag(9, WireType.Varint).int32(message.modality);
        /* repeated pb.AudioMessage.Msg.MsgAnnotation annotations = 10; */
        for (let i = 0; i < message.annotations.length; i++)
            AudioMessage_Msg_MsgAnnotation.internalBinaryWrite(message.annotations[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* optional int64 client_created_at = 11; */
        if (message.clientCreatedAt !== undefined)
            writer.tag(11, WireType.Varint).int64(message.clientCreatedAt);
        /* optional int64 client_max_delta_id = 12; */
        if (message.clientMaxDeltaId !== undefined)
            writer.tag(12, WireType.Varint).int64(message.clientMaxDeltaId);
        /* optional string turn_first_msg_uid = 14; */
        if (message.turnFirstMsgUid !== undefined)
            writer.tag(14, WireType.LengthDelimited).string(message.turnFirstMsgUid);
        /* repeated pb.AudioMessage.Msg.MsgLink links = 15; */
        for (let i = 0; i < message.links.length; i++)
            AudioMessage_Msg_MsgLink.internalBinaryWrite(message.links[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* optional bool suppress_user_changes = 16; */
        if (message.suppressUserChanges !== undefined)
            writer.tag(16, WireType.Varint).bool(message.suppressUserChanges);
        /* repeated pb.AudioMessage.Msg.MsgButton buttons = 17; */
        for (let i = 0; i < message.buttons.length; i++)
            AudioMessage_Msg_MsgButton.internalBinaryWrite(message.buttons[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* optional string speaker_uid = 18; */
        if (message.speakerUid !== undefined)
            writer.tag(18, WireType.LengthDelimited).string(message.speakerUid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg
 */
export const AudioMessage_Msg = new AudioMessage_Msg$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg_MsgText$Type extends MessageType<AudioMessage_Msg_MsgText> {
    constructor() {
        super("pb.AudioMessage.Msg.MsgText", [
            { no: 1, name: "payload", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg_MsgText>): AudioMessage_Msg_MsgText {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg_MsgText>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg_MsgText): AudioMessage_Msg_MsgText {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string payload */ 1:
                    message.payload = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg_MsgText, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string payload = 1; */
        if (message.payload !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.payload);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg.MsgText
 */
export const AudioMessage_Msg_MsgText = new AudioMessage_Msg_MsgText$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg_MsgMedia$Type extends MessageType<AudioMessage_Msg_MsgMedia> {
    constructor() {
        super("pb.AudioMessage.Msg.MsgMedia", [
            { no: 1, name: "media_path", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "path_type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.MsgMedia.PathType", AudioMessage_Msg_MsgMedia_PathType] },
            { no: 3, name: "content_type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "caption", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg_MsgMedia>): AudioMessage_Msg_MsgMedia {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg_MsgMedia>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg_MsgMedia): AudioMessage_Msg_MsgMedia {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string media_path */ 1:
                    message.mediaPath = reader.string();
                    break;
                case /* optional pb.AudioMessage.Msg.MsgMedia.PathType path_type */ 2:
                    message.pathType = reader.int32();
                    break;
                case /* optional string content_type */ 3:
                    message.contentType = reader.string();
                    break;
                case /* optional string caption */ 4:
                    message.caption = reader.string();
                    break;
                case /* optional string description */ 5:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg_MsgMedia, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string media_path = 1; */
        if (message.mediaPath !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.mediaPath);
        /* optional pb.AudioMessage.Msg.MsgMedia.PathType path_type = 2; */
        if (message.pathType !== undefined)
            writer.tag(2, WireType.Varint).int32(message.pathType);
        /* optional string content_type = 3; */
        if (message.contentType !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.contentType);
        /* optional string caption = 4; */
        if (message.caption !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.caption);
        /* optional string description = 5; */
        if (message.description !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg.MsgMedia
 */
export const AudioMessage_Msg_MsgMedia = new AudioMessage_Msg_MsgMedia$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg_MsgLink$Type extends MessageType<AudioMessage_Msg_MsgLink> {
    constructor() {
        super("pb.AudioMessage.Msg.MsgLink", [
            { no: 1, name: "link_type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.MsgLink.Type", AudioMessage_Msg_MsgLink_Type] },
            { no: 6, name: "icon_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "title", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "link_style", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.MsgLink.LinkStyle", AudioMessage_Msg_MsgLink_LinkStyle] },
            { no: 8, name: "requirement_check", kind: "message", T: () => AudioMessage_Msg_MsgLink_RequirementCheck }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg_MsgLink>): AudioMessage_Msg_MsgLink {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg_MsgLink>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg_MsgLink): AudioMessage_Msg_MsgLink {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Msg.MsgLink.Type link_type */ 1:
                    message.linkType = reader.int32();
                    break;
                case /* optional string icon_name */ 6:
                    message.iconName = reader.string();
                    break;
                case /* optional string title */ 3:
                    message.title = reader.string();
                    break;
                case /* optional string description */ 4:
                    message.description = reader.string();
                    break;
                case /* optional string url */ 5:
                    message.url = reader.string();
                    break;
                case /* optional pb.AudioMessage.Msg.MsgLink.LinkStyle link_style */ 7:
                    message.linkStyle = reader.int32();
                    break;
                case /* optional pb.AudioMessage.Msg.MsgLink.RequirementCheck requirement_check */ 8:
                    message.requirementCheck = AudioMessage_Msg_MsgLink_RequirementCheck.internalBinaryRead(reader, reader.uint32(), options, message.requirementCheck);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg_MsgLink, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Msg.MsgLink.Type link_type = 1; */
        if (message.linkType !== undefined)
            writer.tag(1, WireType.Varint).int32(message.linkType);
        /* optional string title = 3; */
        if (message.title !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.title);
        /* optional string description = 4; */
        if (message.description !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* optional string url = 5; */
        if (message.url !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.url);
        /* optional string icon_name = 6; */
        if (message.iconName !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.iconName);
        /* optional pb.AudioMessage.Msg.MsgLink.LinkStyle link_style = 7; */
        if (message.linkStyle !== undefined)
            writer.tag(7, WireType.Varint).int32(message.linkStyle);
        /* optional pb.AudioMessage.Msg.MsgLink.RequirementCheck requirement_check = 8; */
        if (message.requirementCheck)
            AudioMessage_Msg_MsgLink_RequirementCheck.internalBinaryWrite(message.requirementCheck, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg.MsgLink
 */
export const AudioMessage_Msg_MsgLink = new AudioMessage_Msg_MsgLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg_MsgLink_RequirementCheck$Type extends MessageType<AudioMessage_Msg_MsgLink_RequirementCheck> {
    constructor() {
        super("pb.AudioMessage.Msg.MsgLink.RequirementCheck", [
            { no: 1, name: "permission", kind: "enum", T: () => ["pb.AudioMessage.DevicePermissionType", AudioMessage_DevicePermissionType] },
            { no: 2, name: "check_yes_response", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "check_no_response", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg_MsgLink_RequirementCheck>): AudioMessage_Msg_MsgLink_RequirementCheck {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permission = 0;
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg_MsgLink_RequirementCheck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg_MsgLink_RequirementCheck): AudioMessage_Msg_MsgLink_RequirementCheck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* pb.AudioMessage.DevicePermissionType permission */ 1:
                    message.permission = reader.int32();
                    break;
                case /* optional string check_yes_response */ 2:
                    message.checkYesResponse = reader.string();
                    break;
                case /* optional string check_no_response */ 3:
                    message.checkNoResponse = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg_MsgLink_RequirementCheck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* pb.AudioMessage.DevicePermissionType permission = 1; */
        if (message.permission !== 0)
            writer.tag(1, WireType.Varint).int32(message.permission);
        /* optional string check_yes_response = 2; */
        if (message.checkYesResponse !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.checkYesResponse);
        /* optional string check_no_response = 3; */
        if (message.checkNoResponse !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.checkNoResponse);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg.MsgLink.RequirementCheck
 */
export const AudioMessage_Msg_MsgLink_RequirementCheck = new AudioMessage_Msg_MsgLink_RequirementCheck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg_MsgButton$Type extends MessageType<AudioMessage_Msg_MsgButton> {
    constructor() {
        super("pb.AudioMessage.Msg.MsgButton", [
            { no: 1, name: "button_type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.MsgButton.Type", AudioMessage_Msg_MsgButton_Type] },
            { no: 2, name: "button_text", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg_MsgButton>): AudioMessage_Msg_MsgButton {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg_MsgButton>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg_MsgButton): AudioMessage_Msg_MsgButton {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Msg.MsgButton.Type button_type */ 1:
                    message.buttonType = reader.int32();
                    break;
                case /* optional string button_text */ 2:
                    message.buttonText = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg_MsgButton, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Msg.MsgButton.Type button_type = 1; */
        if (message.buttonType !== undefined)
            writer.tag(1, WireType.Varint).int32(message.buttonType);
        /* optional string button_text = 2; */
        if (message.buttonText !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.buttonText);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg.MsgButton
 */
export const AudioMessage_Msg_MsgButton = new AudioMessage_Msg_MsgButton$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg_MsgAnnotation$Type extends MessageType<AudioMessage_Msg_MsgAnnotation> {
    constructor() {
        super("pb.AudioMessage.Msg.MsgAnnotation", [
            { no: 1, name: "category", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.MsgAnnotation.Category", AudioMessage_Msg_MsgAnnotation_Category] },
            { no: 2, name: "speaker_id", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.Speaker", AudioMessage_Msg_Speaker] },
            { no: 3, name: "timestamp", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "action", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.MsgAnnotation.Action", AudioMessage_Msg_MsgAnnotation_Action] },
            { no: 5, name: "reaction", kind: "message", oneof: "payload", T: () => AudioMessage_Msg_MsgAnnotation_Reaction },
            { no: 6, name: "feedback", kind: "message", oneof: "payload", T: () => AudioMessage_Msg_MsgAnnotation_Feedback },
            { no: 7, name: "violation", kind: "message", oneof: "payload", T: () => AudioMessage_Msg_MsgAnnotation_Violation }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg_MsgAnnotation>): AudioMessage_Msg_MsgAnnotation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.payload = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg_MsgAnnotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg_MsgAnnotation): AudioMessage_Msg_MsgAnnotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Msg.MsgAnnotation.Category category */ 1:
                    message.category = reader.int32();
                    break;
                case /* optional pb.AudioMessage.Msg.Speaker speaker_id */ 2:
                    message.speakerId = reader.int32();
                    break;
                case /* optional int64 timestamp */ 3:
                    message.timestamp = reader.int64().toString();
                    break;
                case /* optional pb.AudioMessage.Msg.MsgAnnotation.Action action */ 4:
                    message.action = reader.int32();
                    break;
                case /* pb.AudioMessage.Msg.MsgAnnotation.Reaction reaction */ 5:
                    message.payload = {
                        oneofKind: "reaction",
                        reaction: AudioMessage_Msg_MsgAnnotation_Reaction.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).reaction)
                    };
                    break;
                case /* pb.AudioMessage.Msg.MsgAnnotation.Feedback feedback */ 6:
                    message.payload = {
                        oneofKind: "feedback",
                        feedback: AudioMessage_Msg_MsgAnnotation_Feedback.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).feedback)
                    };
                    break;
                case /* pb.AudioMessage.Msg.MsgAnnotation.Violation violation */ 7:
                    message.payload = {
                        oneofKind: "violation",
                        violation: AudioMessage_Msg_MsgAnnotation_Violation.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).violation)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg_MsgAnnotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Msg.MsgAnnotation.Category category = 1; */
        if (message.category !== undefined)
            writer.tag(1, WireType.Varint).int32(message.category);
        /* optional pb.AudioMessage.Msg.Speaker speaker_id = 2; */
        if (message.speakerId !== undefined)
            writer.tag(2, WireType.Varint).int32(message.speakerId);
        /* optional int64 timestamp = 3; */
        if (message.timestamp !== undefined)
            writer.tag(3, WireType.Varint).int64(message.timestamp);
        /* optional pb.AudioMessage.Msg.MsgAnnotation.Action action = 4; */
        if (message.action !== undefined)
            writer.tag(4, WireType.Varint).int32(message.action);
        /* pb.AudioMessage.Msg.MsgAnnotation.Reaction reaction = 5; */
        if (message.payload.oneofKind === "reaction")
            AudioMessage_Msg_MsgAnnotation_Reaction.internalBinaryWrite(message.payload.reaction, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.Msg.MsgAnnotation.Feedback feedback = 6; */
        if (message.payload.oneofKind === "feedback")
            AudioMessage_Msg_MsgAnnotation_Feedback.internalBinaryWrite(message.payload.feedback, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.Msg.MsgAnnotation.Violation violation = 7; */
        if (message.payload.oneofKind === "violation")
            AudioMessage_Msg_MsgAnnotation_Violation.internalBinaryWrite(message.payload.violation, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg.MsgAnnotation
 */
export const AudioMessage_Msg_MsgAnnotation = new AudioMessage_Msg_MsgAnnotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg_MsgAnnotation_Reaction$Type extends MessageType<AudioMessage_Msg_MsgAnnotation_Reaction> {
    constructor() {
        super("pb.AudioMessage.Msg.MsgAnnotation.Reaction", [
            { no: 1, name: "value", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.MsgAnnotation.Reaction.ReactionValue", AudioMessage_Msg_MsgAnnotation_Reaction_ReactionValue] }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg_MsgAnnotation_Reaction>): AudioMessage_Msg_MsgAnnotation_Reaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg_MsgAnnotation_Reaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg_MsgAnnotation_Reaction): AudioMessage_Msg_MsgAnnotation_Reaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Msg.MsgAnnotation.Reaction.ReactionValue value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg_MsgAnnotation_Reaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Msg.MsgAnnotation.Reaction.ReactionValue value = 1; */
        if (message.value !== undefined)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg.MsgAnnotation.Reaction
 */
export const AudioMessage_Msg_MsgAnnotation_Reaction = new AudioMessage_Msg_MsgAnnotation_Reaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg_MsgAnnotation_Feedback$Type extends MessageType<AudioMessage_Msg_MsgAnnotation_Feedback> {
    constructor() {
        super("pb.AudioMessage.Msg.MsgAnnotation.Feedback", [
            { no: 1, name: "value", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.MsgAnnotation.Feedback.FeedbackValue", AudioMessage_Msg_MsgAnnotation_Feedback_FeedbackValue] }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg_MsgAnnotation_Feedback>): AudioMessage_Msg_MsgAnnotation_Feedback {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg_MsgAnnotation_Feedback>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg_MsgAnnotation_Feedback): AudioMessage_Msg_MsgAnnotation_Feedback {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Msg.MsgAnnotation.Feedback.FeedbackValue value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg_MsgAnnotation_Feedback, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Msg.MsgAnnotation.Feedback.FeedbackValue value = 1; */
        if (message.value !== undefined)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg.MsgAnnotation.Feedback
 */
export const AudioMessage_Msg_MsgAnnotation_Feedback = new AudioMessage_Msg_MsgAnnotation_Feedback$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Msg_MsgAnnotation_Violation$Type extends MessageType<AudioMessage_Msg_MsgAnnotation_Violation> {
    constructor() {
        super("pb.AudioMessage.Msg.MsgAnnotation.Violation", [
            { no: 1, name: "value", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Msg.MsgAnnotation.Violation.ViolationValue", AudioMessage_Msg_MsgAnnotation_Violation_ViolationValue] }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Msg_MsgAnnotation_Violation>): AudioMessage_Msg_MsgAnnotation_Violation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Msg_MsgAnnotation_Violation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Msg_MsgAnnotation_Violation): AudioMessage_Msg_MsgAnnotation_Violation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Msg.MsgAnnotation.Violation.ViolationValue value */ 1:
                    message.value = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Msg_MsgAnnotation_Violation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Msg.MsgAnnotation.Violation.ViolationValue value = 1; */
        if (message.value !== undefined)
            writer.tag(1, WireType.Varint).int32(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Msg.MsgAnnotation.Violation
 */
export const AudioMessage_Msg_MsgAnnotation_Violation = new AudioMessage_Msg_MsgAnnotation_Violation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_MsgDelta$Type extends MessageType<AudioMessage_MsgDelta> {
    constructor() {
        super("pb.AudioMessage.MsgDelta", [
            { no: 1, name: "delta_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.MsgDelta.Type", AudioMessage_MsgDelta_Type] },
            { no: 3, name: "message", kind: "message", oneof: "payload", T: () => AudioMessage_Msg }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_MsgDelta>): AudioMessage_MsgDelta {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.payload = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_MsgDelta>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_MsgDelta): AudioMessage_MsgDelta {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 delta_id */ 1:
                    message.deltaId = reader.int64().toString();
                    break;
                case /* optional pb.AudioMessage.MsgDelta.Type type */ 2:
                    message.type = reader.int32();
                    break;
                case /* pb.AudioMessage.Msg message */ 3:
                    message.payload = {
                        oneofKind: "message",
                        message: AudioMessage_Msg.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).message)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_MsgDelta, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int64 delta_id = 1; */
        if (message.deltaId !== undefined)
            writer.tag(1, WireType.Varint).int64(message.deltaId);
        /* optional pb.AudioMessage.MsgDelta.Type type = 2; */
        if (message.type !== undefined)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* pb.AudioMessage.Msg message = 3; */
        if (message.payload.oneofKind === "message")
            AudioMessage_Msg.internalBinaryWrite(message.payload.message, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.MsgDelta
 */
export const AudioMessage_MsgDelta = new AudioMessage_MsgDelta$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Command$Type extends MessageType<AudioMessage_Command> {
    constructor() {
        super("pb.AudioMessage.Command", [
            { no: 1, name: "type", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Command.Type", AudioMessage_Command_Type] },
            { no: 2, name: "basic", kind: "message", oneof: "payload", T: () => AudioMessage_Command_Basic },
            { no: 3, name: "msg", kind: "message", oneof: "payload", T: () => AudioMessage_Command_MsgWrap },
            { no: 4, name: "msg_range", kind: "message", oneof: "payload", T: () => AudioMessage_Command_MsgRange },
            { no: 5, name: "cluster_id_list", kind: "message", oneof: "payload", T: () => AudioMessage_Command_ClusterIDs },
            { no: 6, name: "cluster_status", kind: "message", oneof: "payload", T: () => AudioMessage_AudioClusterStatus },
            { no: 7, name: "feedback", kind: "message", oneof: "payload", T: () => AudioMessage_Command_FeedbackWrap },
            { no: 8, name: "system", kind: "message", oneof: "payload", T: () => AudioMessage_Command_SystemWrap },
            { no: 9, name: "target_user", kind: "message", oneof: "payload", T: () => AudioMessage_Command_TargetUser },
            { no: 10, name: "cluster_properties", kind: "message", oneof: "payload", T: () => AudioMessage_ClusterProperties }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Command>): AudioMessage_Command {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.payload = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Command>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Command): AudioMessage_Command {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Command.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* pb.AudioMessage.Command.Basic basic */ 2:
                    message.payload = {
                        oneofKind: "basic",
                        basic: AudioMessage_Command_Basic.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).basic)
                    };
                    break;
                case /* pb.AudioMessage.Command.MsgWrap msg */ 3:
                    message.payload = {
                        oneofKind: "msg",
                        msg: AudioMessage_Command_MsgWrap.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).msg)
                    };
                    break;
                case /* pb.AudioMessage.Command.MsgRange msg_range */ 4:
                    message.payload = {
                        oneofKind: "msgRange",
                        msgRange: AudioMessage_Command_MsgRange.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).msgRange)
                    };
                    break;
                case /* pb.AudioMessage.Command.ClusterIDs cluster_id_list */ 5:
                    message.payload = {
                        oneofKind: "clusterIdList",
                        clusterIdList: AudioMessage_Command_ClusterIDs.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).clusterIdList)
                    };
                    break;
                case /* pb.AudioMessage.AudioClusterStatus cluster_status */ 6:
                    message.payload = {
                        oneofKind: "clusterStatus",
                        clusterStatus: AudioMessage_AudioClusterStatus.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).clusterStatus)
                    };
                    break;
                case /* pb.AudioMessage.Command.FeedbackWrap feedback */ 7:
                    message.payload = {
                        oneofKind: "feedback",
                        feedback: AudioMessage_Command_FeedbackWrap.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).feedback)
                    };
                    break;
                case /* pb.AudioMessage.Command.SystemWrap system */ 8:
                    message.payload = {
                        oneofKind: "system",
                        system: AudioMessage_Command_SystemWrap.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).system)
                    };
                    break;
                case /* pb.AudioMessage.Command.TargetUser target_user */ 9:
                    message.payload = {
                        oneofKind: "targetUser",
                        targetUser: AudioMessage_Command_TargetUser.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).targetUser)
                    };
                    break;
                case /* pb.AudioMessage.ClusterProperties cluster_properties */ 10:
                    message.payload = {
                        oneofKind: "clusterProperties",
                        clusterProperties: AudioMessage_ClusterProperties.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).clusterProperties)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Command, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Command.Type type = 1; */
        if (message.type !== undefined)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* pb.AudioMessage.Command.Basic basic = 2; */
        if (message.payload.oneofKind === "basic")
            AudioMessage_Command_Basic.internalBinaryWrite(message.payload.basic, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.Command.MsgWrap msg = 3; */
        if (message.payload.oneofKind === "msg")
            AudioMessage_Command_MsgWrap.internalBinaryWrite(message.payload.msg, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.Command.MsgRange msg_range = 4; */
        if (message.payload.oneofKind === "msgRange")
            AudioMessage_Command_MsgRange.internalBinaryWrite(message.payload.msgRange, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.Command.ClusterIDs cluster_id_list = 5; */
        if (message.payload.oneofKind === "clusterIdList")
            AudioMessage_Command_ClusterIDs.internalBinaryWrite(message.payload.clusterIdList, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.AudioClusterStatus cluster_status = 6; */
        if (message.payload.oneofKind === "clusterStatus")
            AudioMessage_AudioClusterStatus.internalBinaryWrite(message.payload.clusterStatus, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.Command.FeedbackWrap feedback = 7; */
        if (message.payload.oneofKind === "feedback")
            AudioMessage_Command_FeedbackWrap.internalBinaryWrite(message.payload.feedback, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.Command.SystemWrap system = 8; */
        if (message.payload.oneofKind === "system")
            AudioMessage_Command_SystemWrap.internalBinaryWrite(message.payload.system, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.Command.TargetUser target_user = 9; */
        if (message.payload.oneofKind === "targetUser")
            AudioMessage_Command_TargetUser.internalBinaryWrite(message.payload.targetUser, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* pb.AudioMessage.ClusterProperties cluster_properties = 10; */
        if (message.payload.oneofKind === "clusterProperties")
            AudioMessage_ClusterProperties.internalBinaryWrite(message.payload.clusterProperties, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Command
 */
export const AudioMessage_Command = new AudioMessage_Command$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Command_Feedback$Type extends MessageType<AudioMessage_Command_Feedback> {
    constructor() {
        super("pb.AudioMessage.Command.Feedback", [
            { no: 1, name: "msg_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_msg_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "comment", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tags", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["pb.AudioMessage.Command.Feedback.Tag", AudioMessage_Command_Feedback_Tag] }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Command_Feedback>): AudioMessage_Command_Feedback {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tags = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Command_Feedback>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Command_Feedback): AudioMessage_Command_Feedback {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string msg_uid */ 1:
                    message.msgUid = reader.string();
                    break;
                case /* optional string client_msg_uid */ 2:
                    message.clientMsgUid = reader.string();
                    break;
                case /* optional string comment */ 3:
                    message.comment = reader.string();
                    break;
                case /* repeated pb.AudioMessage.Command.Feedback.Tag tags */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.tags.push(reader.int32());
                    else
                        message.tags.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Command_Feedback, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string msg_uid = 1; */
        if (message.msgUid !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.msgUid);
        /* optional string client_msg_uid = 2; */
        if (message.clientMsgUid !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.clientMsgUid);
        /* optional string comment = 3; */
        if (message.comment !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.comment);
        /* repeated pb.AudioMessage.Command.Feedback.Tag tags = 4; */
        if (message.tags.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.tags.length; i++)
                writer.int32(message.tags[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Command.Feedback
 */
export const AudioMessage_Command_Feedback = new AudioMessage_Command_Feedback$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Command_Basic$Type extends MessageType<AudioMessage_Command_Basic> {
    constructor() {
        super("pb.AudioMessage.Command.Basic", [
            { no: 1, name: "payload", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Command_Basic>): AudioMessage_Command_Basic {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Command_Basic>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Command_Basic): AudioMessage_Command_Basic {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string payload */ 1:
                    message.payload = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Command_Basic, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string payload = 1; */
        if (message.payload !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.payload);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Command.Basic
 */
export const AudioMessage_Command_Basic = new AudioMessage_Command_Basic$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Command_ClusterIDs$Type extends MessageType<AudioMessage_Command_ClusterIDs> {
    constructor() {
        super("pb.AudioMessage.Command.ClusterIDs", [
            { no: 2, name: "clusters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_AudioClusterStatus }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Command_ClusterIDs>): AudioMessage_Command_ClusterIDs {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clusters = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Command_ClusterIDs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Command_ClusterIDs): AudioMessage_Command_ClusterIDs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated pb.AudioMessage.AudioClusterStatus clusters */ 2:
                    message.clusters.push(AudioMessage_AudioClusterStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Command_ClusterIDs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated pb.AudioMessage.AudioClusterStatus clusters = 2; */
        for (let i = 0; i < message.clusters.length; i++)
            AudioMessage_AudioClusterStatus.internalBinaryWrite(message.clusters[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Command.ClusterIDs
 */
export const AudioMessage_Command_ClusterIDs = new AudioMessage_Command_ClusterIDs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Command_MsgWrap$Type extends MessageType<AudioMessage_Command_MsgWrap> {
    constructor() {
        super("pb.AudioMessage.Command.MsgWrap", [
            { no: 1, name: "message", kind: "message", T: () => AudioMessage_Msg },
            { no: 2, name: "request_status", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Command.MsgWrap.Status", AudioMessage_Command_MsgWrap_Status] },
            { no: 3, name: "request_client_msg_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "msg_seq_id", kind: "scalar", T: 4 /*ScalarType.UINT64*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Command_MsgWrap>): AudioMessage_Command_MsgWrap {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.msgSeqId = "0";
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Command_MsgWrap>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Command_MsgWrap): AudioMessage_Command_MsgWrap {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Msg message */ 1:
                    message.message = AudioMessage_Msg.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                case /* optional pb.AudioMessage.Command.MsgWrap.Status request_status */ 2:
                    message.requestStatus = reader.int32();
                    break;
                case /* optional string request_client_msg_uid */ 3:
                    message.requestClientMsgUid = reader.string();
                    break;
                case /* uint64 msg_seq_id */ 4:
                    message.msgSeqId = reader.uint64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Command_MsgWrap, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Msg message = 1; */
        if (message.message)
            AudioMessage_Msg.internalBinaryWrite(message.message, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional pb.AudioMessage.Command.MsgWrap.Status request_status = 2; */
        if (message.requestStatus !== undefined)
            writer.tag(2, WireType.Varint).int32(message.requestStatus);
        /* optional string request_client_msg_uid = 3; */
        if (message.requestClientMsgUid !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.requestClientMsgUid);
        /* uint64 msg_seq_id = 4; */
        if (message.msgSeqId !== "0")
            writer.tag(4, WireType.Varint).uint64(message.msgSeqId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Command.MsgWrap
 */
export const AudioMessage_Command_MsgWrap = new AudioMessage_Command_MsgWrap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Command_FeedbackWrap$Type extends MessageType<AudioMessage_Command_FeedbackWrap> {
    constructor() {
        super("pb.AudioMessage.Command.FeedbackWrap", [
            { no: 1, name: "feedback", kind: "message", T: () => AudioMessage_Command_Feedback }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Command_FeedbackWrap>): AudioMessage_Command_FeedbackWrap {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Command_FeedbackWrap>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Command_FeedbackWrap): AudioMessage_Command_FeedbackWrap {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional pb.AudioMessage.Command.Feedback feedback */ 1:
                    message.feedback = AudioMessage_Command_Feedback.internalBinaryRead(reader, reader.uint32(), options, message.feedback);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Command_FeedbackWrap, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional pb.AudioMessage.Command.Feedback feedback = 1; */
        if (message.feedback)
            AudioMessage_Command_Feedback.internalBinaryWrite(message.feedback, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Command.FeedbackWrap
 */
export const AudioMessage_Command_FeedbackWrap = new AudioMessage_Command_FeedbackWrap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Command_SystemWrap$Type extends MessageType<AudioMessage_Command_SystemWrap> {
    constructor() {
        super("pb.AudioMessage.Command.SystemWrap", [
            { no: 1, name: "message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sys_comm", kind: "enum", opt: true, T: () => ["pb.AudioMessage.Command.SystemWrap.SysComm", AudioMessage_Command_SystemWrap_SysComm] },
            { no: 4, name: "icon_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Command_SystemWrap>): AudioMessage_Command_SystemWrap {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Command_SystemWrap>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Command_SystemWrap): AudioMessage_Command_SystemWrap {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string message */ 1:
                    message.message = reader.string();
                    break;
                case /* optional pb.AudioMessage.Command.SystemWrap.SysComm sys_comm */ 2:
                    message.sysComm = reader.int32();
                    break;
                case /* optional string icon_name */ 4:
                    message.iconName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Command_SystemWrap, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string message = 1; */
        if (message.message !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.message);
        /* optional pb.AudioMessage.Command.SystemWrap.SysComm sys_comm = 2; */
        if (message.sysComm !== undefined)
            writer.tag(2, WireType.Varint).int32(message.sysComm);
        /* optional string icon_name = 4; */
        if (message.iconName !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.iconName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Command.SystemWrap
 */
export const AudioMessage_Command_SystemWrap = new AudioMessage_Command_SystemWrap$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Command_MsgRange$Type extends MessageType<AudioMessage_Command_MsgRange> {
    constructor() {
        super("pb.AudioMessage.Command.MsgRange", [
            { no: 1, name: "prev_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "next_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "older_than", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "newer_than", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "msg_uid", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "session_id", kind: "scalar", opt: true, T: 4 /*ScalarType.UINT64*/ },
            { no: 8, name: "preferred_count", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Command_MsgRange>): AudioMessage_Command_MsgRange {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Command_MsgRange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Command_MsgRange): AudioMessage_Command_MsgRange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string prev_token */ 1:
                    message.prevToken = reader.string();
                    break;
                case /* optional string token */ 2:
                    message.token = reader.string();
                    break;
                case /* optional string next_token */ 3:
                    message.nextToken = reader.string();
                    break;
                case /* optional int64 older_than */ 4:
                    message.olderThan = reader.int64().toString();
                    break;
                case /* optional int64 newer_than */ 5:
                    message.newerThan = reader.int64().toString();
                    break;
                case /* optional string msg_uid */ 6:
                    message.msgUid = reader.string();
                    break;
                case /* optional uint64 session_id */ 7:
                    message.sessionId = reader.uint64().toString();
                    break;
                case /* optional int32 preferred_count */ 8:
                    message.preferredCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Command_MsgRange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string prev_token = 1; */
        if (message.prevToken !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.prevToken);
        /* optional string token = 2; */
        if (message.token !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.token);
        /* optional string next_token = 3; */
        if (message.nextToken !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.nextToken);
        /* optional int64 older_than = 4; */
        if (message.olderThan !== undefined)
            writer.tag(4, WireType.Varint).int64(message.olderThan);
        /* optional int64 newer_than = 5; */
        if (message.newerThan !== undefined)
            writer.tag(5, WireType.Varint).int64(message.newerThan);
        /* optional string msg_uid = 6; */
        if (message.msgUid !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.msgUid);
        /* optional uint64 session_id = 7; */
        if (message.sessionId !== undefined)
            writer.tag(7, WireType.Varint).uint64(message.sessionId);
        /* optional int32 preferred_count = 8; */
        if (message.preferredCount !== undefined)
            writer.tag(8, WireType.Varint).int32(message.preferredCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Command.MsgRange
 */
export const AudioMessage_Command_MsgRange = new AudioMessage_Command_MsgRange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_Command_TargetUser$Type extends MessageType<AudioMessage_Command_TargetUser> {
    constructor() {
        super("pb.AudioMessage.Command.TargetUser", [
            { no: 1, name: "user_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_Command_TargetUser>): AudioMessage_Command_TargetUser {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_Command_TargetUser>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_Command_TargetUser): AudioMessage_Command_TargetUser {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string user_id */ 1:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_Command_TargetUser, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string user_id = 1; */
        if (message.userId !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.Command.TargetUser
 */
export const AudioMessage_Command_TargetUser = new AudioMessage_Command_TargetUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_MsgBlock$Type extends MessageType<AudioMessage_MsgBlock> {
    constructor() {
        super("pb.AudioMessage.MsgBlock", [
            { no: 1, name: "min_delta_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "prev_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "next_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "start_timestamp", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "end_timestamp", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "messages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_Msg }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_MsgBlock>): AudioMessage_MsgBlock {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.messages = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_MsgBlock>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_MsgBlock): AudioMessage_MsgBlock {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 min_delta_id */ 1:
                    message.minDeltaId = reader.int64().toString();
                    break;
                case /* optional string prev_token */ 2:
                    message.prevToken = reader.string();
                    break;
                case /* optional string token */ 3:
                    message.token = reader.string();
                    break;
                case /* optional string next_token */ 4:
                    message.nextToken = reader.string();
                    break;
                case /* optional int64 start_timestamp */ 5:
                    message.startTimestamp = reader.int64().toString();
                    break;
                case /* optional int64 end_timestamp */ 6:
                    message.endTimestamp = reader.int64().toString();
                    break;
                case /* repeated pb.AudioMessage.Msg messages */ 7:
                    message.messages.push(AudioMessage_Msg.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_MsgBlock, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int64 min_delta_id = 1; */
        if (message.minDeltaId !== undefined)
            writer.tag(1, WireType.Varint).int64(message.minDeltaId);
        /* optional string prev_token = 2; */
        if (message.prevToken !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.prevToken);
        /* optional string token = 3; */
        if (message.token !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.token);
        /* optional string next_token = 4; */
        if (message.nextToken !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.nextToken);
        /* optional int64 start_timestamp = 5; */
        if (message.startTimestamp !== undefined)
            writer.tag(5, WireType.Varint).int64(message.startTimestamp);
        /* optional int64 end_timestamp = 6; */
        if (message.endTimestamp !== undefined)
            writer.tag(6, WireType.Varint).int64(message.endTimestamp);
        /* repeated pb.AudioMessage.Msg messages = 7; */
        for (let i = 0; i < message.messages.length; i++)
            AudioMessage_Msg.internalBinaryWrite(message.messages[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.MsgBlock
 */
export const AudioMessage_MsgBlock = new AudioMessage_MsgBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AudioMessage_MsgDeltaBlock$Type extends MessageType<AudioMessage_MsgDeltaBlock> {
    constructor() {
        super("pb.AudioMessage.MsgDeltaBlock", [
            { no: 1, name: "max_delta_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 10, name: "msg_version", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "server_max_delta_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "created_delta_id", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "session_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "session_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "session_prev_token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "start_timestamp", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 8, name: "force_reset", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "msg_deltas", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AudioMessage_MsgDelta }
        ]);
    }
    create(value?: PartialMessage<AudioMessage_MsgDeltaBlock>): AudioMessage_MsgDeltaBlock {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.msgDeltas = [];
        if (value !== undefined)
            reflectionMergePartial<AudioMessage_MsgDeltaBlock>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AudioMessage_MsgDeltaBlock): AudioMessage_MsgDeltaBlock {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int64 max_delta_id */ 1:
                    message.maxDeltaId = reader.int64().toString();
                    break;
                case /* optional uint32 msg_version */ 10:
                    message.msgVersion = reader.uint32();
                    break;
                case /* optional int64 server_max_delta_id */ 2:
                    message.serverMaxDeltaId = reader.int64().toString();
                    break;
                case /* optional int64 created_delta_id */ 3:
                    message.createdDeltaId = reader.int64().toString();
                    break;
                case /* optional string session_id */ 4:
                    message.sessionId = reader.string();
                    break;
                case /* optional string session_token */ 5:
                    message.sessionToken = reader.string();
                    break;
                case /* optional string session_prev_token */ 6:
                    message.sessionPrevToken = reader.string();
                    break;
                case /* optional int64 start_timestamp */ 7:
                    message.startTimestamp = reader.int64().toString();
                    break;
                case /* optional bool force_reset */ 8:
                    message.forceReset = reader.bool();
                    break;
                case /* repeated pb.AudioMessage.MsgDelta msg_deltas */ 9:
                    message.msgDeltas.push(AudioMessage_MsgDelta.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AudioMessage_MsgDeltaBlock, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int64 max_delta_id = 1; */
        if (message.maxDeltaId !== undefined)
            writer.tag(1, WireType.Varint).int64(message.maxDeltaId);
        /* optional int64 server_max_delta_id = 2; */
        if (message.serverMaxDeltaId !== undefined)
            writer.tag(2, WireType.Varint).int64(message.serverMaxDeltaId);
        /* optional int64 created_delta_id = 3; */
        if (message.createdDeltaId !== undefined)
            writer.tag(3, WireType.Varint).int64(message.createdDeltaId);
        /* optional string session_id = 4; */
        if (message.sessionId !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.sessionId);
        /* optional string session_token = 5; */
        if (message.sessionToken !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.sessionToken);
        /* optional string session_prev_token = 6; */
        if (message.sessionPrevToken !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.sessionPrevToken);
        /* optional int64 start_timestamp = 7; */
        if (message.startTimestamp !== undefined)
            writer.tag(7, WireType.Varint).int64(message.startTimestamp);
        /* optional bool force_reset = 8; */
        if (message.forceReset !== undefined)
            writer.tag(8, WireType.Varint).bool(message.forceReset);
        /* repeated pb.AudioMessage.MsgDelta msg_deltas = 9; */
        for (let i = 0; i < message.msgDeltas.length; i++)
            AudioMessage_MsgDelta.internalBinaryWrite(message.msgDeltas[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* optional uint32 msg_version = 10; */
        if (message.msgVersion !== undefined)
            writer.tag(10, WireType.Varint).uint32(message.msgVersion);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message pb.AudioMessage.MsgDeltaBlock
 */
export const AudioMessage_MsgDeltaBlock = new AudioMessage_MsgDeltaBlock$Type();
